export const japanese = () => {
    return {
        dashboard: 'ダッシュボード',
        cms_dashboard: 'cms',
        content_dashboard: '内容',
        sales_dashboard: '販売',
        booking_status_dashboard: '予約状況',
        booking_summary_dashboard: '予約概要',
        contract_menu: '契約書',
        contract_sub_menu: '契約書',
        media_management_menu: 'メディア管理',
        media_others_menu: 'その他',
        series_sub_menu: '親シリーズ',
        season_sub_menu: 'シリーズ',
        episode_sub_menu: '独立したエピソード',
        program_sub_menu: 'プログラム',
        movie_sub_menu: '映画',
        trailer_sub_menu: 'トレーラー',
        interstitial_sub_menu: 'インタースティシャル',
        commercial_sub_menu: 'コマーシャル',
        filler_sub_menu: 'フィラー',
        music_sub_menu: '音楽',
        break_sub_menu: '休憩',
        media_episode_group_sub_menu: 'メディアエピソードグループ',
        planning_menu: '企画',
        planning_sub_menu: '企画',
        formats_sub_menu: 'フォーマット',
        program_schedule_clash_sub_menu: 'プログラムスケジュールの衝突',
        scheduling_menu: 'スケジュール設定',
        curate_menu: 'キュレート',
        timeline_sub_menu: 'タイムライン',
        timeline_linear_sub_menu: '直線的なタイムライン',
        series_timeline_sub_menu: 'シリーズタイムライン',
        rails_sub_menu: 'レール',
        pages_sub_menu: 'ページ',
        assets_sub_menu: '資産',
        tv_preview_sub_menu: 'テレビのプレビュー',
        web_preview_sub_menu: 'ウェブプレビュー',
        mobile_preview_sub_menu: 'モバイルプレビュー',
        ingestion_menu: '摂取',
        posters_sub_menu: 'ポスター',
        ingestion_template_sub_menu: 'インジェストテンプレート',
        partner_ingestion_sub_menu: 'パートナーの取り込み',
        jobs_sub_menu: '求人',
        sales_menu: '販売',
        agency_sub_menu: '代理店',
        client_sub_menu: 'クライアント',
        campaign_sub_menu: 'キャンペーン',
        booking_sub_menu: '予約',
        booking_transfer_sub_menu: '予約転送',
        update_booking_line_number_sub_menu: '予約明細番号を更新する',
        sales_team_sub_menu: '営業チーム',
        sales_executive_sub_menu: '営業担当役員',
        reconciliation_menu: '和解',
        as_run_reconciliation_sub_menu: '実行時の調整',
        import_planning_sub_menu: '輸入計画',
        import_asRun_sub_menu: '実行時にインポート',
        manage_asRun_sub_menu: '実行時の管理',
        export_menu: 'Export',
        epg_sub_menu: 'EPG',
        epg_template_sub_menu: 'EPG テンプレート',
        secondary_event_menu: '二次イベント',
        prototype_sub_menu: 'プロトタイプ',
        styleSheet_sub_menu: 'スタイルシート',
        default_prototype_sub_menu: 'デフォルトのプロトタイプ',
        protoType_source_sub_menu: 'プロトタイプソース',
        secondary_event_dynamic_rule_sub_menu: 'SecondaryEvent 動的ルール',
        billing_menu: '請求',
        billing_sub_menu: '請求',
        generated_bills_sub_menu: '生成された請求書',
        masters_menu: 'マスターズ',
        master_menu_title: 'マスター',
        language_sub_menu: '言語',
        content_sub_menu: '内容',
        assets_type_sub_menu: '資産の種類',
        rails_type_sub_menu: 'レールの種類',
        posters_type_sub_menu: "ポスターの種類",
        users_sub_menu: 'ユーザー',
        department_sub_menu: '部門',
        role_sub_menu: '役割',
        content_category_sub_menu: 'コンテンツカテゴリ',
        region_sub_menu: '地域',
        brand_sub_menu: 'ブランド',
        product_sub_menu: '製品',
        bank_account_sub_menu: '銀行口座',
        tax_sub_menu: '税金',
        licensor_sub_menu: 'ライセンサー',
        channel_sub_menu: 'チャンネル',
        currency_sub_menu: '通貨',
        time_range_sub_menu: '時間範囲',
        repeat_pattern_sub_menu: 'リピートパターン',
        invoice_content_sub_menu: '請求書の内容',
        segemnt_type_sub_menu: 'セグメントタイプ',
        variation_sub_menu: 'バリエーション',
        break_format_sub_menu: 'ブレークフォーマット',
        payment_provider_sub_menu: '決済プロバイダー',
        ott_period_type_sub_menu: 'オット期タイプ',
        payment_type_sub_menu: '支払いタイプ',
        schedule_constraints_sub_menu: 'スケジュールの制約',
        monetization_menu: '収益化',
        ott_period_sub_menu: '期間',
        subscriber_sub_menu: '購読者',
        ott_campaign_sub_menu: 'キャンペーン',
        coupon_sub_menu: 'クーポン',
        data_migration_menu: 'データ移行',
        form_fields_menu: 'フォームフィールド',
        save_button_tooltip: '保存',
        save_button_text: '保存',
        back_button_tooltip: '戻る',
        add_button_tooltip: '追加',
        add_button_text: '追加',
        add_multiple_button_text: '複数追加',
        add_dialog_header: '追加',
        new_button_dialog_header: '新しい',
        new_title_editpageheader: '新しい',
        edit_button_tooltip: '編集',
        update_button_tooltip: 'アップデート',
        remove_button_tooltip: '削除する',
        delete_button_tooltip: '削除',
        select_button_tooltip: '選択',
        select_button_text: '選択',
        cancel_button_tooltip: 'キャンセル',
        cancel_button_text: 'キャンセル',
        preference_button_tooltip: '好み',
        options: 'オプション',
        refresh_button_tooltip: 'リフレッシュ',
        archive: 'アーカイブ',
        ExportBreaksOnly: 'ブレークのみをエクスポート',
        loading_pleasewait: '読み込み中ですしばらくお待ちください...',
        no_records_found: '記録が見つかりません!!',
        contract_number_label: '契約番号',
        platform_type_label: 'プラットフォームの種類',
        licensor_label: 'ライセンサー',
        payee_label: '受取人',
        start_date_label: '開始日',
        end_Date_label: '終了日',
        channel_label: 'チャンネル',
        platform_label: 'プラットフォーム',
        region_label: '地域',
        exhibition_label: '展示会',
        repeat_label: 'リピート',
        play_time_number_label: '再生時間数',
        playTime_label: 'プレイタイム',
        is_unlimited_label: '無制限',
        add_media_episode_button_tooltip: 'メディアエピソードを追加',
        remove_media_episode_button_tooltip: 'メディアエピソードを削除',
        assetId_column: 'アセットID',
        title_column: 'タイトル',
        media_category_column: 'メディア部門',
        start_date_column: '開始日',
        end_date_column: '終了日',
        is_unlimited_column: '無制限です',
        exhibition_column: '展示会',
        repeat_column: 'リピート',
        play_time_number_column: '再生時間番号',
        playTime_column: 'プレイタイム',
        media_library_dialog_header: 'メディアライブラリ',
        summary: '概要',
        create_series_dialog_header: '親シリーズの作成',
        content_label: '内容',
        asset_id_label: 'アセットID',
        description_label: '説明',
        synopsis_label: 'あらすじ',
        islive_label: 'ライブ',
        alwaysLive_label: '常にライブ',
        seasons_title: 'シリーズ',
        series_cardlist_header: 'シリーズ',
        season_cardlist_header: 'エピソード',
        sidefix_season_tooltip: '季節',
        s_content_label: 'S. 内容',
        season_no_label: 'シーズンNo.',
        ep_content_label: 'エピソード内容',
        episodes_label: 'エピソード',
        no_of_episodes_label: '話数',
        duration_label: '継続時間 (hh:mm:ss:ff)',
        playlist_duration_label: '継続時間 (hh:mm:ss)',
        total_block_duration_label: '合計ブロック期間 (hh:mm:ss:ff)',
        season_number_column: 'シーズン番号',
        no_of_episodes_column: 'エピソード数',
        season_content_column: 'シーズンコンテンツ',
        episode_content_column: 'エピソードの内容',
        duration_column: '期間',
        timerangefrom_column: 'から',
        timerangeto_column: 'に',
        select_image_collection_header: '画像の選択',
        description_column: '説明',
        meta_data_label: 'メタデータ',
        posters_label: 'ポスター',
        publishing_label: '出版',
        search_by_title: 'タイトルで検索',
        genre_label: 'ジャンル',
        language_label: '言語',
        pg_rating_label: 'PG 評価',
        keywords_label: 'キーワード',
        add_poster_button_tooltip: 'ポスターを追加',
        poster_type_column: 'ポスターの種類',
        edit_poster_dialog_header: 'ポスターの編集',
        poster_type_label: 'ポスターの種類',
        url_label: 'URL',
        select_url_tooltip: 'URLを選択してください',
        add_publishing_button_tooltip: '公開の追加',
        unlimited_rights_grid: '無制限の権利',
        tba_label: '未定',
        tba_column: '未定',
        publishing_dialog_header: '出版',
        platform_type_column: 'プラットフォームの種類',
        channel_column: 'チャンネル',
        source_column: 'ソース',
        enter_title: 'タイトルを入力してください',
        create_season_dialog_header: 'シリーズの作成',
        season_number_label: 'シーズン番号',
        series_label: '親シリーズ',
        starting_episode_label: '始まりのエピソード',
        select_series_collection_header: '親シリーズの選択',
        video_label: 'ビデオ',
        videos_label: '動画',
        add_video_button_tooltip: 'ビデオを追加',
        video_type_column: 'ビデオの種類',
        video_type_label: 'ビデオの種類',
        url_column: 'URL',
        edit_video_dialog_header: 'ビデオを編集する',
        create_video_dialog_header: 'ビデオの作成',
        episode_title_label: 'エピソードのタイトル',
        episode_number_label: 'エピソード番号',
        season_number_labelshort: "SnNo.",
        episode_number_labelshort: 'エピソード番号',
        release_date_label: '発売日',
        version_label: 'バージョン',
        content_category_label: 'コンテンツカテゴリ',
        format_label: 'フォーマット',
        cast_and_crew_label: 'キャストとスタッフ',
        dynamic_fields_label: '動的フィールド',
        censor_rating_label: '検閲評価',
        technical_prototype_label: '技術プロトタイプ',
        production_year_label: '製造年',
        language_column: '言語',
        synopsis_column: 'あらすじ',
        cast_column: 'キャスト',
        name_column: '名前',
        name_label: '名前',
        cast_type_label: 'キャストタイプ',
        segment_type_column: 'タイプ',
        material_id_column: 'マテリアルID',
        actual_duration_column: '実際の継続時間',
        is_default_column: 'デフォルト',
        is_hard_parted_column: '別れは難しい',
        edit_version_dialog_header: 'バージョンの編集',
        create_version_dialog_header: 'バージョンの作成',
        segment_type_label: 'セグメントタイプ',
        material_id_label: 'マテリアルID',
        is_hard_parted_label: '別れは難しい',
        is_default_label: 'デフォルト',
        generate_segments_button_text: 'セグメントの生成',
        auto_distribute_button_text: '自動配信',
        sequence_column: 'シーケンス',
        media_id_column: 'メディアID',
        start_time_column: '開始時間',
        end_time_column: '終了時間',
        previewed_column: 'プレビュー済み',
        parent_content_category_column: '親コンテンツのカテゴリ',
        select_format_collection: 'フォーマットの選択',
        select_content_category_collection_header: 'コンテンツカテゴリの選択',
        manual_assetid_label: 'マニュアルアセットID',
        media_category_label: 'メディア部門',
        media_category_type_label: 'メディア カテゴリ タイプ',
        media_sub_category_type_label: 'メディアサブカテゴリータイプ',
        tc_in_label: 'Tc 入力 (hh:mm:ss:ff)',
        tc_out_label: 'Tc アウト (hh:mm:ss:ff)',
        media_episode_group_dialog_header: 'メディア エピソード グループの作成',
        program_group_dialog_header: 'プログラムグループの作成',
        interstital_group_dialog_header: 'インタースティシャルグループの作成',
        media_category_type_column: 'メディア カテゴリ タイプ',
        media_category_type_collection_header: 'メディア カテゴリ タイプ',
        episode_dialog_header: 'エピソード',
        sidefixmenu_rails_asset_tooltip: '資産',
        cardlist_rails_title: '資産',
        cardlist_rails_assets_title: 'アセットライブラリ',
        rails_title_editpageheader: 'レール',
        display_title_label: '表示タイトル',
        rails_type_label: 'タイプ',
        rails_note_label: '注: ユーザーは選択できます',
        publish_label: '発行する',
        published_label: '発行済み',
        unpublished_label: '未公開',
        rails_p_label: 'P',
        rails_up_label: '上へ',
        ott_assets_collection_header: 'オット・アセット',
        options_actionbutton_menutext: 'オプション',
        delete_actionbutton_option: '削除',
        moveup_actionbutton_option: '上に移動',
        movedown_actionbutton_option: '下に移動',
        sidefixmenu_rails_tooltip: 'レール',
        cardlist_page_rails_title: 'レール',
        cardlist_rails_page_title: '鉄道ライブラリ',
        theme_label: 'テーマ',
        icon_url_label: 'アイコンのURL',
        please_fill_out_details_label: 'このフィールドに記入してください。',
        assets_dialog_header: 'アセットの作成',
        validation: '値を選択してください',
        asset_type_label: '資産タイプ',
        portrait_image_url_label: 'ポートレート画像の URL',
        landscape_image_url_label: '横長画像のURL',
        video_playback_url_label: '動画再生URL',
        select_portal_image_url_collection_header: 'ポートレート画像の URL を選択してください',
        select_landscape_image_url_collection_header: '横長画像の URL を選択',
        create_poster_dialog_header: 'ポスターの作成',
        image_url_label: '画像のURL',
        file_path_label: 'ファイルパス',
        poster_note_label: '注: 画像は保存時にアップロードされ、URL が割り当てられます',
        template_name_label: 'テンプレート名',
        module_type_label: 'モジュールの種類',
        ingestion_template_type_label: 'インジェストテンプレートのタイプ',
        save_template_text: 'テンプレートの保存',
        send_text: '送信',
        send_button_tooltip: '送信',
        body_label: '本体',
        response_label: '応答',
        select_file_label: 'ファイルの選択',
        load_button_text: 'ロード',
        ingestion_template_note_label: '保存中に最初のパラメータ値を searchtext に置き換えます',
        key_column: 'キー',
        value_column: '値',
        key_label: 'キー',
        value_label: '値',
        template_details_label: 'テンプレートの詳細',
        template_label: 'テンプレート',
        search_title_label: 'タイトル検索',
        ingest_button_text: '摂取する',
        ingest_button_tooltip: '摂取する',
        load_button_tooltip: 'ロード',
        ingestion_details_label: '取り込みの詳細',
        pg_rating_column: 'PGR評価',
        genres_column: 'ジャンル',
        show_response_label: '応答を表示',
        response_dialog_header: '応答',
        eye_tooltip: '目',
        agency_dialog_header: '代理店の作成',
        code_label: 'コード',
        address_label: '住所',
        pincode_label: 'ピンコード',
        email_label: '電子メール',
        credit_limit_label: '与信限度額',
        pan_label: 'パン',
        gst_number_label: 'GST番号',
        default_tax_label: 'デフォルト税',
        is_credit_unlimited_label: '無制限のクレジット',
        client_dialog_header: 'クライアントの作成',
        agency_label: '代理店',
        campaign_number_label: 'キャンペーン番号',
        order_date_label: '注文日 *',
        period_from_label: 'から',
        period_to_label: 'に',
        campaign_type_label: 'タイプ',
        deal_type_label: '取引タイプ',
        client_label: 'クライアント',
        location_label: '場所',
        product_label: '製品',
        commission_label: '手数料',
        target_budget_label: '目標予算',
        target_spots_label: '対象スポット',
        target_seconds_label: '目標秒数',
        currency_label: '通貨',
        discount_label: '割引',
        tax_applicable_label: '適用される税金',
        actual_booking_label: '実際の予約',
        commercial_label: 'コマーシャル',
        fct_label: 'FCT',
        billing_label: '請求',
        channel_tab_label: 'チャンネル',
        channel_name_column: 'チャンネル名',
        epg_code_column: 'EPG コード',
        asrun_code_column: '実行コード',
        content_column: '内容',
        add_channel_button_tooltip: 'チャンネルの追加',
        add_commercial_button_tooltip: 'コマーシャル/プロモーションを追加する',
        commercial_promos_label: 'コマーシャル / プロモーション',
        add_fct_button_tooltip: 'FCTの追加',
        add_billing_button_tooltip: '請求の追加',
        channel_collection_header: 'チャンネル',
        commercials_collection_header: 'コマーシャル',
        fct_column: 'FCT',
        from_date_column: '開始日',
        to_date_column: '現在まで',
        campaign_type_column: 'キャンペーンの種類',
        rate10sec_column: 'レート10秒',
        days_column: '日数',
        fct_dialog_header: 'FCT',
        billing_dialog_header: '請求',
        from_date_label: '開始日',
        to_date_label: '現在まで',
        rate10sec_label: 'レート10秒',
        rate30sec_label: '料金30秒',
        day_label: '日',
        select_all_label: 'すべて選択',
        sun_label: '太陽',
        mon_label: '月',
        tue_label: '火',
        wed_label: '水',
        thu_label: '木',
        fri_label: '金',
        sat_label: '土',
        amount_column: '金額',
        amount_label: '金額',
        booking_label: '予約',
        campaign_label: 'キャンペーン',
        year_label: '年',
        months_label: '月',
        booking_collection_header: '予約するキャンペーンを選択してください',
        from_label: '出身:',
        to_label: '宛先:',
        total_spot_label: '総スポット数',
        total_seconds_label: '合計秒数',
        total_budget_label: '総予算:',
        download_template_tooltip: 'テンプレートをダウンロード',
        file_tooltip: 'ファイルを選択',
        line_no_column: 'ライン番号',
        commercial_column: 'コマーシャル',
        program_column: 'プログラム',
        house_number_column: '住居番号',
        type_column: 'タイプ',
        deal_type_column: '取引タイプ',
        spot_rate_column: 'スポットレート',
        position_column: 'ポジション',
        from_time_column: 'から',
        to_time_column: 'に',
        product_code_column: '製品コード',
        total_spot_column: 'トータルスポット',
        total_fct_column: '合計FCT',
        total_amount_column: '合計金額',
        booked_spots_lable: '予約済みスポット:',
        current_spots_label: '現在のスポット:',
        booked_seconds_label: '予約された秒数:',
        current_seconds_label: '現在の秒数:',
        booked_amount_label: '予約金額:',
        current_amount_label: '現在の金額:',
        add_booking_dialog_header: '予約を追加',
        type_label: 'タイプ',
        from_time_label: '時間から',
        spot_per_day_label: 'スポット（1日あたり）',
        spot_per_week_label: 'スポット (週あたり)',
        rate_label: '料金',
        estimate_code_label: '推定コード',
        remark_label: '備考',
        count_label: 'カウント',
        transfer_from_label: '転送元',
        transfer_to_label: '転送先',
        transfer_button_tooltip: '転送',
        transfer_button_text: '転送',
        campaign_column: 'キャンペーン',
        booking_date_column: '予約日',
        time_range_from_column: '時間範囲: から',
        time_range_to_column: '終了時間範囲',
        edit_actionbutton_menutext: '編集',
        select_all_Header_menutext: 'すべてのヘッダーを選択',
        delete_actionbutton_menutext: '削除',
        editduration_actionbutton_menutext: '期間の編集',
        cut_actionbutton_menutext: 'カット',
        update_booking_line_number_label: '予約明細番号を更新する',
        select_campaign_collection_text: 'キャンペーンを選択',
        edit_campaign_collection_text: 'キャンペーンの編集',
        select_campaign_collection_tooltip: '選択',
        already_scheduled_label: 'すでに予定されています',
        not_scheduled_label: '予定されていません',
        edit_booking_dialog_header: '予約の編集',
        spot_rate_label: 'スポットレート',
        time_range_from_label: '開始時間範囲',
        time_range_to_label: '終了時間範囲',
        auto_reconcile_button_tooltip: '自動調整',
        auto_reconcile_button_text: '自動調整',
        import_as_run_button_text: '実行としてインポート',
        import_as_run_button_tooltip: '実行としてインポート',
        reconciled_r_label: "R",
        reconciled_label: '和解した',
        non_reconciled_label: '調整されていない',
        non_reconciled_nr_label: 'NR',
        total_label: '合計',
        total_commercial: '総コマーシャル:',
        sno_column: 'SNo.',
        slot_date_time_column: 'スロット日付時刻',
        episode_number_column: 'エピソード番号',
        category_column: 'カテゴリ',
        reconciled_status_column: '調整済みステータス',
        is_reconciled_column: '和解している',
        reconsilation_by_column: '調整者',
        status_column: 'ステータス',
        ref_force_match_label: '強制一致',
        force_match_label: '強制一致',
        force_match_fm_label: 'FM',
        ref_force_unmatch_label: '強制アンマッチ',
        ref_cancel_label: 'キャンセル',
        ref_export_xml_label: 'XMLのエクスポート',
        purge_button_tooltip: 'パージ',
        unpurge_button_tooltip: 'パージ解除',
        campaign_no_label: 'キャンペーン番号',
        fic_dxb_0002486_label: 'FIC-DXB-0002486',
        total_spot_857_label: '857',
        total_amount_label: '合計金額',
        total_seconds_19935_label: '19935',
        total_cast_2478_label: '2478.00',
        purged_label: 'パージされた',
        date_column: '日付',
        is_purged_column: 'パージされた',
        ref_purged_label: 'パージ',
        ref_unpurged_label: 'パージ解除',
        ref_calculate_spot_rate_label: 'スポットレートの計算',
        total_fct_label: '合計FCT',
        total_spot_rate: '合計スポットレート',
        ref_calculate_fct_label: 'FCTの計算',
        ref_change_time_range_label: '時間範囲の変更',
        ref_transfer_label: '転送',
        ref_update_estimate_code_label: '見積りコードの更新',
        ref_change_commercial_label: 'コマーシャルを変更する',
        ref_change_spot_rate_label: 'スポットレートの変更',
        change_time_range_dialog_header: '時間範囲の変更',
        start_time_label: '開始時間',
        to_time_label: '時間に合わせて',
        transfer_dialog_header: '転送',
        transfer_to_date_label: '転送日まで',
        change_spot_rate_dialog_header: 'スポットレートの変更',
        change_spot_rate_label: 'スポットレートの変更',
        change_commercial_dialog_header: 'コマーシャルを変更する',
        change_commercial_label: 'コマーシャルを変更する',
        update_product_estimate_code_dialog_header: '製品見積コードの更新',
        update_button_text: 'アップデート',
        update_all_button_text: 'すべて更新',
        add_file_label: 'ファイルの追加',
        import_file_label: 'ファイルをインポートする',
        message_column: 'メッセージ',
        file_upload_tooltip: 'ファイルのアップロード',
        import_file_name_column: 'インポートファイル名',
        comment_load_data_label: '「ロード」をクリックしてデータをロードします',
        program_label: 'プログラム',
        select_program_booking_collection_header: '予約するプログラムを選択してください',
        export_report_dialog_header: 'Export EPG',
        import_template_dialog_heade: 'テンプレートのインポート',
        filters_label: 'フィルター',
        operator_label: 'オペレーター',
        operator_column: 'オペレーター',
        export_button_tooltip: 'Export',
        export_button_text: 'Export',
        export_playlist_button_tooltip: 'Export Playlist',
        export_and_sftp_playlist_button_tooltip: 'Export & SFTP Playlist',
        export_playlist_button_text: 'Export Playlist',
        up_button_tooltip: '上へ',
        down_button_tooltip: 'ダウン',
        export_template_editpageheader: 'Export EPG Template',
        save_template_as_label: 'テンプレートに名前を付けて保存',
        module_name_label: 'モジュール名',
        selected_Columns_label: '選択された列',
        available_Column_label: '利用可能な列',
        display_name_label: '表示名',
        add_blank_button_tooltip: '空白を追加',
        add_blank_button_text: '空白を追加',
        add_column_button_tooltip: '列の追加',
        add_column_button_text: '列の追加',
        available_Column: '利用可能な列',
        display_column: '表示名',
        format_name_column: 'フォーマット',
        id_label: 'ID',
        source_label: 'ソース',
        segment_position_label: 'セグメントの位置',
        group_label: 'グループ',
        select_media_episode_collection_header: 'メディアエピソードを選択してください',
        start_type_label: 'スタートタイプ',
        start_offset_label: '開始オフセット',
        time_hh_mm_ss_ff_label: '時:mm:ss:ff',
        negative_label: 'ネガティブ',
        end_type_label: 'エンドタイプ',
        end_offset_label: '終了オフセット',
        add_secondary_event_button_toottip: '二次イベントの追加',
        text_number_column: 'テキスト番号',
        prefix_column: 'プレフィックス',
        rule_column: 'ルール',
        text_number_label: 'テキスト番号',
        prefix_label: 'プレフィックス',
        rule_label: 'ルール',
        style_sheet_editpageheader: 'スタイルシート',
        add_prototype_button_tooltip: 'プロトタイプの追加',
        id_column: 'ID',
        protoType_source_column: 'プロトタイプソース',
        group_column: 'グループ',
        select_prototype_collection_header: 'プロトタイプの選択',
        default_prototype_editpageheader: 'デフォルトのプロトタイプ',
        create_secondary_event_dynamic_rule_dialog_header: 'セカンダリ イベントの動的ルールの作成',
        formula_label: '計算式',
        secondary_event_overview_dialog_header: '二次イベント概要',
        start_type_column: 'スタートタイプ',
        start_offset_column: '開始オフセット',
        end_type_column: '終了タイプ',
        end_offset_column: '終了オフセット',
        confirm_button_text: '確認する',
        billing_period_label: '請求期間',
        upto_label: 'まで',
        generate_bill_button_tooltip: '請求書の生成',
        generate_bill_button_text: '請求書の生成',
        agency_column: '代理店',
        client_column: 'クライアント',
        comission_column: '手数料%',
        from_column: 'から',
        to_column: 'に',
        total_budget_spot_column: '対象スポット',
        total_booked_spot_column: '予約済みスポットの合計',
        missing_spot_column: '欠けているスポット',
        reconciled_spots_column: '和解したスポット',
        generated_bill_Spots_column: '生成されたビルスポット',
        contact_label: '連絡する',
        contact_info_label: '連絡先情報',
        telephone_label: '電話',
        address1_label: '住所1',
        address2_label: '住所2',
        agency_info_label: '代理店情報',
        spots_label: 'スポット',
        amounts_label: '金額',
        total_booked_label: '合計予約数',
        missing_label: '行方不明',
        generated_bill_label: '生成された請求書',
        payment_recived_label: '支払いを受け取りました',
        due_amount_label: '支払額',
        credit_balance_label: 'クレジット残高',
        selected_campaign_info_label: '選択されたキャンペーン情報',
        booked_label: '予約済み',
        detail_for_selected_date_range_and_campaign_label: '選択した期間とキャンペーンの詳細',
        invoice_denomination_dialog_header: '請求書の額面',
        invoice_period_label: '請求期間',
        invoice_campaign_brabd_label: 'キャンペーンブランド',
        select_period_label: '期間を選択してください',
        show_button_tooltip: '表示する',
        show_button_text: '表示する',
        details_label: '詳細',
        caption_column: 'キャプション',
        spots_column: 'スポット',
        tax_column: '税金',
        tax_label: '税金',
        tax_not_applicable_label: '税金は適用されません',
        discount_amount_label: '割引額',
        invoice_date_label: '請求書の日付',
        bank_account_label: '銀行口座',
        gross_total_label: '総計',
        tax_amount_label: '税額',
        commission_amount_label: '手数料金額',
        target_amount_label: '目標金額',
        invoice_no_column: '請求書番号',
        campaign_no_column: 'キャンペーンNo.',
        invoice_date_column: '請求書の日付',
        period_from_column: '期間から',
        period_to_column: '期間終了',
        validated_amount_column: '検証された金額',
        discount_percentage_column: '割引率',
        discount_amount_column: '割引額',
        company_menu: '会社名',
        logo_url_label: 'ロゴの URL',
        logo_width_label: 'ロゴの幅',
        suffix_label: 'サフィックス',
        next_number_label: '次の番号',
        full_channel_name_label: '完全なチャンネル名',
        short_channel_name_label: '短いチャンネル名',
        epg_code_label: 'EPG コード',
        as_run_code_label: '実行コードとして',
        automation_channel_name_label: 'オートメーションチャンネル名',
        color_label: '色',
        automation_label: '自動化',
        repeated_pattern_details_dialog_header: '繰り返しパターンの詳細',
        add_repeat_button_tooltip: 'リピートの追加',
        create_repeat_pattern_editpage_header: 'リピートパターンの作成',
        create_variation_editpage_header: 'バリエーションを作成する',
        create_break_format_editpage_header: 'ブレークフォーマットの作成',
        edit_variation_editpage_header: 'バリエーションの編集',
        edit_break_format_editpage_header: 'ブレーク形式の編集',
        add_primary_pattern_button_tolltip: 'プライマリの追加',
        primary_events_no_column: '主なイベント いいえ',
        repeat_events_no_column: '繰り返しイベント いいえ',
        nominal_start_column: '公称スタート',
        primary_events_no_label: '主なイベント いいえ',
        days_label: '日数',
        times_label: '回',
        create_invoice_content_dialog_header: '請求書の内容を作成する',
        number_length_label: '数値の長さ',
        label: 'ラベル',
        sequence_label: 'シーケンス',
        entity_name_label: 'エンティティ名',
        max_length_label: '最大長さ',
        width_label: '幅',
        required_label: '必須',
        edit_label: '編集',
        slot_time_column: 'スロットタイム',
        please_generate_segment_to_load_media_label: 'メディアをロードするにはセグメントを生成してください。',
        filter_button_tooltip: 'フィルター',
        search_content_dialog_header: 'コンテンツの検索',
        clear_button_tooltip: 'クリア',
        clear_button_text: 'クリア',
        search_button_tooltip: '検索',
        search_button_text: '検索',
        select_preference_for_dialog_header: '列の設定を選択してください',
        available_label: '利用可能',
        preference_label: '好み',
        note_preference: '注: - デフォルトの列の場合は、設定を空のままにしてください',
        house_number_label: '住居番号',
        category_type_label: 'カテゴリの種類',
        slot_time_label: 'スロットタイム',
        actual_duration_label: '実際の継続時間',
        nominal_duration_label: '公称持続時間',
        segments_label: 'セグメント',
        recursive_button_text: '再帰的',
        recursive_dialog_header: '再帰的',
        generate_button_toottip: '生成する',
        generate_button_text: 'エクセル',
        inclusion_range_label: '包含範囲',
        episode_range_label: 'エピソード範囲',
        example_label: '例',
        exclusion_range_label: '除外範囲',
        exclude_days_label: '日を除く',
        format_icon_tooltip: 'フォーマット',
        no_segment_icon_tooltip: 'セグメントなし',
        contract_icon_tooltip: '契約書',
        slot_duration_title_label: 'スロット期間',
        maximize_button_tooltip: '最大化する',
        copy_Schedule_button_tooltip: 'コピー',
        planing_preference_button_tooltip: '計画の好み',
        export_planning_button_tooltip: 'Export Planning',
        selected_label: '選択済み',
        copied_label: 'コピーされました',
        select_channels_dialog_header: 'チャンネルの選択',
        date_label: '日付',
        copy_Schedule_dialog_header: 'スケジュールのコピー',
        copy_from_label: 'コピー元',
        copy_to_label: 'コピー先',
        selected_date_should_be_equal_error_message: '選択した日付範囲は同じである必要があります',
        from_channel_label: 'チャンネルから',
        to_channel_label: 'チャンネルへ',
        activity_label: 'アクティビティ',
        create_button_tootltip: '作成',
        create_button_text: '作成',
        planing_preference_dialog_header: '計画の好み',
        events_label: 'イベント',
        columns_label: 'コラム',
        general_label: '一般',
        note_select_the_events_you_want_to_change: '変更したいイベントを選択します',
        events_type_lable: 'イベントの種類',
        foreground_Color_label: '前景色',
        available_columns_label: '利用可能な列',
        view_type_label: 'ビューの種類',
        show_format_label: '表示形式',
        show_no_seg_label: 'セグメントを表示しない',
        show_contract_label: '契約書の表示',
        day_Start_time_label: '一日の開始時刻',
        prime_end_time_label: 'プライム終了時間',
        prime_Start_time_label: 'プライム開始時間',
        episode_Column: 'エピソード',
        season_Column: '季節',
        versions_column: 'バージョン',
        search_filter_dialog_header: '検索フィルター',
        release_year_label: '発売年',
        is_live_label: 'イズライブ',
        save_as_template_label: 'テンプレートとして保存',
        show_search_options_media_liberary_tooltip: '検索オプションを表示',
        place_holder_dialog_header: 'プレースホルダー',
        please_choose_one_publishing_rights_collection_header: '出版権を 1 つ選択してください',
        export_excel_dialog_header: 'Export Excel',
        export_excel_button_tooltip: 'Export Excel',
        export_csv_button_tooltip: 'Export CSV',
        export_excel_button_text: 'Export Excel',
        history_dialog_header: '歴史',
        slot_date_column: 'スロット日付',
        exhibition_no_column: '展示No.',
        repeat_no_column: '繰り返しいいえ',
        planning_loaded_label_note: '計画がロードされました',
        planning_loading_label_note: '計画を読み込んでいます...',
        time_column: '時間',
        prototypes_column: 'プロトタイプ',
        info_column: '情報',
        cut_button_tooltip: 'カット',
        paste_button_tooltip: 'ペースト',
        download_pdf_button_tooltip: 'PDFをダウンロード',
        open_planning_button_tooltip: 'オープンプランニング',
        delete_all_footer_button_tooltip: 'すべてのフッターを削除',
        delete_All_secondary_events_button_tooltip: 'すべての二次イベントを削除',
        global_replacement_button_tooltip: 'グローバルな置き換え',
        apply_style_sheet_button_tooltip: 'スタイルシートを適用する',
        apply_button_tooltip: '申し込む',
        apply_button_text: '申し込む',
        schedule_preference_button_tooltip: 'スケジュール設定',
        auto_save_button_tooltip: '自動保存',
        secondary_events_label: '二次的なイベント',
        text_1_column: 'テキスト1',
        text_2_column: 'テキスト 2',
        text_3_column: 'テキスト 3',
        prototypes_label: 'プロトタイプ',
        insert_break_actionbutton_menutext: 'ブレークの挿入',
        delete_header_actionbutton_menutext: 'ヘッダーの削除',
        program_replacement_actionbutton_menutext: 'プログラムの置き換え',
        attach_format_reload_actionbutton_menutext: '添付フォーマット',
        history_actionbutton_menutext: '歴史',
        select_program_to_replace_with_collection_title: '置き換えるプログラムを選択してください',
        global_replacement_dialog_header: 'グローバルな置き換え',
        replace_button_tooltip: '交換する',
        replace_button_text: '交換する',
        replacement_method_label: '交換方法',
        include_isBreak_label: '休憩を含む',
        replace_with_same_duration_only: '同じ期間のみ置換',
        enable_cross_category_replacement: 'クロスカテゴリーを有効にする',
        replacement_material_label: '交換材',
        delete_all_button_tooltip: 'すべて削除',
        delete_all_button_text: 'すべて削除',
        group_all_button_tooltip: 'グループメディアエピソード',
        group_all_button_text: 'グループメディアエピソード',
        select_media_episode_dialoag_header: 'メディアエピソードを選択してください',
        select_media_episode_group_dialoag_header: 'メディア エピソード グループの選択',
        remove_filter_actionbutton_menutext: 'フィルターを削除',
        filter_actionbutton_menutext: 'フィルター',
        copy_actionbutton_menutext: 'コピー',
        paste_actionbutton_menutext: 'ペースト',
        se_overview_actionbutton_menutext: 'SEの概要',
        global_replacement_actionbutton_menutext: 'グローバルな置き換え',
        sales_team_label: '営業チーム',
        department_label: '部門',
        password_label: 'パスワード',
        phone_no_label: '電話番号',
        pobox_label: '私書箱',
        reporting_to_lable: '報告先',
        role_label: '役割',
        issalesexecutive_label: 'セールスエグゼクティブです',
        sales_executive_editpageheader: '営業担当役員',
        email_column: '電子メール',
        phone_no_column: '電話番号',
        select_sales_executive_colllection_header: '営業担当者を選択',
        select_collection_button_text: '選択',
        export_planet_cast_button_tooltip: 'Export Planet Cast',
        check_list_button_tooltip: 'チェックリスト',
        check_lists_dialog_header: 'チェックリスト',
        success_label: '成功',
        failure_lable: '失敗',
        module_menu: 'モジュール',
        sales_team_dailog_header: '営業チームの作成',
        module_dialog_header: 'モジュール',
        role_dialog_header: '役割',
        admin_label: '管理者',
        sales_label: '販売',
        media_management_label: 'メディア管理',
        rights_manager_label: '権利マネージャー',
        role_editpageheader: '役割',
        select_module_collection_header: 'モジュールの選択',
        users_editpage_header: 'ユーザー',
        select_Role_collection_header: '役割の選択',
        module_column: 'モジュール',
        role_column: '役割',
        add_role_collection_text: '役割の追加',
        add_role_button_text: '役割から追加',
        add_module_collection_text: 'モジュールの追加',
        sales_executive_editpage_header: '営業担当役員',
        timeline_page_breadcrumb: 'タイムライン',
        linear_timeline_page_breadcrumb: '直線的なタイムライン',
        series_timeline_page_breadcrumb: "シリーズタイムライン",
        assets_type_page_breadcrumb: '資産の種類',
        rails_type_page_breadcrumb: 'レールの種類',
        posters_type_page_breadcrumb: 'ポスターの種類',
        department_page_breadcrumb: '部門',
        users_page_breadcrumb: 'ユーザー',
        role_page_breadcrumb: '役割',
        assets_page_breadcrumb: '資産',
        posters_page_breadcrumb: 'ポスター',
        client_page_breadcrumb: 'クライアント',
        agency_page_breadcrumb: '代理店',
        sales_team_page_breadcrumb: '営業チーム',
        trailer_page_breadcrumb: 'トレーラー',
        sales_executive_page_breadcrumb: '営業担当役員',
        content_page_breadcrumb: '内容',
        channel_page_breadcrumb: 'チャンネル',
        currency_page_breadcrumb: '通貨',
        repeat_pattern_page_breadcrumb: 'リピートパターン',
        invoice_content_page_breadcrumb: '請求書の内容',
        segment_type_page_breadcrumb: 'セグメントタイプ',
        contract_page_breadcrumb: '契約書',
        series_page_breadcrumb: '親シリーズ',
        season_page_breadcrumb: 'シリーズ',
        programs_page_breadcrumb: 'プログラム',
        episode_page_breadcrumb: 'エピソード',
        movies_page_breadcrumb: '映画',
        interstitial_page_breadcrumb: 'インタースティシャル',
        commercial_page_breadcrumb: 'コマーシャル',
        music_page_breadcrumb: '音楽',
        filler_page_breadcrumb: 'フィラー',
        break_page_breadcrumb: '休憩',
        group_page_breadcrumb: 'グループ',
        program_group_page_breadcrumb: 'プログラムグループ',
        interstital_group_page_breadcrumb: 'インタースティシャルグループ',
        schedule_constraints_page_breadcrumb: 'スケジュールの制約',
        campaign_page_breadcrumb: 'キャンペーン',
        utilisied_label: '活用済み',
        over_booked_label: '予約超過',
        counts_label: 'カウント',
        active_label: 'アクティブ',
        top_10_agency_label: 'トップ 10 代理店',
        top_10_client_label: 'トップ10のクライアント',
        pending_vs_on_air_booking_label: '保留中 vs OnAirBooking',
        revenue_by_location_label: '場所別の収益',
        revenue_by_months_label: '月ごとの収益',
        booking_by_deal_type_label: 'DealType による予約',
        time_range_label: '時間範囲',
        language_page_breadcrumb: '言語',
        region_page_breadcrumb: '地域',
        brand_page_breadcrumb: 'ブランド',
        product_page_breadcrumb: '製品',
        rails_page_breadcrumb: 'レール',
        page_breadcrumb: 'ページ',
        content_caegory_page_breadcrumb: 'コンテンツカテゴリ',
        ingestion_page_breadcrumb: '摂取',
        jobs_page_breadcrumb: '求人',
        prototype_page_breadcrumb: 'プロトタイプ',
        prototype_style_sheet_page_breadcrumb: 'プロトタイプのスタイルシート',
        default_prototype_style_sheet_page_breadcrumb: 'デフォルトのプロトタイプ スタイル シート',
        prototype_source_page_breadcrumb: 'プロトタイプソース',
        export_template_page_breadcrumb: 'Export Template',
        form_fields_page_breadcrumb: 'フォームフィールド',
        secondary_event_dynamic_rule_page_breadcrumb: 'セカンダリ イベントの動的ルール',
        format_page_breadcrumb: 'フォーマット',
        time_range_page_breadcrumb: '時間範囲',
        company_page_breadcrumb: '会社名',
        bank_account_page_breadcrumb: '銀行口座',
        tax_page_breadcrumb: '税金',
        licensor_page_breadcrumb: 'ライセンサー',
        delete_successfully_grid_data_success_toast_message: '正常に削除されました',
        delete_all_successfully_grid_data_success_toast_message: 'すべて正常に削除されました',
        please_select_first_contract_collection_error_message: '最初に選択してください!!',
        please_enter_contarct_number_contract_error_message: '契約番号を入力してください',
        please_select_platform_type_error_message: 'プラットフォームの種類を選択してください',
        please_select_licensor_error_message: 'ライセンサーを選択してください',
        please_select_payee_error_message: '受取人を選択してください',
        please_select_platform_error_message: 'プラットフォームを選択してください',
        please_select_channel_error_message: 'チャンネルを選択してください',
        please_select_region_error_message: '地域を選択してください',
        please_select_content_error_message: 'コンテンツを選択してください',
        please_select_play_time_error_message: '再生時間を選択してください',
        please_select_media_category_type_error_message: 'メディア カテゴリ タイプを選択してください',
        please_select_genres_media_episode_error_message: 'ジャンルを選択してください',
        please_select_department_error_message: '部門を選択してください',
        please_enter_title_error_message: 'タイトルを入力してください',
        please_enter_description_error_message: '説明を入力してください',
        please_enter_name_error_message: '名前を入力してください',
        please_enter_phone_no_error_message: '電話番号を入力してください',
        please_enter_email_error_message: '有効な電子メールを入力してください',
        please_select_roletype_error_message: '役割の種類を選択してください',
        please_enter_user_name_users_error_message: 'ユーザー名を入力してください',
        please_enter_password_users_error_message: 'パスワードを入力してください',
        invalid_duration_error_message: '有効な期間を入力してください',
        please_attach_atleast_one_media_episode_group_error_message: '少なくとも 1 つのメディアを添付してください',
        please_add_atleast_one_module_rights_users_error_message: '少なくとも 1 つのモジュール権限を追加してください',
        please_select_reportingto_user_error_message: '報告先を選択してください',
        please_select_sales_team_error_message: '営業チームを選択してください',
        exhibition_should_not_be_zero_error_message: '展覧会はゼロより大きくなければなりません',
        repeat_should_not_be_zero_error_message: '繰り返しはゼロより大きくなければなりません',
        play_time_number_should_not_be_zero_error_message: '再生時間の数値はゼロより大きくなければなりません',
        end_date_should_be_greater_than_start_date_error_message: '終了日は開始日よりも後の日付にする必要があります',
        please_attach_atleast_one_media_contract_error_message: '少なくとも 1 つのメディアを添付してください',
        please_select_season_content_series_error_message: 'シーズンコンテンツを選択してください',
        value_is_not_greater_then_zero_season_number_series_error_message: 'シーズン番号はゼロより大きくなければなりません',
        please_select_epiosde_content_series_error_message: 'エピソードの内容を選択してください',
        value_is_not_greater_then_zero_episode_number_series_error_message: 'エピソード番号はゼロより大きくなければなりません',
        please_attach_series_season_error_message: 'シリーズを添付してください',
        please_add_atleast_one_season_series_error_message: '少なくとも 1 つのシーズンを追加してください',
        entering_same_season_number_twice_series_error_message: '同じシーズン番号を2回入力する',
        enter_title_expender: 'タイトルを入力してください',
        please_select_poster_type_first_media_episode_poster_error_message: 'ポスターの種類を選択してください',
        please_select_url_first_media_episode_poster_error_message: '最初に URL を選択してください',
        please_select_the_value_in_start_date_media_episode_publishing_error_message: '開始日の値を選択してください',
        please_select_the_value_in_end_date_media_episode_publishing_error_message: '終了日の値を選択してください',
        you_delete_this_deal_right_from_contract_only_media_episode_publishing_error_message: 'この取引は契約からのみ削除してください。',
        please_select_ottvideo_type_media_episode_video_error_message: 'ビデオの種類を選択してください',
        create_dialog_header: '作成',
        synopsis_can_not_be_null_media_episode_Synopsis_error_message: '概要を Null にすることはできません',
        please_select_language_media_episode_Synopsis_error_message: '言語を選択してください',
        please_enter_name_cast_crew_media_episode_error_message: '名前を入力してください',
        please_select_casttype_cast_crew_media_episode_error_message: 'キャストタイプを入力してください',
        please_select_segment_type_media_episode_version_error_message: 'セグメントタイプを選択してください',
        please_generate_segments_first_media_episode_version_error_message: 'セグメントを生成してください',
        media_episode_entity_duration_segment_error_message: '実際の期間は null です。セグメンテーションを適用する期間の有効期間を更新してください',
        please_select_brand_media_episode_error_message: 'ブランドを選択してください',
        please_select_product_media_episode_error_message: '製品を選択してください',
        please_enter_value_media_episode_error_message: '値を入力してください',
        please_enter_valid_value_tcin_should_not_be_greater_than_tcout_media_episode_error_message: '有効な値を入力してください。TcIn は TcOut より大きくてはなりません',
        error_while_generating_house_number_media_episode_error_message: '家番号の生成中にエラーが発生しました',
        already_exists_global_error_message: 'すでに存在します!!',
        you_can_update_this_deal_right_from_contract_only_media_episode_publishing_error_message: 'この取引は契約からのみ更新できます!!',
        this_segment_is_already_been_scheduled_segmnet_media_episode_error_message: 'このセグメントはすでにスケジュールされています',
        please_enter_title_display_rails_error_message: 'タイトル表示を入力してください',
        atleast_attach_one_ottassets_rails_error_message: '少なくとも 1 つの OttAssets を添付してください',
        please_enter_enter_icon_uel_error_message: 'アイコンのURLを入力してください',
        create_label: '作成',
        edit_lable: '編集',
        select_label: '選択',
        please_select_media_category_type_first_media_episode_group_error_message: '最初にメディア カテゴリ タイプを選択してください',
        please_select_role_users_error_message: '役割を選択してください',
        user_name_error_message: '同じユーザー名を持つユーザー/営業担当者',
        no_data_found_scheduling_reconciliation_error_message: 'データが見つかりません!',
        schedule_and_as_run_data_load_successfully_scheduling_reconciliation_success_message: 'スケジュールとAsRunデータが正常にロードされました',
        error_while_loading_as_run_data_scheduling_reconciliation_error_message: 'AsRun データのロード中にエラーが発生しました:',
        auto_recocile_successfully_scheduling_reconciliation_success_message: '自動調整が成功しました!!',
        select_first_scheduling_reconciliation_error_message: '一致するスケジュールと実行項目を選択してください。',
        already_reconsiled_scheduling_reconciliation_error_message: 'すでに調整済み!',
        select_item_have_different_assetid_scheduling_reconciliation_error_message: '選択したアイテムの AssetId が異なります。',
        force_unmatch_successfully_scheduling_reconciliation_success_message: '強制アンマッチが成功しました!!',
        please_select_schedule_and_as_run_item_scheduling_reconciliation_error_message: 'スケジュールとAsRun項目を選択してください。',
        select_item_is_not_reconsiled_scheduling_reconciliation_error_message: '選択した項目は調整されません。',
        select_schedule_and_asrun_item_not_reconciled_together_scheduling_reconciliation_error_message: '選択したスケジュールと実行項目が調整されていません',
        select_schedule_item_already_billed_error_message: '選択したスケジュール項目はすでに請求されています。',
        saved_successfully_scheduling_reconciliation_success_message: '正常に保存されました!!!',
        role_type_label: '役割の種類',
        please_load_first_scheduling_reconciliation_error_message: 'まずはロードしてください!!',
        tx_mode_label: '送信モード',
        segment_count_label: 'セグメント数',
        create_segment_type_dialog_header: 'セグメントタイプの作成',
        please_enter_type_name_segment_type_error_message: 'タイプ名を入力してください',
        please_select_tx_mode_segment_type_error_message: 'TXモードを選択してください',
        please_enter_segment_count_segment_type_error_message: 'セグメント数を入力してください',
        interstitial_group_sub_menu: 'インタースティシャルグループ',
        program_group_sub_menu: 'プログラムグループ',
        variation_page_breadcrumb: 'バリエーション',
        breakformat_page_breadcrumb: 'ブレークフォーマット',
        payment_provider_page_breadcrumb: '決済プロバイダー',
        ott_period_type_page_breadcrumb: 'オット期タイプ',
        payment_type_page_breadcrumb: '支払いタイプ',
        ott_period_page_breadcrumb: '期間',
        subscriber_page_breadcrumb: '購読者',
        media_type_label: 'メディアの種類',
        atleast_attach_one_item_variation_error_message: '少なくとも 1 つのアイテムを添付してください',
        please_select_media_type_error_message: 'メディアの種類を選択してください',
        season_number_should_not_be_zero_error_message: 'シーズン番号はゼロより大きくなければなりません',
        number_of_epiosde_should_not_be_zero_error_message: 'エピソード数はゼロより大きくなければなりません',
        starting_epiosde_should_not_be_zero_error_message: '開始エピソードはゼロより大きくなければなりません',
        please_select_potraitimageurl_otteditform_error_message: 'ポートレート画像のURLを選択してください',
        please_select_landscapeimageurl_otteditform_error_message: '横長画像のURLを選択してください',
        include_pre_opening_label: 'プレオープニングを含む',
        include_closing_label: '終わりを含める',
        break_number_column: 'ブレーク番号',
        break_duration_column: '休憩時間',
        commercial_duration_column: 'コマーシャル期間',
        promo_duration_Column: 'プロモーション期間',
        total_break_duration_label: '合計休憩時間',
        segment_count_should_be_zero_error_message: 'セグメント数は 1 より大きくなければなりません',
        invalid_slot_duration_error_message: '無効なスロット期間',
        invalid_total_break_duration_error_message: '無効な合計休憩時間',
        break_not_distribute_breakformat_error_message: '休憩は配布されません',
        slot_duration_should_Be_greater_than_total_break_duration_breakformat_error_message: 'スロット継続時間は合計ブレイク継続時間より長くする必要があります',
        break_count_segment_count_does_not_match_breakformat_error_message: 'ブレーク数とセグメント数が一致しません',
        please_enter_template_name_error_toast: 'テンプレート名を入力してください',
        please_select_module_type_error_message: 'モジュールタイプを選択してください',
        please_select_ingestion_template_type_error_message: '取り込みテンプレートのタイプを選択してください',
        saved_successfully_message: '正常に保存されました',
        please_enter_code_error_message: 'コードを入力してください',
        please_select_agency_error_message: '代理店を選択してください',
        please_select_default_tax_error_message: 'デフォルトの税金を選択してください',
        please_select_agency_type_error_message: '代理店タイプを選択してください',
        please_select_atleast_one_Sales_executive: '少なくとも 1 人の営業担当者を選択してください',
        add_sales_executive_button_tooltip: '営業担当者を追加',
        please_enter_prefix_error_message: 'プレフィックスを入力してください',
        please_enter_suffix_error_message: 'サフィックスを入力してください',
        please_attach_atleast_one_media_error_message: '少なくとも 1 つのメディアを添付してください',
        please_enter_full_Channel_name_error_message: '完全なチャンネル名を入力してください',
        please_enter_short_Channel_name_error_message: '短いチャンネル名を入力してください',
        please_select_atleast_one_repeat_pattern_error_message: '少なくとも 1 つの繰り返しを選択してください。',
        primary_delete_succesfully_repeat_pattern_error_message: 'プライマリ削除に成功しました',
        repeat_delete_succesfully_repeat_pattern_error_message: '削除を繰り返し成功しました',
        please_select_atleast_one_days_repeat_pattern_error_message: '少なくとも 1 日を選択してください。',
        please_enter_automation_channel_name_error_message: 'オートメーション チャネル名を入力してください',
        please_enter_epg_code_error_message: 'EPG コードを入力してください',
        please_select_automation_error_message: '自動化を選択してください',
        please_enter_color_error_message: '色を入力してください',
        please_add_atleast_one_module_role_error_message: '少なくとも 1 つのモジュールを追加してください。',
        data_loaded_successfully_ingestion_template_message: 'データは正常にロードされました',
        please_enter_positive_value_in_creditlimit_error_message: 'CreditLimit に正の値を入力してください',
        please_enter_gst_no_error_message: 'GST番号を入力してください',
        please_enter_campaign_no_error_message: 'キャンペーン番号を入力してください',
        please_select_client_error_message: 'クライアントを選択してください',
        period_from_should_be_less_then_periodto_campaign_error_message: 'PeriodFrom は PeriodTo より小さい必要があります',
        commission_exceeded_limit_from_less_than_100_campaign_error_message: 'コミッションが許容制限を超えています (100 未満である必要があります)。',
        discount_exceeded_from_limit_less_than_100_campaign_error_message: '割引が許容制限を超えています (100 未満である必要があります)。',
        please_enter_target_budget_error_message: '目標予算を入力してください',
        please_enter_target_spots_error_message: '対象スポットを入力してください',
        please_enter_target_seconds_error_message: '目標秒数を入力してください',
        please_attach_atleast_one_commercials_campaign_error_message: '少なくとも 1 つのコマーシャルを添付してください',
        please_attach_atleast_one_channel_campaign_error_message: '少なくとも 1 つのチャンネルを接続してください',
        please_select_campaign_type_error_message: 'キャンペーンの種類を選択してください',
        please_enter_rate10sec_error_message: '料金10秒を選択してください',
        please_enter_fct_error_message: 'FCTを入力してください',
        please_enter_from_date_error_message: '開始日を入力してください',
        please_enter_to_date_error_message: '現在までの日付を入力してください',
        please_enter_amount_error_message: '金額を入力してください',
        data_loading_error_message: 'データをロード中...',
        no_record_found_error_message: '記録が見つかりません!',
        total_sum_spot_rate_success_message: '合計スポットレート',
        total_fct_success_message: '合計FCT',
        booking_is_used_in_schedule_show_spot_error_message: '予約はスケジュールで使用されます',
        changes_Will_Reflect_in_new_planned_items_only_segmenttype_error_message: '変更は新しい計画アイテムにのみ反映されます',
        please_select_campaign_first_booking_error_message: '最初にキャンペーンを選択してください',
        error_reading_file_booking_error_message: 'ファイル読み取りエラー',
        wrong_month_selected_booking_error_message: '間違った月が選択されました',
        wrong_year_selected_booking_error_message: '間違った年が選択されました',
        error_downloading_template_booking_error_message: 'テンプレートのダウンロード中にエラーが発生しました',
        please_select_a_value_to_update_booking_error_message: '更新する値を選択してください',
        exceding_target_spots_limit_booking_error_message: 'ターゲットスポットの制限を超えています',
        exceding_target_budget_booking_error_message: '目標予算を超えている',
        commercials_not_updated_in_line_no_booking_error_message: 'コマーシャルがライン内で更新されない',
        exceding_target_seconds_booking_error_message: '目標秒数を超えています',
        booking_saved_booking_error_message: '予約が保存されました',
        no_data_found_booking_error_message: 'データが見つかりません',
        from_time_should_be_less_than_To_time_booking_error_message: 'From Time は To Time より小さくなければなりません',
        please_enter_spot_booking_error_message: 'スポットを入力してください',
        please_enter_rate_booking_error_message: '料金を入力してください',
        please_select_transfer_from_date_booking_transfer_error_message: '転送開始日を選択してください',
        please_select_transfer_date_booking_transfer_error_message: '転送日を選択してください',
        please_select_item_booking_transfer_error_message: '最初に項目を選択してください!',
        booking_transfer_succesfully_to_booking_transfer_error_message: '予約転送が成功しました',
        exceding_target_spots_limit_update_booking_line_number_error_message: 'ターゲットスポットの制限を超えています',
        exceding_target_budget_update_booking_line_number_error_message: '目標予算を超えている',
        exceding_target_seconds_update_booking_line_number_error_message: '目標秒数を超えています',
        loading_data_update_booking_line_number_error_message: 'データをロードしています!!',
        data_loaded_update_booking_line_number_success_message: 'データのロードに成功しました!!',
        loading_booking_update_booking_line_number_success_message: '予約を読み込んでいます...',
        bill_is_already_generated_for_this_linenumber_update_booking_line_number_success_message: 'この LineNumber に対して請求書はすでに生成されています。',
        please_select_file_error_message: 'ファイルを選択してください',
        downlaod_file_error_message: 'ダウンロードファイル',
        no_import_type_defined_error_message: 'インポートタイプが定義されていません',
        upload_Successfully_import_success_message: 'アップロードに成功しました',
        asrun_Save_Successfully_import_success_message: 'AsRun 保存に成功しました',
        asrun_save_failed_import_error_message: 'AsRun 保存に失敗しました',
        update_failed_import_error_message: 'アップロードに失敗しました',
        assest_not_found_import_message: 'アセットが見つかりません',
        planning_imported_successfully_import_message: '計画が正常にインポートされました',
        import_planning_failed_import_message: 'インポート計画が失敗しました。',
        read_to_upload_import_message: '読み取りからアップロードまで',
        please_select_from_date: '開始日を選択してください',
        please_select_to_date_greater_than_from_date_error_message: '開始日より後の終了日を選択してください',
        please_select_the_value_in_template_name_first_export_report_error_message: '最初にテンプレート名の値を選択してください。',
        please_select_the_value_in_format_first_export_report_error_message: '最初に形式の値を選択してください',
        please_add_at_least_one_item_list_export_report_error_message: '少なくとも 1 つの項目リストを追加してください。',
        please_select_the_value_in_filters_first_export_report_error_message: '最初にフィルターの値を選択してください。',
        Please_select_the_value_in_Operator_first_export_report_error_message: 'まず演算子で値を選択してください。',
        value_can_not_be_null_export_report_error_message: '値をNULLにすることはできません',
        report_is_exported_successfully_message: 'EPG は正常にエクスポートされました',
        content_report_is_exported_successfully_message: 'レポートは正常にエクスポートされました',
        please_select_valid_dates_export_template_error_message: '有効な日付を選択してください',
        exporting_data_please_wait_export_template_error_message: 'Exporting data please wait....',
        successfully_exported_export_template_message: '正常にエクスポートされました',
        no_data_found_to_export_template_message: 'エクスポートするデータが見つかりませんでした',
        please_select_the_value_in_available_column_export_template_error_message: '「使用可能な列」の値を選択してください',
        please_enter_display_name_error_message: '表示名を入力してください',
        please_enter_savetempleteas_export_template_error_message: '入力してください。Templete に名前を付けて保存',
        please_add_column_atleast_one_item_export_template_error_message: '少なくとも 1 つの列を追加してください',
        is_saved_successfully_export_template_message: '正常に保存されました',
        please_select_module_error_message: 'モジュールを選択してください',
        please_enter_id_error_message: 'IDを入力してください',
        please_select_source_error_message: 'ソースを選択してください',
        please_select_atleast_one_secondary_events_error_message: '少なくとも 1 つの二次イベントを選択してください',
        invalid_startoffset_error_message: '無効な開始オフセット',
        invalid_endoffset_error_message: '無効な終了オフセット',
        please_enter_text_no_error_message: 'テキスト番号を入力してください',
        please_select_the_value_in_rule_first_error_message: '最初にルールの値を選択してください',
        please_attach_atleast_one_prototype_stylesheet_error_message: '少なくとも 1 つのプロトタイプを添付してください',
        please_enter_formula_error_message: '数式を入力してください',
        please_wait_loading_data_billing_error_message: 'データをロード中ですのでお待ちください...',
        data_loaded_successfully_billing_template_message: 'データは正常にロードされました',
        please_select_a_billing_detail_first_billing_template_message: '最初に請求の詳細を選択してください。',
        no_reconciled_spots_found_for_selected_details_billing_template_message: '選択した詳細に対して調整されたスポットが見つかりません!',
        please_select_bank_billing_error_message: '銀行を選択してください!',
        please_select_tax_billing_error_message: '税金を選択してください!',
        please_select_brand_billing_error_message: 'ブランドを選択してください!',
        no_invoice_details_are_available_to_bill_billing_error_message: '請求に使用できる請求書の詳細はありません。',
        campaign_brands_label: 'ブランド',
        all_label: 'すべて',
        selected_brand: '選択されたブランド',
        selected_channel: '選択したチャンネル',
        brand_label: 'ブランド',
        please_select_file_first_datamigration_error_message: '最初にファイルを選択してください。',
        empty_media_grid_datamigration_error_message: 'インポートするには、以下のグリッドにデータをロードしてください。',
        please_select_type_datamigration_error_message: 'タイプを選択してください!!',
        imported_successfully_datamigration_success_message: '正常にインポートされました',
        please_select_language_error_message: "言語を選択してください",
        please_select_logo_url_first_error_mesage: '最初にロゴの URL を選択してください。',
        please_select_segment_type_and_channel_format_error_message: 'セグメントタイプとチャンネルを選択してください',
        new_create_formfield_dialog_header: '新規作成',
        please_select_segment_type_format_error_message: 'セグメントタイプを選択してください',
        not_allowed_for_segments_format_error_message: 'セグメントには使用できません',
        cannot_delete_segments_format_error_message: 'セグメントを削除できません',
        select_atleast_one_mediaDealRight_planner_error_message: '少なくとも 1 つのメディア取引権利を選択してください',
        first_copy_planner_items_you_want_to_paste_planner_error_message: 'まず、貼り付けたいプランナー項目をコピーします。',
        please_select_area_on_planner_where_to_paste_planner_error_message: 'プランナー上の貼り付ける領域を選択してください。',
        from_date_cant_be_greater_than_to_date_paste_planner_error_message: 'From date を to date より大きくすることはできません。',
        call_planner_error_message: '電話する',
        data_copy_schedule_please_wait_copyschedule_error_message: 'コピー スケジュールの検証を確認しています。お待ちください...',
        copy_schedule_data_copyschedule_successfully_message: 'コピー スケジュール データのコピーが正常に完了しました....',
        no_data_found_to_copy_schedule_error_message: 'スケジュールをコピーするデータが見つかりませんでした',
        applying_recursive_pattern_please_wait_planner_error_message: 'Applying Recursive Pattern, Please Wait...',
        recursive_pattern_applied_successfully_planner_success_message: 'Recursive Pattern Applied Successfully',
        pasted_pattern_planner_error_message: '貼り付けた',
        items_pattern_planner_error_message: 'アイテム',
        to_date_is_mandatory_recursive_error_message: '現在までの日付は必須です。',
        to_date_should_be_greater_than_base_program_start_date_recursive_error_message: '現在までの日付は、基本プログラム開始日よりも後の日付である必要があります',
        select_one_item_to_open_schedule_planner_helper_error_message: 'select one item to open schedule',
        copy_button_text: 'コピー',
        open_schedule_button_text: 'オープンスケジュール',
        paste_button_text: 'ペースト',
        delete_button_text: '削除',
        error_fetching_channel_list_planning_wrapper_error_message: 'Error fetching channel list',
        please_select_planning_item_planning_wrapper_error_message: 'Please Select Planning Item',
        recursive_applied_successfully_planning_wrapper_message: 'Recursive Applied Successfully !!',
        select_program_group_label: 'プログラムグループの選択',
        select_break_format__label: 'ブレーク形式の選択',
        please_enter_template_name_to_save_template_planningfilter_error_message: 'Please enter template name to save template',
        selected_content_text_planning_footer: '選択されたコンテンツ',
        copied_content_text_planning_footer: 'コピーされたコンテンツ',
        first_copy_planner_items_you_want_to_paste_planning_performance_error_message: 'まず、貼り付けたいプランナー項目をコピーします。',
        please_select_area_on_planner_where_to_paste_planning_performance_error_message: 'プランナー上の貼り付ける領域を選択してください。',
        select_atleast_one_mediadealright_planning_performance_error_message: 'select atleast one deal right',
        first_select_replace_items_global_replacement_error_message: 'まず置換アイテムを選択します',
        please_select_content_to_delete_planning_performance_error_message: 'Please select content to delete',
        not_allowed_Control_with_schedule_planning_performance_error_message: 'Not Allowed, Control with schedule',
        entry_already_exist_try_with_different_values_collection_error_message: 'エントリはすでに存在します。別の値で試してください。',
        please_select_first_collection_error_message: '最初に選択してください!',
        already_attached_collection_error_message: 'すでに取り付けられています!!',
        export_current_booking_tooltip: 'Export Current Booking',
        export_saved_booking_tooltip: 'Export Saved Booking',
        please_select_poster_type_error_message: 'ポスターの種類を選択してください',
        browser_button_text: '閲覧する',
        file_selected_label: 'ファイルが選択されました',
        only_jpg_jpeg_and_png_files_are_allowed_msg: 'jpg/jpeg および png ファイルのみが許可されます。',
        please_add_programs_format_error_message: 'Please add programs format',
        please_select_atleast_one_item: '少なくとも 1 つの項目を選択してください。',
        please_enter_season_number_error_message: 'シーズン番号を入力してください',
        repeat_pattern_label: 'リピートパターン',
        select_repeat_pattern_collection_header: 'リピートパターンの選択',
        please_select_from_date_error_message: '日付から選択してください',
        please_select_to_date_error_message: '現在までの日付を選択してください',
        please_select_to_date_grater_then_from_date_error_message: '開始日より後の終了日を選択してください',
        parent_content_category_label: '親コンテンツのカテゴリ',
        rail_will_be_added_soon2_label: 'Rail will be added soon2!',
        rail_will_be_added_soon3_label: 'レールは近日追加予定です3!',
        no_select_image_error_message: '画像を選択していません',
        please_enter_key_error_message: 'キーを入力してください',
        please_enter_value_error_message: '値を入力してください',
        please_wait_generating_bill: '請求書を生成しています。お待ちください...',
        bill_generated_successfully: '請求書が正常に生成されました',
        please_select_template_error_message: 'テンプレートを選択してください',
        please_select_file_first_error_message: '最初にファイルを選択してください。',
        please_enter_first_error_message: 'まずは入力してください！',
        please_select_channel_first: '最初にチャンネルを選択してください',
        please_select_start_date_error_message: '開始日を選択してください',
        please_select_end_date_error_message: '終了日を選択してください',
        please_enter_valid_sequnce_number_error_message: '有効なシーケンス番号を入力してください',
        program_schedule_clash_breadcrumb: 'プログラムスケジュールの衝突',
        clash_channel_column: 'クラッシュチャンネル',
        clashed_time_Column: 'クラッシュタイム',
        source_time_Column: 'ソース時間',
        no_data_found_error_message: 'データが見つかりません!',
        movie_name_column: '映画名',
        create_ott_period_type_dialog_header: 'オット期間の作成',
        create_subscriber_dialog_header: '購読者の作成',
        play_type_label: 'プレイタイプ',
        ott_period_type_label: 'オット期タイプ',
        please_enter_play_time_error_message: '再生時間はゼロより大きくなければなりません',
        please_select_play_type_error_message: 'プレイタイプを選択してください',
        please_select_ott_period_type_error_message: 'オット期タイプを選択してください',
        ott_period_label: 'オット期',
        payment_type_label: '支払いタイプ',
        trials_tab_label: '試練',
        fixed_trials_tab_label: '固定トライアル',
        reminders_tab_label: 'リマインダー',
        payment_Provider_label: '決済プロバイダー',
        send_label: 'リマインダー',
        dayPrior_label: '前日のリマインダー',
        enable: '有効にする',
        trials_dialog_header: '試練',
        reminders_dialog_header: 'リマインダー',
        add_trial_button_tooltip: 'トライアルの追加',
        add_reminders_button_tooltip: 'リマインダーを追加する',
        paymentPlan_sub_menu: 'お支払いプラン',
        please_select_Payment_Provider_error_message: '支払いプロバイダーを選択してください',
        please_select_PlayType_error_message: 'プレイタイプを選択してください',
        please_select_OttPeriod_error_message: 'オット期間を選択してください',
        please_select_Currency_error_message: '通貨を選択してください',
        please_select_PaymentType_error_message: 'お支払いタイプを選択してください',
        ott_product_sub_menu: '製品',
        ott_product_label: '製品',
        sales_status_label: '販売状況',
        geo_Region_label: '地域地域',
        create_ott_product_type_dialog_header: 'オット製品の作成',
        please_select_geo_region_error_message: '地域を選択してください',
        please_select_sales_status_error_message: '販売状況を選択してください',
        please_select_Payment_Plan_error_message: 'お支払いプランを選択してください',
        show_app_bar_label: 'アプリバーを表示',
        isHomePage_label: 'ホームページです',
        route_type_label: 'ルートの種類',
        page_label: 'ページ',
        rails_l_label: 'L',
        rails_uat_label: 'U',
        live_label: 'ライブ',
        uat_label: 'UAT',
        media_is_already_attached_with_another_asset_error_message: 'メディアはすでに別のアセットにアタッチされています',
        add_payment_plan_tooltip: '支払いプランの追加',
        trial_price_label: 'お試し価格',
        trial_days_label: 'トライアルデー',
        sort_index_label: 'ソートインデックス',
        hide: '隠す',
        select_payment_plan_collection: 'お支払いプランを選択してください',
        payments_dialog_header: '支払い',
        daysBefore_label: '数日前',
        subscription_id_label: 'サブスクリプションID',
        package_label: 'パッケージ',
        last_updated_label: '最終更新',
        please_enter_subscription_id_error_message: 'サブスクリプションIDを入力してください',
        please_enter_package_error_message: 'パッケージを入力してください',
        please_enter_last_update_error_message: '最終更新情報を入力してください',
        please_select_route_type: "ルートの種類を選択してください",
        please_select_video_playback_url: '動画の再生 URL を選択してください',
        please_select_page: 'ページを選択してください',
        ott_campaign_page_breadcrumb: 'キャンペーン',
        edit_campaign_editpage_header: 'オットキャンペーンの編集',
        add_rails_button_tootip: 'レールの追加',
        select_rails_collection: 'レールの選択',
        publish_column: '出版',
        from_date_should_be_less_than_to_date_error_message: '開始日は終了日よりも小さい必要があります',
        please_select_rails_error_message: '少なくとも 1 つのレールを選択してください',
        ott_rails_type_column: 'オットレールタイプ',
        add_above_option: '上に追加',
        add_below_option: '以下に追加',
        select_any_one_collection_selection_error_message: 'どれかを選択してください',
        please_attach_media_first: 'メディアを添付してください',
        edit_actionbutton_option: '編集',
        asset_label: 'アセットID',
        job_id_label: 'ジョブID',
        job_started_label: '開始しました',
        job_finished_label: '完了しました',
        elapsed_label: '経過',
        job_input_file_label: '入力ファイル',
        media_type_column: 'メディアの種類',
        file_location_column: 'ファイルの場所',
        attach_media_button_tooltip: 'メディアを添付する',
        attach_media_button_text: 'メディアを添付する',
        select_media_collection_header: "メディアの選択",
        assets_label_ott_collection: '資産',
        select_assets_collection_header: "アセットの選択",
        some_bookings_are_already_Scheduled_Could_not_transfer_error_message: '一部の予約はすでにスケジュールされており、転送できませんでした',
        jobs_title: '求人',
        total_assets_label: '総資産',
        makegoodspot_sub_menu: '良いスポットを作る',
        makegoodspot_title: '良いスポットを作る',
        makegoodspottransfer_dialog_header: 'スポット転送を上手に行う',
        select_item_date_between_from_and_to_error_message: '選択した移行日はキャンペーン期間の開始日と終了日の間である必要があります',
        please_transfer_error_date_greater_than_bookingdate_message: '現在の予約日より後の振替日を選択してください。',
        latest_jobs_label: '最新の求人',
        invalid_date_range_copy_to_planning_error_message: 'コピー先の日付範囲が無効です',
        invalid_date_range_copy_from_planning_error_message: 'コピー元の日付範囲が無効です',
        date_range_between_seven_day_copy_from_planning_error_message: 'コピー元の日付範囲は 31 日以内である必要があります',
        date_range_between_seven_day_copy_to_planning_error_message: 'コピー日の範囲は 31 日以内である必要があります',
        height_label: "高さ",
        create_ott_asset_label: 'オットアセットの作成',
        media_label: 'メディア *',
        recent_jobs_label: '最近の仕事',
        please_select_type_error_message: 'タイプを選択してください',
        create_schedule_constraints_editpage_header: 'スケジュール制約の作成',
        schedule_constraints_error_message: 'スケジュールの制約',
        constraints_lable: '制約',
        fill_under_run_button_tooltip: 'バリエーションとデフォルト形式に基づいたスケジュールの入力',
        resetautofill_button_tooltip: 'オートフィルをリセット',
        please_select_amount_error_message: '金額を選択してください',
        please_enter_sort_index_error_message: 'ソートインデックスを入力してください',
        please_enter_trial_price_error_message: 'お試し価格を入力してください',
        please_enter_trial_days_error_message: '試用日を入力してください',
        please_select_reminder_error_message: 'リマインダーを選択してください',
        please_enter_days_before_error_message: '日前に入力してください',
        enable_reminder_label: 'リマインダーを有効にする',
        coupon_page_breadcrumb: 'クーポン',
        discount_type_label: '割引タイプ',
        discount_value_label: '割引額',
        create_coupon_dialog_header: 'クーポンの作成',
        please_select_discount_type_error_message: '割引タイプを選択してください',
        percentage_can_not_be_greater_than_error_message: 'パーセンテージは 100 を超えることはできません',
        enable_fixed_trial_label: '固定トライアルを有効にする',
        limited_period_label: '期間限定',
        valid_from_label: '有効開始日',
        valid_to_label: '有効期限',
        please_select_valid_from_date_error_message: '有効な期間を選択してください',
        please_select_valid_to_date_error_message: '有効期限を選択してください',
        discount_should_be_greater_then_zero_error_message: '割引はゼロより大きくなければなりません',
        please_select_valid_date_error_message: '有効な日付を選択してください',
        payment_plan_label: 'お支払いプラン',
        coupon_label: 'クーポン',
        add_coupon_tooltip: 'クーポンを追加',
        select_coupon_collection: 'クーポンを選択',
        code_column: 'コード',
        discount_type_column: '割引タイプ',
        discount_value_column: '割引額',
        audit_log_menu: '監査ログ',
        audit_log_breadcrumb: '監査ログ',
        genre_sub_menu: 'ジャンル',
        media_category_sub_menu: 'メディア部門',
        genre_page_breadcrumb: 'ジャンル',
        media_category_page_breadcrumb: 'メディア部門',
        module_label: 'モジュール',
        event_label: 'イベント',
        please_select_event_error_message: 'イベントを選択してください',
        download_button_tooltip: 'ダウンロード',
        date_time_label: '日付時刻',
        confirm_password_label: 'パスワードの確認',
        password_do_not_match_error_message: 'パスワードが一致しません',
        please_enter_confirm_password_users_error_message: '確認用のパスワードを入力してください',
        atleast_attach_atleast_one_platform_error_message: '少なくとも 1 つのプラットフォームを選択してください',
        upload_file_button_tooltip: 'ファイルをアップロードする',
        role_tab_label: '役割',
        add_channel_button_text: 'チャンネルの追加',
        select_channel_collection_header: 'チャンネルの選択',
        please_add_atleast_one_channel_users_error_message: '少なくとも 1 つのチャンネルを追加してください',
        please_select_order_date_error_message: '注文日を選択してください',
        please_select_period_from_date_error_message: '期間を選択してください',
        please_select_period_to_date_error_message: '期間を選択してください',
        please_select_deal_type_error_message: '取引タイプを選択してください',
        please_select_location_error_message: '場所を選択してください',
        please_select_product_error_message: '製品を選択してください',
        ott_segment_sub_menu: 'セグメント',
        payment_plan_page_breadcrumb: 'お支払いプラン',
        ott_segment_page_breadcrumb: 'セグメント',
        create_segment_dialog_header: 'セグメントの作成',
        segment_label: 'セグメント',
        please_select_segment_error_message: 'セグメントを選択してください',
        monetization_dashboard: '収益化',
        segment_by_subscribe_label: '加入者ごとにセグメント化する',
        segment_by_product_label: '製品別セグメント',
        products_column: '製品',
        total_coupon_column: '合計クーポン',
        total_subscriber_column: '総購読者数',
        coupon_name_column: 'クーポン名',
        pgrating_sub_menu: 'PG 評価',
        pgrating_page_breadcrumb: 'PG 評価',
        open_in_a_new_tab_label: '新しいタブで開く',
        column_preference_label: '列の設定',
        parent_label: '親',
        vod_channel_label: 'VODチャンネル',
        overrun_underrun_label: 'オーバーランとアンダーラン',
        copy_count_label: 'コピー数',
        selected_header_label: '選択されたヘッダー',
        selected_count_label: '選択された数',
        platform_column: 'プラットフォーム',
        please_enter_old_password_users_error_message: '古いパスワードを入力してください',
        old_password_does_not_match_error_message: '古いパスワードが一致しません',
        please_enter_new_password_error_message: '新しいパスワードを入力してください',
        confirm_password_do_not_match_error_message: 'パスワードが一致しませんので確認してください',
        old_password_label: '古いパスワード',
        new_password_label: '新しいパスワード',
        account_label: 'アカウント',
        change_password_label: 'パスワードを変更する',
        log_out_label: 'ログアウト',
        media_by_category_menu: 'カテゴリ別メディア',
        movie_label: '映画',
        season_label: '季節',
        view_details_label: '詳細を見る',
        executive_label: 'エグゼクティブ',
        subscriber_label: '購読者',
        confirm_logout_label: 'ログアウトの確認',
        are_you_sure_you_want_to_generate_payment: '支払いを生成してもよろしいですか?',
        yes_label: 'はい',
        no_label: 'いいえ',
        confirm_delete_label: '削除の確認',
        are_you_sure_you_want_to_delete: '削除してもよろしいですか?',
        scheduling_label: 'スケジュール設定',
        planning_label: '企画',
        options_label: 'オプション',
        un_archive_label: 'アーカイブを解除する',
        create_from_label: '作成元',
        category_label: 'カテゴリ',
        select_category_label: 'カテゴリの選択',
        grid_view_label: 'グリッドビュー',
        tile_view_label: 'タイルビュー',
        linear_label: 'リニア',
        non_linear_label: '非線形',
        audit_log_label: '監査ログ',
        entry_date_and_time_column: 'エントリー日時',
        event_column: 'イベント',
        user_column: 'ユーザー',
        close_button_tooltip: '閉じる',
        apply_recursive_button_text_planning: '再帰的な適用',
        history_button_text_planning: '歴史',
        open_schedule_button_text_planning: 'オープンスケジュール',
        insert_program_group_label_planning: 'プログラムグループの挿入',
        export_planner_button_text: 'Export Planner',
        export_epg_button_text: 'Export EPG ',
        planning_loaded_label: '計画がロードされました',
        planning_loading_error_label: '計画ロードエラー',
        error_fetching_planning_data_error_message: '計画データの取得中にエラーが発生しました',
        planning_loading_label: '計画の読み込み',
        creating_label: '作成中',
        successfully_created_group_label: 'グループが正常に作成されました!',
        pasted_label: '貼り付けた',
        items_label: 'アイテム',
        last_updated_from_label_msg: '最終更新日',
        cannot_delete_segment_label_msg: 'セグメントを削除できません',
        cannot_delete_header_label_msg: 'ヘッダーを削除できません。ヘッダーを右クリックしてヘッダーの削除を使用してください',
        select_item_to_error_message: '項目を選択してください',
        cannot_cut_footer_msg_scheduling: 'フッターをカットできません。',
        cannot_delete_multiple_footer_msg_scheduling: '複数のフッターを削除できません。',
        cannot_delete_multiple_footer_please_select_one_footer_at_a_time_msg_scheduling: '複数のフッターを削除することはできません。一度に 1 つのフッターを選択してください。',
        no_item_selected_to_copy_msg_scheduling: 'コピーする項目が選択されていません',
        cannot_copy_segment_msg_scheduling: 'コピーできません - セグメント',
        cannot_copy_break_msg_scheduling: 'コピーできません - 中断します',
        cannot_copy_header_msg_scheduling: 'コピーできません - ヘッダー',
        deleting_footer_msg_scheduling: 'フッターの削除',
        footer_deleted_msg_scheduling: 'フッターが削除されました',
        no_footer_to_deleted_error_message: '削除するフッターがありません',
        all_footer_deleted_error_message: 'すべてのフッターが削除されました',
        there_are_some_at_server_side_please_contact_admin: 'サーバー側にいくつかあります。管理者に問い合わせてください',
        loading_schedule_please_wait_msg_scheduling: 'スケジュールを読み込んでいます。お待ちください...',
        loading_schedule_completed_msg_scheduling: '積み込みスケジュール完了!!',
        please_selct_one_item_msg_scheduling: '項目を 1 つ選択してください',
        no_media_selected_msg_scheduling: 'メディアが選択されていません',
        deleted_secondary_events_msg_scheduling: '削除された二次イベント',
        all_secondary_events_deleted_successfully_msg_scheduling: 'すべての二次イベントが正常に削除されました !!',
        style_sheet_applied_successfully_msg_scheduling: 'スタイルシートが正常に適用されました!!',
        secondary_event_updated_msg_scheduling: '二次イベントを更新しました',
        no_secondary_events_error_message: '二次的なイベントはありません',
        select_target_item_from_schedule_error_message: 'スケジュールから対象項目を選択',
        first_cut_or_copy_item_error_message: '最初のアイテムを切り取るかコピーします。',
        please_select_Item_to_paste_error_message: '貼り付ける項目を選択してください。',
        Please_select_one_Item_where_need_to_paste_error_message: '貼り付ける必要がある項目を 1 つ選択してください。',
        delete_msg: '削除する',
        cut_msg: '削除する',
        cannot_segment_please_unselect_segment_error_message: 'セグメントは削除できません。セグメントの選択を解除してください',
        cannot_delete_header_please_unselect_header_error_message: 'ヘッダーは削除できません。ヘッダーの選択を解除するか、右クリックしてヘッダーを削除するオプションを使用してください。',
        Confirmation_label: '確認',
        are_you_sure_you_want_to_delete_footer_label: 'フッターを削除してもよろしいですか?',
        Are_you_sure_you_want_to_items_label_confirm_alert: '本当によろしいですか',
        cannot_select_footer_error_message: 'フッターを選択できません。',
        cannot_multi_select_items_from_different_headers_error_message: '異なるヘッダーから項目を複数選択することはできません。',
        please_select_first_error_message: '最初に選択してください。',
        cannot_select_items_from_different_headers_error_message: '異なるヘッダーから項目を選択することはできません。',
        please_choose_right_media_categor_error_message: '適切なメディア カテゴリを選択してください',
        prototype_drop_not_allowed_for_headers_error_message: 'ヘッダーではプロトタイプのドロップは許可されません',
        break_type_item_is_not_allowed_error_message: 'ブレークタイプの項目は使用できません。',
        cannot_move_segment_to_different_program_schedule_error_message: 'セグメントを別の番組スケジュールに移動できません',
        prototype_drop_not_allowed_for_headers_and_footers_error_message: 'ヘッダーとフッターではプロトタイプのドロップは許可されません',
        please_select_header_firsts_error_message: '最初にヘッダーを選択してください',
        cannot_delete_selected_header_contains_booked_commercials_error_message: '削除できません!!選択したヘッダーには予約済みのコマーシャルが含まれています',
        cannot_delete_selected_header_contains_reconciled_items_error_message: '削除できません!!選択したヘッダーには調整されたアイテムが含まれています',
        confirm_delete_header_confirm_alert_msg: 'ヘッダーの削除を確認する',
        are_you_sure_you_want_to_delete_confirm_alert_msg: '削除してもよろしいですか',
        select_one_program_to_replace_with_error_message: '置き換えるプログラムを 1 つ選択してください',
        header_from_confirm_alert_msg: 'からのヘッダー',
        please_select_schedule_item_error_message: 'スケジュール項目を選択してください',
        not_allowed_on_this_postion_error_message: 'この投稿では許可されていません',
        please_select_one_item_error_message: '項目を 1 つ選択してください',
        no_secondary_events_attached_to_delete_error_message: '削除対象の二次イベントはありません',
        prototype_drop_not_allowed_for_break_error_message: 'ブレーク中のプロトタイプのドロップは許可されていません',
        added_secondary_events_success_message: '二次イベントを追加しました',
        please_load_schedule_first_error_message: '最初にスケジュールをロードしてください。',
        variations_are_not_available_info_message: 'バリエーションはありません',
        process_completed_success_message: 'プロセスが完了しました',
        select_atleast_one_header_error_message: '少なくとも 1 つのヘッダーを選択してください',
        user_favourite_page_breadcrumb: 'お気に入り',
        please_enter_template_name_to_save_template_error_message: 'Please enter template name to save template',
        rmn_label: 'RMN',
        please_enter_rmn_error_message: 'RMN番号を入力してください',
        expand_collapse_headers_label: 'ヘッダーの展開/折りたたみ',
        pages_label: 'ページ',
        total_product_column: '総製品',
        update_synopsis: 'アップデート概要',
        invalid_time_range: '無効な時間範囲',
        schedule_automatic_break_tooltip: '自動ブレークの作成',
        select_icon_url_collection_header: 'アイコンを選択',
        planningdistributionformat_sub_menu: '企画配信形式',
        planningdistributionformat_page_breadcrumb: '企画配信形式',
        edit_planningdistributionformat_editpage_header: '計画配布フォーマットの編集',
        create_planningdistributionformat_editpage_header: '計画配布フォーマットの作成',
        subtitle_label: 'サブタイトル',
        subtitle_type_label: '字幕の種類',
        please_select_segment_type_error_message: 'セグメントタイプを選択してください',
        audio_track_label: 'オーディオトラック',
        track_number_label: 'トラック番号',
        add_language_group_prototype_button_tooltip: '言語グループの追加',
        add_language_group_prototype_button_text: '言語グループの追加',
        please_enter_track_number_error_message: 'トラック番号を入力してください',
        please_select_atleast_one_language_error_message: '少なくとも 1 つの言語を選択してください',
        language_already_added_error_message: '言語はすでに追加されています',
        track_number_already_added_error_message: 'トラック番号はすでに追加されています',
        please_select_atleast_one_rule_error_message: '少なくとも 1 つのルールを選択してください',
        update_template_label: 'テンプレートの更新',
        media_category_type_sub_menu: 'メディア カテゴリ タイプ',
        media_sub_category_type_sub_menu: 'メディアのサブカテゴリのタイプ',
        work_order_dashboard: '作業命令',
        todo_tile_label: 'やるべきこと',
        in_progress_tile_label: '進行中',
        done_tile_label: '完了',
        workflow_label: 'ワークフロー',
        notes_label: '注意事項',
        please_select_atleast_one_role_error_message: '少なくとも 1 つの役割を選択してください',
        workflow_dialog_header: 'ワークフローの作成',
        workorder_dialog_header: '作業指示書の作成',
        roles_label: '役割',
        workflow_page_breadcrumb: 'ワークフロー',
        workflow_menu: 'ワークフロー',
        current_status_column: '現在の状況',
        created_date_column: '作成日',
        please_select_workflow_error_message: 'ワークフローを選択してください',
        media_column: 'メディア',
        transmission_label: '送信',
        transmission_column: '送信',
        mamID_label: 'ママID',
        apply_distribution_button_text_planning: '配布計画',
        min_gap_label: '最小ギャップ',
        apply_fix_gap_label: 'ギャップの修正を適用',
        plan_till_label: 'までの計画を立てる',
        max_placement_label: '最大配置',
        valid_days_label: '有効日数',
        retry_gap_label: 'リトライギャップ',
        planning_distribution_label: '企画配信',
        please_enter_minimum_gap_error_message: '最小ギャップを入力してください',
        please_select_plan_till_date_error_message: '日付までのプランを選択してください',
        please_enter_max_placement_error_message: '最大配置を入力してください',
        please_select_days_error_message: '曜日を選択してください',
        please_enter_retry_gap_error_message: '再試行ギャップを入力してください',
        please_select_starting_role_error_message: '開始時の役割を選択してください',
        starting_role_label: '開始時の役割',
        plan_till_date_cannot_be_less_than_original_planned_item_error_message: '計画までの日付を元の計画項目より小さくすることはできません',
        applying_planning_distribution_template_please_wait_planner_status_message: "企画配布テンプレートを適用しています。お待ちください...",
        planning_distribution_template_applied_success_planner_status_message: "計画配布テンプレートが正常に適用されました",
        note_for_parent_select_root_label: '注: 親ノードにはルートを選択します',
        payments_label: '支払い',
        schedule_autofill_button_tooltip: "予約済みコマーシャルの自動入力",
        schedule_reset_all_header_to_nominal_start_time_button_tooltip: "すべてのヘッダーの開始時間を計画された公称時間にリセット",
        work_orders_label: '作業命令',
        role_wise_work_orders_label: '役割に応じた作業命令',
        user_wise_work_orders_label: 'ユーザーに合わせた作業指示',
        select_media_info_message: 'メディアの選択',
        history_label: '歴史',
        booking_details_label: '予約の詳細',
        show_jobs_button_text: '求人を表示',
        please_check_label: 'ご確認ください',
        categories_label: 'カテゴリー',
        job_status_label: 'ジョブステータス',
        invalid_start_date: '無効な開始日です',
        invalid_end_date: '無効な終了日です',
        target_budget_should_be_greater_then_zero: '目標予算はゼロより大きくなければなりません',
        target_spots_should_be_greater_then_zero: 'ターゲット スポットはゼロより大きくなければなりません',
        target_seconds_should_be_greater_then_zero: '目標秒数は負の値より大きくなければなりません',
        please_select_date_format_error_message: '日付形式を選択してください',
        no_data_schedule_to_save_scheduling_reconciliation_error_message: 'データが見つからないスケジュール',
        no_data_asrun_to_save_scheduling_reconciliation_error_message: 'データが見つかりませんでした',
        reset_password_label: 'パスワードのリセット',
        date_column_is_not_present_in_this_csv_file_label: 'この CSV ファイルには日付列が存在しません',
        time_column_is_not_present_in_this_csv_file_label: 'この CSV ファイルには時間列が存在しません',
        house_number_column_is_not_present_in_this_csv_file_label: 'この CSV ファイルには HouseNumber 列が存在しません',
        user_favourite_add_button_title: 'お気に入りの追加',
        user_favourite_menu: 'お気に入り',
        user_favorite_menu_dropdown_label: 'メニュー',
        user_favorite_menu_text_label: '名前',
        please_select_user_favourite_menu_error_message: 'メニューを選択してください',
        please_select_user_favourite_name_error_message: '名前を入力してください',
        vodtype_label: 'VODの種類',
        replace_existing_planning_label: '既存の計画を置き換える',
        region_column: '地域',
        live_events_menu: 'ライブイベント',
        vodtype: 'VODの種類',
        version_sub_menu: 'バージョン',
        version_page_breadcrumb: 'バージョン',
        spot_can_not_be_negative_error_message: 'スポットをマイナスにすることはできません',
        rate_can_not_be_negative_error_message: 'レートをマイナスにすることはできません',
        please_add_booking_first_booking_error_message: 'まず予約を追加してください',
        transfer_from_and_transfer_to_are_same_date_error_message: '同日振込不可',
        tournament_dialog_header: 'トーナメントの作成',
        live_match_dialog_header: '一致の作成',
        no_booking_data_error_message: '予約データが見つかりません!',
        ott_assets_video: 'ビデオ',
        ott_assets_poster: 'ポスター',
        update_successfully_booking_success_toast_message: '予約が正常に更新されました',
        please_select_a_value_to_delete_booking_error_message: '削除する値を選択してください',
        ott_assets_video_url_error_message: 'URLを入力してください',
        LiveEventRound_sub_menu: 'ライブイベントラウンド',
        LiveEventType_sub_menu: 'ライブイベントの種類',
        TournamentType_sub_menu: 'トーナメントの種類',
        commission_negative_value_campaign_error_message: 'コミッションをマイナスにすることはできません',
        discount_negative_value_campaign_error_message: 'マイナスの割引はできません',
        invalid_spots_value_line_no_booking_error_message: '行番号内の負のスポット値',
        channels_not_updated_in_booking_error_message: 'チャネルがライン番号で更新されない',
        attach_media_label: 'メディアを添付する',
        media_episode_localization: 'ローカリゼーション',
        media_episode_id_column: 'メディアエピソードID',
        manage_content_template_sub_menu: 'コンテンツテンプレートの管理',
        fct_can_not_be_negative_error_message: 'FCT を負にすることはできません',
        rate_10_sec_can_not_be_negative_error_message: 'Rate10Sec を負の値にすることはできません',
        amount_can_not_be_negative_error_message: '金額をマイナスにすることはできません',
        booked_spots_scheduled_error_message: '選択した予約の一部はすでにスケジュールで使用されています。',
        booking_line_no: '行番号',
        please_select_import_type_error_message: 'インポートタイプを選択してください',
        optimisation_sun_menu: '最適化',
        optimisation_page_breadcrumb: '最適化',
        booking_date_label: '予約日',
        agency_name_column: '代理店名',
        assurance_type_column: '保証の種類',
        assured_value_column: '保証価値',
        please_select_booking_date_error_message: '予約日を選択してください',
        optimisation_label: '最適化',
        please_show_atleast_one_item_error_message: '少なくとも 1 つの項目を表示してください。',
        please_enter_valid_percentage_error_message: '有効な割合を入力してください',
        campaign_target_seconds_actual_seconds_booking_error: '目標秒数は予約された合計秒数より小さくすることはできません',
        campaign_target_budget_actual_budget_booking_error: '目標予算は予約された予算の合計より小さくすることはできません',
        campaign_target_spots_actual_spots_booking_error: '対象スポットは予約済みスポットの合計より小さくすることはできません',
        assured_value_is_greater_than_total_fct_error_message: '保証値は合計 fct より大きい',
        assured_value_is_less_than_zero_error_message: '保証値はゼロ未満です',
        booking_schedule_status: '予約スケジュールのステータス',
        makegood_column: '良いものにする',
        booked_spots_unique_line_no_selection_error_message: '更新する同じ行番号のスポットを選択してください',
        booking_file_import_error_message: 'ファイルからデータを読み取ることができません。エラー -',
        spot_status_column: 'ステータス',
        booking_transfer_from_date_greater_than_transfer_to_date_error_message: '転送開始日を転送日より大きくすることはできません',
        spot_time_from_time_to_error_message: 'From time は to time よりも短くする必要があります',
        material_type_label: '材質の種類',
        cancreatedeal_label: '取引を作成できます',
        please_enter_material_type_error_message: '材質の種類を入力してください',
        automation_type_label: '自動化の種類',
        download_button_text: 'ダウンロード',
        edit_black_out_date_button_tooltip: 'ブラックアウト日の編集',
        add_black_out_date_button_tooltip: 'ブラックアウト日を追加',
        edit_black_out_date_dialog_header: 'ブラックアウトの編集',
        add_black_out_date_dialog_header: 'ブラックアウトを追加する',
        black_out_date_dialog_header: 'ブラックアウトデート',
        please_add_atleast_one_black_out_date_error_message: '除外日を少なくとも 1 つ追加してください',
        update_successfully_grid_data_success_toast_message: '正常に更新されました',
        black_out_channel_column: 'ブラックアウトチャンネル',
        black_out_start_date_column: 'ブラックアウト開始日',
        black_out_end_date_column: 'ブラックアウト終了日',
        black_out_date_should_be_within_publishing_dates_range_error_message: '除外日は公開日の範囲内である必要があります',
        some_bookings_are_out_of_campaign_date_range_could_not_transfer_error_message: '一部の予約はキャンペーン期間外のため、転送できませんでした',
        report_menu: 'レポート',
        interstitial_history_sub_menu: 'インタースティシャル履歴',
        interstitial_history_report_dialog_header: 'インタースティシャル履歴レポート',
        client_agency_booking_report_sub_menu: 'クライアント代理店予約レポート',
        primary_channel_column: 'プライマリチャネル',
        order_date_error_message: '注文日は期間開始日よりも前の日付である必要があります',
        please_select_tournament_type: 'トーナメントの種類を選択してください',
        please_enter_tournament_ID: 'トーナメントIDを入力してください',
        tournament_type_label: 'トーナメントの種類',
        tournament_ID_label: 'トーナメントID',
        as_run_label: '実行中',
        schedule_label: 'スケジュール',
        update_booking_multiple_dialog_header: '予約を更新する',
        commercial_duration_lable: '期間',
        no_as_run_found_error_message: 'AsRun が見つかりませんでした',
        copy_from_and_copy_to_date_range_should_be_same: "(コピー元) 選択した日は、(コピー先) 選択した日と同じである必要があります。",
        exclusive_label: '独占的',
        exclusive_start_date_column: '独占開始日',
        exclusive_end_date_column: '独占終了日',
        technical_details_prototype_sub_menu: '技術詳細 プロトタイプ',
        technical_details_prototype_page_breadcrumb: '技術詳細 プロトタイプ',
        audio_codec_page_breadcrumb: 'オーディオコーデック',
        video_codec_page_breadcrumb: 'ビデオコーデック',
        delivery_method_page_breadcrumb: '配送方法',
        video_aspect_ratio_page_breadcrumb: 'ビデオのアスペクト比',
        video_type_page_breadcrumb: 'ビデオの種類',
        audio_codec_sub_menu: 'オーディオコーデック',
        video_codec_sub_menu: 'ビデオコーデック',
        delivery_method_sub_menu: '配送方法',
        video_aspect_ratio_sub_menu: 'ビデオのアスペクト比',
        video_type_sub_menu: 'ビデオの種類',
        is_exclusive_column: '独占的です',
        ref_off_setting_label: 'オフセット設定',
        offset_time_minus_label: 'オフセット時間マイナス',
        offset_time_plus_label: 'オフセットタイムプラス',
        ignore_duration_lable: '無視期間',
        reference_no_label: '参照番号',
        please_enter_reference_no_error_message: '参照番号を入力してください',
        create_technical_details_prototype_header_dialog: '技術詳細プロトタイプの作成',
        audio_codec_label: 'オーディオコーデック',
        video_codec_label: 'ビデオコーデック',
        video_aspect_ratio_label: 'ビデオのアスペクト比',
        delivery_method_label: '配送方法',
        is_quality_checked_label: '品質はチェックされていますか',
        enable_caption_label: 'キャプションを有効にする',
        distributer_label: '販売代理店',
        please_select_audio_codec_error_message: 'オーディオコーデックを選択してください',
        please_select_video_codec_error_message: 'ビデオコーデックを選択してください',
        please_select_delivery_method_error_message: '配送方法を選択してください',
        please_select_video_aspect_ratio_error_message: 'ビデオのアスペクト比を選択してください',
        please_select_video_type_error_message: 'ビデオの種類を選択してください',
        offsetsetting_dialog_header: 'オフセット設定',
        please_enter_OffSet_Time_Minus_error_message: 'オフセット時間マイナスを入力してください',
        please_enter_offSet_time_plus_error_message: 'オフセット時間プラスを入力してください',
        booking_schedule_status_sub_menu: '予約スケジュールのステータス',
        edit_multiple_tooltip: '複数の編集',
        select_commercial_error_message: 'コマーシャルを選択してください',
        invalid_spotRate_error_message: '有効なスポットレートを入力してください',
        invalid_rate10Sec_error_message: '有効なレート 10 秒を入力してください',
        please_select_atleast_one_value_to_update_error_message: '更新する値を少なくとも 1 つ選択してください',
        rate_10_sec_column: 'レート10秒',
        missing_media_report_dialog_header: 'メディア欠落レポート',
        missing_media_report_sub_menu: 'メディア欠落レポート',
        schedule_date_label: '予定日',
        please_select_schedule_date_error_message: '予定日を選択してください',
        mam_assets_sub_menu: 'ママアセット',
        mamassets_page_breadcrumb: 'ママアセット',
        create_mamasset_dialog_header: 'MamAsset の作成',
        please_enter_programeditstatus_error_message: 'プログラム編集ステータスを入力してください',
        end_time_label: '終了時間',
        program_edit_status_label: 'プログラム編集ステータス',
        tx_ready_label: '送信準備完了',
        subtitle_availble_label: '字幕あり',
        censorship_report_available_label: '検閲レポートが利用可能',
        qcpass_label: 'QCパス',
        please_enter_valid_end_time_message: '有効な終了時刻を入力してください',
        please_enter_valid_actual_duration_message: '有効な実際の期間を入力してください',
        time_in_label: 'タイムイン',
        time_out_label: 'タイムアウト',
        commercial_limit_label: '商用制限',
        please_enter_valid_commercial_limit_error_message: '有効な商用制限を入力してください',
        contract_number_column: '契約番号',
        duration_should_be_greater_than_zero_error_message: '期間はゼロより大きくなければなりません',
        number_of_episode_can_be_greater_than_zero_error_message: `エピソード数はゼロより大きくなければなりません`,
        staring_episode_can_be_greater_than_zero_error_message: `開始エピソードはゼロより大きくなければなりません`,
        segment_qc_page_header: 'セグメントQC',
        segment_qc_button_tooltip: 'セグメントQC',
        media_title_label: 'メディアタイトル',
        qc_status_label: '品質管理ステータス',
        frame_rate_label: 'フレームレート',
        note_label: '注記',
        please_select_qc_status_error_message: 'QCステータスを選択してください',
        please_enter_note_error_message: '注記を入力してください',
        please_select_frame_rate_error_message: 'フレームレートを選択してください',
        please_enter_positive_value_in_pin_code_error_message: 'Pincode に正の値を入力してください',
        please_enter_commission_error_message: 'コミッションを入力してください',
        please_enter_discount_error_message: '割引を入力してください',
        please_configure_checklist_preference_error_message: 'チェックリストの設定を行ってください。',
        preference_saved_successfully: '設定が正常に保存されました !!',
        please_select_csv_file_error_message: 'csvファイルを選択してください！',
        cannot_delete_channel_campaign_already_has_booking_error_message: "すでに予約されているチャンネル キャンペーンを削除できません",
        cannot_delete_commercial_campaign_already_has_booking_error_message: "すでに予約されているコマーシャル キャンペーンは削除できません",
        ref_change_rate10sec_label: '変化率10秒',
        change_rate10sec_dialog_header: '変化率10秒',
        change_rate10sec_label: '変化率10秒',
        import_pdf_file: 'PDF ファイルをインポートする',
        please_select_atleast_one_media_category_type_error_message: 'メディア カテゴリ タイプを少なくとも 1 つ選択してください',
        please_select_episode_content_error_message: 'エピソードのコンテンツを選択してください',
        iso_code_label: 'ISOコード',
        google_api_code_label: 'Google APIコード',
        create_language_dialog_header: '言語の作成',
        please_enter_iso_code_error_message: 'ISOコードを入力してください',
        please_enter_google_api_code_error_message: 'Google APIコードを入力してください',
        click_here_to_check_ISO_code_error_message: 'ISOコードを確認するにはここをクリックしてください',
        booking_update_successfully: '予約が正常に更新されました',
        cast_Type_page_breadcrumb: 'キャストタイプ',
        cast_Type_sub_menu: 'キャストタイプ',
        spots_out_of_campaign_date_range_error_message: 'キャンペーン期間外のスポットもございます。ご確認ください',
        import_pdf_booking_file: 'PDF予約をインポート',
        import_booking_label: 'インポート予約',
        download_template_label: 'テンプレートをダウンロード',
        export_saved_booking_label: ' Export Saved Booking',
        export_current_booking_label: ' Export Current Booking',
        planning_is_locked_on_some_days_in_this_date_range: 'この日付範囲の一部の日に計画がロックされています',
        payment_schedule_label: '支払いスケジュール',
        promotional_excerpts_label: 'プロモーションの抜粋',
        governing_laws_label: '準拠法',
        add_linear_page_header: 'リニアを追加',
        add_linear_button_tooltip: 'リニアを追加',
        amount_should_be_negative_error_message: '金額をマイナスにすることはできません',
        currency_column: "通貨",
        total_booked_spots_label: '予約済みスポット',
        total_booked_seconds_label: '予約された秒数',
        booking_exceeded_target_budget: '目標予算を超えています。更新してもう一度お試しください。',
        booking_exceeded_target_seconds: '目標秒数を超えています。更新して再試行してください',
        booking_exceeded_target_amount: '目標金額を超えています。更新してもう一度お試しください。',
        broadcaster_id_label: '放送者ID',
        restriction_label: '制限事項',
        create_restriction_dialog_header: '制限の作成',
        dynamic_rules_label: '動的ルール',
        censorship_details_label: '検閲の詳細',
        term_label: '規約',
        reason_label: '理由',
        hold_all_payment_label: 'すべての支払いを保留する',
        generate_payment_button_text: '支払いの生成',
        contract_payment_schedule_dialog_header: '契約支払いスケジュール',
        generate_payment_schedule_dialog_header: '支払いスケジュールの生成',
        due_date_label: '期限',
        interest_rate_label: '金利',
        no_of_installment_label: '分割払い回数',
        recurring_label: '繰り返し発生する',
        due_date_column: '期限',
        due_amount_column: '支払額',
        approve_status_column: '承認ステータス',
        amount_paid_column: '支払った金額',
        balance_amount_column: '残高',
        please_select_recurring_error_message: '定期的なものを選択してください',
        interest_rate_should_be_negative_error_message: '金利はマイナスになるはず',
        no_of_installment_should_be_greater_than_zero_error_message: '分割払い回数はゼロより大きくなければなりません',
        generate_payment_label: '支払いの生成',
        are_you_sure_you_want_to_generate_payment_schedule: '支払いスケジュールを再生成してもよろしいですか?',
        amount_paid_label: '支払った金額',
        approve_status_label: '承認ステータス',
        remark_column: '備考',
        edit_contract_title_button_text: '契約タイトルの編集',
        edit_black_out_date_button_text: 'ブラックアウト日の編集',
        delete_contract_title_button_text: '契約タイトルの削除',
        classification_label: '分類',
        cut_tc_in_label: 'カット Tc イン (hh:mm:ss:ff)',
        cut_tc_out_label: 'Tc アウト (hh:mm:ss:ff) をカット',
        done_date_label: '完了日',
        result_label: '結果',
        officer_label: '役員',
        cut_label: 'カット',
        classification_column: '分類',
        cut_tc_in_column: 'カットイン',
        cut_tc_out_column: 'Tc アウトをカットする',
        done_date_column: '完了日',
        reference_no_column: '参照番号',
        result_column: '結果',
        officer_column: '役員',
        cut_column: 'カット',
        create_censorship_details_dialog_header: '検閲の詳細を作成する',
        please_enter_valid_value_cut_tcin_error_message: '有効なCutTcInを入力してください',
        can_not_delete_error_message: 'ダッシュボードを正しく削除できません',
        add_brand_button_tooltip: 'ブランドの追加',
        add_product_button_tooltip: '製品の追加',
        ratecard_page_breadcrumb: '料金表',
        ratecard_sun_menu: '料金表',
        create_ratecard_dialog_header: '料金表の作成',
        rate_10sec_label: 'レート 10 秒',
        please_enter_time_in_error_message: '時間を入力してください',
        please_enter_time_out_error_message: 'タイムアウトを入力してください',
        view_label: '見る',
        other_option_label: 'その他のオプション',
        prime_time_label: 'プライムタイム',
        no_rights_scheduling_error_message: 'スケジュール権限なし',
        used_to_configure_prefix_suffix_and_incremental_next_number_for_assetid_tooltip: 'これは、アセット ID のプレフィックス サフィックスと増分次の番号を構成するために使用されます。',
        sales_executive_label: '営業担当役員',
        please_select_sales_executive_error_message: '営業担当者を選択してください',
        material_content_page_breadcrumb: 'マテリアルコンテンツ',
        material_content_sub_menu: 'マテリアルコンテンツ',
        added_by_column: '追加者',
        modified_by_column: '変更者',
        show_history_button_text: '履歴の表示',
        successfully_download_success_message: '正常にダウンロードされました',
        top_5_sales_executive_label: 'トップ 5 の営業担当役員',
        add_job_url_button_tooltip: 'ジョブ URL を追加',
        checklist_preference_label: 'チェックリストの設定',
        select_playback_url_header: '再生URLを選択',
        duration_mismatch_error_message: '期間の不一致',
        no_invoice_details_are_available_to_preview_bill_error_message: 'プレビューできる請求書の詳細はありません。',
        selected_commercial_label: '選択されたコマーシャル',
        no_data_schedule_to_download_error_message: 'ダウンロードするデータスケジュールがありません',
        from_date_can_not_be_less_than_campaign_start_date_error_message: '開始日はキャンペーン開始日より前にすることはできません',
        to_date_can_not_be_greater_than_campaign_end_date_error_message: '現在までの日付はキャンペーン終了日以降にすることはできません',
        cancel_invoice_waiting_message: '請求書をキャンセルしています。お待ちください...',
        series_dialog_header: 'シリーズ',
        manage_content_template_breadcrumb: 'コンテンツテンプレートの管理',
        ottmenu_sub_menu: 'メニュー',
        ottmenu_page_breadcrumb: 'メニュー',
        cardlist_pages_menu_title: 'ページ',
        select_pages_header_collection: 'ページ',
        ottmenu_title_editpageheader: 'メニュー',
        sidefixmenu_rails_pages_tooltip: 'ページ',
        atleast_attach_one_ott_pages_rails_error_message: '少なくとも 1 ページを添付してください',
        menu_type_label: 'メニューの種類',
        team_a_label: 'チームA',
        team_b_label: 'チームB',
        round_label: 'ラウンド',
        bottom_menu_sub_menu: '下部メニュー',
        bottom_menu_page_breadcrumb: '下部メニュー',
        top_menu_sub_menu: 'トップメニュー',
        top_menu_page_breadcrumb: 'トップメニュー',
        please_select_asset_type_to_media_asset_error_message: 'アセットタイプからメディアアセットを選択してください',
        multi_versioning_tooltip_button: 'マルチバージョン管理',
        title_view_tooltip_button: 'タイトルビュー',
        close_title_view_tooltip_button: 'タイトルビューを閉じる',
        sidefix_episode_tooltip: 'エピソード',
        please_select_valid_start_date_error_message: '有効な開始日を選択してください',
        please_select_valid_end_date_error_message: '有効な終了日を選択してください',
        please_select_exclusive_start_date_error_message: '独占開始日を選択してください',
        please_select_exclusive_end_date_error_message: '独占終了日を選択してください',
        please_select_start_date_smaller_than_end_date_media_episode_publishing_error_message: '開始日は終了日よりも前の日付にする必要があります',
        amount_paid_can_not_be_negative_error_message: '支払った金額をマイナスにすることはできません',
        print_button_tooltip: '印刷する',
        print_telecast_certificate_in_pdf_button_tooltip: 'テレビ放送証明書を PDF で印刷',
        print_telecast_certificate_in_excel_button_tooltip: 'テレビ放送証明書を Excel で印刷する',
        cancel_invoice_button_tooltip: '請求書のキャンセル',
        campagn_type_page_breadcrumb: 'キャンペーンの種類',
        deal_type_page_breadcrumb: '取引タイプ',
        location_page_breadcrumb: '場所',
        campaigntype_sub_menu: 'キャンペーンの種類',
        dealtype_sub_menu: '取引タイプ',
        location_sub_menu: '場所',
        ott_setting_sub_menu: '設定',
        ott_setting_page_breadcrumb: '設定',
        application_name_label: 'アプリケーション名',
        logo_label: 'ロゴ',
        logo_position_label: 'ロゴの位置',
        pi_page_template_label: 'PiPage テンプレート',
        show_bottom_menu_label: '下部メニューを表示',
        home_page_label: 'ホームページ',
        show_hamburger_menu_label: 'ハンバーガーメニューを表示',
        image_cdn_base_url_label: '画像 CDN ベース URL',
        video_cdn_base_url_label: 'ビデオ CDN ベース URL',
        image_cdn_credentials_label: '画像 CDN 認証',
        video_cdn_credentials_label: 'ビデオ CDN 認証',
        key_name_label: 'キー名',
        key_value_label: 'キー値',
        add_image_cdn_credentials_dialog_header: '画像を追加 CDN CRED',
        add_video_cdn_credentials_dialog_header: 'ビデオ CDN CRED を追加',
        please_enter_key_name_error_messgae: 'キー名を入力してください',
        please_enter_key_value_error_message: 'キー値を入力してください',
        settings_label: '設定',
        please_enter_application_name_error_message: 'アプリケーション名を入力してください',
        please_select_logo_error_message: 'ロゴを選択してください',
        please_select_logo_position_error_message: 'ロゴの位置を選択してください',
        please_select_pi_page_template_error_message: 'PiPage テンプレートを選択してください',
        please_select_home_page_error_message: 'ホームページを選択してください',
        please_select_theme_error_message: 'テーマを選択してください',
        please_enter_image_cdn_base_url_error_message: '画像 CDN ベース URL を入力してください',
        please_enter_video_cdn_base_url_error_message: 'ビデオ CDN ベース URL を入力してください',
        icon_label: 'アイコン',
        please_select_icon_error_message: 'アイコンを選択してください',
        please_select_hamburger_menu_error_message: `ハンバーガーメニューを選択してください`,
        hamburger_menu_label: 'ハンバーガーメニュー',
        select_package_header: 'パッケージの選択',
        please_select_package_error_message: 'パッケージを選択してください',
        vod_type_validation_error_message: `VOD タイプ FREE は AVOD のみで適用可能`,
        server_health_sub_menu: 'サーバーの状態',
        server_health_page_breadcrumb: 'サーバーの状態',
        text_number_can_not_be_negative_error_message: 'テキスト番号を負にすることはできません',
        prelog_postlog_report_sub_menu: '前後ログレポート',
        pre_log_report_title_button: 'プレログレポート',
        post_log_report_title_button: 'ポストログレポート',
        download_pre_log_report_tooltip_button: 'プレログレポートのダウンロード',
        download_post_log_report_tooltip_button: 'ポストログレポートをダウンロードする',
        credit_line_report_sub_menu: 'クレジットラインレポート',
        download_credit_line_report_tooltip_button: 'クレジットラインレポートのダウンロード',
        please_select_date_error_message: '日付を選択してください',
        logo_size_label: 'ロゴのサイズ',
        application_color_label: 'アプリケーションの色',
        purge_Spot_report_sub_menu: 'パージスポットレポート',
        download_purge_Spot_report_tooltip_button: 'パージスポットレポートのダウンロード',
        download_client_agency_booking_report_tooltip_button: 'クライアント代理店予約レポートのダウンロード',
        download_purge_spot_report_tooltip_button: 'パージスポットレポートのダウンロード',
        client_agency_booking_report_header: 'クライアント代理店予約レポート',
        pre_post_log_report_header: '前後ログレポート',
        credit_line_report_header: 'クレジットラインレポート',
        purge_spot_report_header: 'パージスポットレポート',
        interstitial_history_report_header: 'インタースティシャル履歴レポート',
        download_interstitial_history_report_tooltip_button: 'インタースティシャル履歴レポートのダウンロード',
        telecast_certificate_details_not_found_error_message: "テレビ放送の詳細が見つかりません",
        air_time_consumption_report_sub_menu: '通信時間消費レポート',
        download_air_time_consumption_report_tooltip_button: '通信時間消費レポートのダウンロード',
        air_time_consumption_report_header: '通信時間消費レポート',
        prototypecontent_sub_menu: 'プロトタイプのコンテンツ',
        prototypecontent_page_breadcrumb: 'プロトタイプのコンテンツ',
        create_prototypecontent_dialog_header: 'プロトタイプコンテンツの作成',
        please_enter_max_length_error_message: '最大長を入力してください',
        manual_prototype_id_label: 'マニュアルID',
        prototype_id_label: 'ID',
        error_while_generating_prototype_number_error_message: 'プロトタイプ番号の生成中にエラーが発生しました',
        refresh_generated_segments_tooltip: '生成されたセグメントを更新する',
        generated_segments_selected_segmentType_mismatch_error_message: '生成されたセグメントの数が選択したセグメント タイプと同じではありません',
        materialID_mediaID_mismatch_generated_segment_error_message: 'マテリアル ID は生成されたセグメントの MediaID と同じではありません。更新してください。',
        please_select_subtitle_type_error_message: '字幕の種類を選択してください',
        number_of_generated_segments_is_not_same_as_selected_segment_Type_error_message: '生成されたセグメントの数が選択したセグメント タイプと同じではありません',
        select_material_content_first_error_message: '最初にマテリアルコンテンツを選択してください',
        segment_already_exist_with_same_material_id_and_segment_type_error_message: '同じマテリアル ID とセグメント タイプのセグメントがすでに存在します',
        amazon_delivery_group_page_breadcrumb: 'アマゾン配送グループ',
        amazon_delivery_group_sub_menu: 'アマゾン配送グループ',
        amazon_delivery_group_edit_page_header: 'アマゾン配送グループ',
        tv_preview_label: 'テレビのプレビュー',
        mobile_preview_label: 'モバイルプレビュー',
        ditribute_by_percentage_label: '%で分配',
        ditribute_by_percentage_error_message: '選択した商用流通%の合計は100である必要があります',
        select_commercial_for_booking_error_message: '予約するコマーシャルを少なくとも 1 つ選択してください',
        distribute_selected_equal_lable: '選択したものを均等に分配',
        feature_label: '特長',
        select_secondary_event_error_message: '最初に二次イベントを選択してください',
        delete_secondary_event_tooltip: '選択した二次イベントを削除',
        select_campaign_header_dialog: 'キャンペーンを選択',
        select_pages_header_dialog: 'ページの選択',
        display_name_column: '表示名',
        spot_separation_label: 'スポット分離',
        please_enter_valid_spot_separation_error_message: '有効なスポット間隔を入力してください',
        ott_package_delivery_schedule_menu: 'オット荷物お届けスケジュール',
        service_menu: 'サービス',
        ott_package_delivery_schedule_page_breadcrumb: 'オット荷物お届けスケジュール',
        schedule_delivery_button_tooltip: '配達のスケジュールを設定する',
        schedule_delivery_button_text: '配達のスケジュールを設定する',
        schedule_delivered_successfully_success_message: 'スケジュールが正常に配信されました',
        schedule_auto_fill_interstitial_page_breadcrumb: 'インタースティシャルの自動入力をスケジュールする',
        schedule_auto_fill_interstitial_sub_menu: 'インタースティシャルの自動入力をスケジュールする',
        schedule_auto_fill_interstitial_edit_page_header: 'インタースティシャルの自動入力をスケジュールする',
        interstitial_label: 'インタースティシャル',
        filler_label: 'フィラー',
        music_label: '音楽',
        new_subscriber_in_week_label: '週の新規登録者数',
        no_pack_users_label: 'パックユーザーがいません',
        users_subscription_expiring_in_current_week_label: '今週中にユーザーの有効期限が切れます',
        user_by_plan_label: 'プランごとのユーザー',
        media_asset_label: 'メディア資産',
        vod_label: 'VOD',
        dummy_page_breadcrumb: 'ダミー',
        dummy_sub_menu: 'ダミー',
        ref_attach_formats_label: '添付フォーマット',
        format_attached_success_message: 'フォーマットが正常に接続されました',
        ref_delete_formats_label: 'すべてのフォーマットを削除',
        formats_deleted_success_message: 'すべてのフォーマットが正常に削除されました',
        insert_break_label: 'ブレークの挿入',
        slot_duration_label: 'スロット期間',
        please_enter_slot_duration_error: 'スロット期間を入力してください',
        actual_duration_slot_duration_format_error_message: '実際の期間はスロット期間を超えることはできません',
        total_amount_is_smaller_than_amount_paid_error_message: '合計金額が支払金額より小さい',
        is_dummy_label: 'ダミーです',
        downloading_log_report_label: 'ログレポートのダウンロード',
        bill_generate_label: '請求書の生成',
        contract_run_report_button_tooltip: '契約実行レポート',
        contract_run_report_label: '契約実行レポート',
        total_run_column: 'トータルラン',
        preview_button_tooltip: 'プレビュー',
        preview_image_title_label: 'プレビュー画像',
        poster_dimension_title_label: 'ポスターの寸法',
        show_poster_dimension_title_label: 'ポスターの寸法を表示',
        mam_asset_report_sub_menu: 'マムアセットレポート',
        mam_asset_report_page_breadcrumb: 'マムアセットレポート',
        schedule_duration_column: 'スケジュール期間',
        mam_duration_column: 'ママの期間',
        total_column: '合計',
        schudule_column: 'スケジュール',
        pending_colun: '保留中',
        tomorrow_pending_booking_status_label: '明日の予約保留状況',
        pending_approval_sun_menu: '承認待ち',
        pending_approval_page_breadcrumb: '承認待ち',
        approve_button_text: '承認する',
        reject_button_text: '拒否する',
        booking_status_updated_successfully: '予約ステータスが正常に更新されました',
        total_segment_duration_lable: '合計セグメント期間',
        other_label: 'その他',
        comment_label: 'コメント',
        please_enter_comment_error_message: 'コメントを入力してください',
        unpurged_label: 'パージされていない',
        please_add_deeplink_in_video_list_error_message: '動画リストにディープリンクを追加してください',
        please_attach_atleast_one_video_error_message: '少なくとも 1 つのビデオを添付してください',
        please_attach_atleast_one_poster_error_message: 'ポスターを少なくとも1枚添付してください',
        deeplink_url_label: 'ディープリンク URL',
        rental_wholesale_price_label: 'レンタル卸価格',
        rental_retail_price_label: 'レンタル小売価格',
        actual_on_air_column: '実際のオンエア',
        nominal_on_air_column: '公称オンエア',
        parent_series_code_label: '親シリーズのコード',
        series_code_label: 'シリーズコード',
        duration_only_label: '期間',
        reference_code_label: 'リファレンスコード',
        material_type_column: '材質の種類',
        break_configuration_page_breadcrumb: '設定を解除する',
        break_configuration_sub_menu: '設定を解除する',
        create_break_configuration_dialog_header: 'ブレーク構成の作成',
        please_select_atleast_one_allow_media_category_type_error_message: '許可するメディア カテゴリ タイプを少なくとも 1 つ選択してください',
        please_select_atleast_one_day_error_message: '少なくとも 1 日を選択してください',
        please_enter_from_time_label: '開始時刻を入力してください',
        please_enter_to_time_label: '時間を入力してください',
        fct_should_be_greater_than_zero_error_message: 'FCT はゼロより大きくなければなりません',
        from_time_should_be_less_than_To_time_error_message: 'From time は to time よりも短くする必要があります',
        to_date_should_be_greater_than_from_date_error_message: '終了日は開始日よりも大きい必要があります',
        fct_already_exists_error_message: 'FCT は同じチャネル/時間範囲/日数にすでに存在します',
        fct_should_not_be_greater_than_campaign_target_seconds_error_message: 'FCT はキャンペーンの目標秒数を超えてはなりません',
        sort_by_label: '並べ替え基準',
        billing_summary_report_sub_menu: '料金概要レポート',
        no_scheduling_found_auto_fill_commercial_error: 'スケジュールが見つかりません',
        no_break_item_found_auto_fill_commercial_error: 'この日は休憩アイテムは予定されていません',
        no_booked_spot_found_auto_fill_commercial_error: '予約したスポットは利用できません',
        save_bill_button_text: '請求書の保存',
        save_bill_button_tooltip: '請求書の保存',
        preview_button_text: 'プレビュー',
        parent_series_lable: '親シリーズ',
        ott_setting_label: 'オットの設定',
        bottom_menu_label: '下部メニュー',
        series_only_label: 'シリーズ',
        add_insert_break_label: '挿入区切りを追加',
        playlist_lock_status_sub_menu: 'プレイリストのロックステータス',
        playlist_lock_page_breadcrumb: 'プレイリストのロックステータス',
        generate_pdf_message: 'PDF を生成中です。お待ちください...',
        generate_pdf_successfully_message: 'PDF が正常に生成されました',
        payment_received_label: '支払いを受領しました',
        payment_received_button_tooltip: '支払いを受領しました',
        payment_received_button_text: '支払いを受領しました',
        print_button_text: '印刷する',
        to_txt_button_toolip: 'TXTへ',
        to_txt_button_text: 'TXTへ',
        pdf_button_text: 'PDF',
        excel_button_text: 'エクセル',
        received_date_label: '受信日',
        payment_mode_label: '支払いモード',
        cheque_no_label: 'チェックNo.',
        payment_received_successfully: '支払いが正常に受領されました',
        is_paymnet_received_column: '支払いは受領されましたか',
        payment_received_date_column: '支払い受領日',
        payment_mode_column: '支払いモード',
        cheque_no_column: 'チェックNo.',
        payment_already_received_error_message: '支払いはすでに受領済みです',
        please_select_received_date_error_message: '受信日を選択してください',
        please_select_payment_mode_error_message: '支払いモードを選択してください',
        please_enter_cheque_no_error_message: '小切手番号を入力してください。',
        booked_commercial_label: '予約済みコマーシャル',
        booked_announcement_label: '予約済みのお知らせ',
        announcement_label: 'お知らせ',
        export_commercial_break_playlist_button_tooltip: 'Export Commercial Break Playlist',
        credit_line_report_page_breadcrumb: 'クレジットラインレポート',
        brand_column: 'ブランド',
        time_range_column: '時間範囲',
        schedule_spot_column: 'スケジュールスポット',
        total_duration_column: '合計所要時間',
        booking_schedule_status_header: '予約スケジュールのステータス',
        no_data_found_for_selected_filter_error_message: '選択したフィルターのデータが見つかりません!',
        artist_label: 'アーティスト',
        please_enter_artist_error_message: 'アーティストを入力してください',
        announcement_reconcile_sun_menu: 'アナウンス調整',
        announcement_reconcile_page_breadcrumb: 'アナウンス調整',
        edit_header_dialog: '編集',
        actual_on_air_label: '実際のオンエア',
        reconciled_successfully_message: '和解に成功しました',
        reconcile_label: '和解する',
        please_enter_actualonair_error_message: 'ActualOnAir を入力してください',
        please_select_atleast_one_saleteam_error_message: '少なくとも 1 つの営業チームを選択してください',
        export_announcement_tooltip: 'Export Announcement',
        export_jazzler_automation_playlist: 'Export Jazzler Commercial Break',
        point_of_contact_label: '連絡先',
        please_enter_point_of_contact_error_message: '連絡先を入力してください',
        please_enter_pin_code_error_message: 'PINコードを入力してください',
        epg_menu: 'EPG',
        epg_channel_sub_menu: 'チャンネル',
        epg_channel_page_breadcrumb: 'チャンネル',
        create_channel_dialog_header: 'チャンネルの作成',
        please_enter_image_url_error_message: '画像の URL を入力してください',
        faq_category_page_breadcrumb: 'よくある質問のカテゴリ',
        faq_category_sub_menu: 'よくある質問のカテゴリ',
        faq_page_breadcrumb: 'よくある質問',
        faq_sub_menu: 'よくある質問',
        please_select_faq_Category_error_message: 'カテゴリを選択してください',
        faq_category_label: 'よくある質問のカテゴリ',
        question_label: '質問',
        answer_label: '答え',
        please_enter_question_error_message: '質問を入力してください',
        please_enter_answer_error_message: '答えを入力してください',
        select_a_category_column: 'カテゴリを選択してください',
        faqs_column: 'よくある質問',
        faqs_dailog_header: 'よくある質問',
        faqs_page_breadcrumb: 'よくある質問',
        top_news_menu: 'トップニュース',
        top_news_page_breadcrumb: 'トップニュース',
        favorite_channel_sub_menu: 'お気に入りのチャンネル',
        favorite_channel_page_breadcrumb: 'お気に入りのチャンネル',
        create_favorite_channel_dialog_header: 'お気に入りのチャンネルを作成する',
        logo_column: 'ロゴ',
        please_select_atleast_one_channel_error_message: '少なくとも 1 つのチャンネルを選択してください',
        tutorial_videos_page_breadcrumb: 'チュートリアルビデオ',
        tutorial_videos_sub_menu: 'チュートリアルビデオ',
        summary_label: '概要',
        playback_url_label: '再生URL',
        create_tutorial_videos_dialog_header: 'チュートリアルビデオを作成する',
        please_enter_summary_error_message: '概要を入力してください',
        please_enter_playback_url_error_message: '再生URLを入力してください',
        create_top_news_dialog_header: 'トップニュースの作成',
        source_id_label: 'ソースID',
        featured_image_url_label: '注目の画像の URL',
        image_caption_label: '画像キャプション',
        time_stamp_label: 'タイムスタンプ',
        pull_latest_top_news_button_tooltip: '最新のトップニュースを取得',
        thumbnail_url_label: 'サムネイルのURL',
        please_enter_thumbnail_url_error_message: 'サムネイルの URL を入力してください',
        please_enter_source_id_error_message: 'ソースIDを入力してください',
        please_enter_image_caption_error_message: '画像のキャプションを入力してください',
        header_address_label: 'ヘッダーアドレス',
        footer_address_label: 'フッターアドレス',
        ok_label: 'OK',
        cancel_label: 'キャンセル',
        session_expired_please_login_again_label: 'セッションが期限切れになりました。再度ログインしてください',
        please_select_episodes_first: `最初にエピソードを選択してください`,
        successfully_saved_updated_message: '正常に保存/更新されました !!!',
        please_select_all_platforms_message: "位置を変更するにはすべてのプラットフォームを選択してください",
        please_book_spots_within_campaign_date_message: 'キャンペーン期間内にスポットをご予約ください:',
        invalid_file_format: `無効なファイル形式です`,
        import_already_in_progress: 'インポートはすでに進行中です。プロセスが中止されました',
        invalid_template_file: 'テンプレートファイルが無効です!!',
        date_time_houseNumber_column_is_mandatory: 'インポート ファイルでは日付、時刻、および HouseNumber 列が必須です',
        commercial_used_in_booking_cannot_change_duration_message: '予約時に使用されたコマーシャルは期間を変更できません!!',
        please_enter_team: `チームを入力してください`,
        please_select_round_error: 'ラウンドを選択してください',
        please_select_start_date_between_tournament_date_range_error: `トーナメントの日付範囲の間で開始日を選択してください`,
        match_scheduled_successfully_message: '試合予定が無事に決まりました!!',
        some_spots_are_reconciled_bill_generated_selected_spots: `一部のスポットは調整されるか、選択したスポットで請求書が生成されます`,
        media_master_report_sub_menu: 'メディアマスターレポート',
        media_master_report_page_breadcrumb: 'メディアマスターレポート',
        video_column: 'ビデオ',
        product_column: '製品',
        data_load_successfully_message: 'データは正常にロードされました',
        please_enter_address_error_message: '住所を入力してください',
        target_seconds_should_be_greater_then_zero_error_message: 'ターゲット秒数はゼロより大きくなければなりません',
        missing_seasone_detail_form_error_message: '欠落シーズンの詳細',
        ott_menu: 'オット',
        manage_content_menu: 'コンテンツの管理',
        to_do_column: 'やるべきこと',
        in_progress_column: '進行中',
        done_column: '完了',
        work_order_button_tooltip: '作業指示',
        show_spots_button_tooltip: 'ショースポット',
        show_spots_button_text: 'ショースポット',
        save_and_create_work_order_button_tooltip: '作業指示書の保存と作成',
        save_and_create_work_order_button_text: 'WOを保存',
        planning_prime_time_sub_menu: 'プライムタイムの計画',
        breaks_label: '休憩',
        add_line_button_tooltip: '行を追加',
        add_line_button_text: '行を追加',
        perday_label: '1日あたり',
        perweek_label: '週あたり',
        trp_label: 'TRP',
        booking_yearly_sub_menu: '年間予約',
        booking_yearly_page_breadcrumb: '年間予約',
        days_of_week_column: '曜日',
        edit_multiple_button_text: '複数の編集',
        delete_multiple_button_tooltip: '複数の削除',
        delete_multiple_button_text: '複数の削除',
        announcements_label: 'お知らせ',
        recorded_commercial_label: '録画されたコマーシャル',
        read_outs_column: '読み上げ',
        scripts_column: 'スクリプト',
        booking_status_column: '予約状況',
        asset_id_column: 'アセットID',
        delete_strand_label: 'ストランドの削除',
        delete_strand_items_confirm_message: 'ストランド項目の削除',
        press_yes_to_delete_all_the_strand_from_the_selected_slot_onwards_confirm_message: 'YES を押すと、選択したスロット以降のすべてのストランドが削除されます。',
        show_media_label: 'メディアを表示する',
        lock_unlock_label: 'ロック/ロック解除',
        show_exhibitions_label: 'ショーの展示会',
        expand_all_breaks_label: 'すべてのブレークを展開',
        mnimize_all_breaks_label: 'すべての休憩を最小限に抑える',
        please_select_atleast_one_days_error_message: '少なくとも 1 日を選択してください',
        session_time_out_label: 'セッションタイムアウト',
        please_enter_session_time_out_error_message: 'セッションタイムアウトを入力してください',
        session_time_out_should_be_greater_than_one_hour_error_message: 'セッションのタイムアウトは 1 時間以上である必要があります',
        non_reconciled_spot_column: '調整されていないスポット',
        time_in_should_be_less_than_time_out_error_message: 'タイムインはタイムアウトよりも短くする必要があります',
        promotional_screens_sub_menu: 'プロモーション画面',
        promotional_screens_page_breadcrumb: 'プロモーション画面',
        marketing_screens_sub_menu: 'マーケティング画面',
        marketing_screens_page_breadcrumb: 'マーケティング画面',
        frequency_type_label: '周波数の種類',
        frequency_label: '周波数',
        enable_label: '有効にする',
        marketing_screens_editpageheader: 'マーケティング画面',
        promotional_screens_editpageheader: 'プロモーション画面',
        frequency_should_be_greater_than_zero_error_message: '周波数はゼロより大きい必要があります',
        verbiage_key_label: '言葉遣い',
        access_level_label: 'アクセスレベル',
        ottcampaign_label: 'オットキャンペーン',
        ott_campaign_dialog_header: 'キャンペーン',
        successfully_add_campaign_message: 'キャンペーンを正常に追加しました',
        rail_is_already_attach_in_selected_campaign_info_message: 'レールは選択したキャンペーンにすでに取り付けられています',
        deattach_ott_campaign_dialog_header: 'デアタッチキャンペーン',
        deattach_successfully_message: '接続解除に成功しました',
        confirm_deattach_label: '接続解除の確認',
        are_you_sure_do_you_want_to_deattach_campaign_label: 'キャンペーンの接続を解除してもよろしいですか?',
        ott_camapign_status_label: 'キャンペーンのステータス',
        expire_label: '期限切れ',
        rails_dialog_header: 'レール',
        please_select_provider_error_message: 'プロバイダーを選択してください',
        are_you_sure_do_you_want_to_deattach_rail_label: 'レールを取り外しますか?',
        rail_is_already_attach_in_selected_page_info_message: 'レールは選択したページにすでに取り付けられています',
        successfully_add_rails_message: 'レールの追加に成功しました',
        provider_sub_menu: 'プロバイダー',
        provider_page_breadcrumb: 'プロバイダー',
        logourl_label: 'ロゴのURL',
        please_enter_logourl_error_message: 'ロゴURLを入力してください',
        please_select_at_least_one_product_error_message: '少なくとも 1 つの製品を選択してください',
        products_label: '製品',
        active_ottcampaign_label: 'アクティブなキャンペーン',
        total_active_subscriber_label: 'アクティブな購読者数の合計',
        preview_menu: 'プレビュー',
        module_sub_menu: 'モジュール',
        module_page_breadcrumb: 'モジュール',
        path_label: 'パス',
        create_module_header_dialog: 'モジュールの作成',
        select_product_header_dialog: '製品の選択',
        successfully_add_product_succes_message: '製品を正常に追加しました',
        campaign_prefix_label: 'キャンペーンプレフィックス',
        please_enter_campaign_prefix_error_message: 'キャンペーンのプレフィックスを入力してください',
        please_enter_valid_release_year_error_message: '有効なリリース年を入力してください。',
        traffic_sub_menu: '交通',
        adSales_sub_menu: '広告販売',
        curate_sub_menu: 'キュレート',
        monetize_sub_menu: '収益化',
        sms_sub_menu: 'SMS',
        couponing_sub_menu: 'クーポン発行',
        print_pdf_button_tooltip: 'PDFを印刷する',
        please_enter_code: 'コードを入力してください',
        external_description_label: '外観説明',
        alternate_description_label: '代替説明',
        please_select_access_level_error_message: 'アクセスレベルを選択してください',
        company_setting_label: '会社概要',
        invoice_label: '請求書',
        successfully_saved_message: '正常に保存されました',
        export_edi_format_label: 'Export EDI Format',
        do_you_want_print_campaign_billing_lines_label: 'キャンペーンの請求明細行を印刷しますか?',
        cancel_invoice_label: '請求書のキャンセル',
        do_you_want_cancel_this_invoice_label: 'この請求書をキャンセルしますか?',
        please_wait_cancel_invoice_message: '請求書をキャンセルしてください...',
        please_select_menu_type_error_message: 'メニュータイプを選択してください',
        is_parent_menu_label: '親メニュー項目です',
        submenu_label: 'サブメニュー',
        please_select_sub_menu_error_message: 'サブメニューを選択してください',
        warning_label: '警告',
        user_channel_warning_message: 'このユーザーにはチャンネル権限が付与されていません。続行しますか?',
        financial_year_page_breadcrumb: '会計年度',
        sales_target_page_breadcrumb: '販売目標',
        financial_year_dialog_header: '会計年度の作成',
        sales_target_dialog_header: '販売目標の作成',
        financial_year_sub_menu: '会計年度',
        sales_target_sub_menu: '販売目標',
        financial_year_label: '会計年度',
        quarter_label: '四半期',
        target_label: 'ターゲット',
        please_select_financial_year_error_message: '会計年度を選択してください',
        please_enter_target_error_message: 'ターゲットを入力してください',
        please_select_quarter_error_message: '四半期を選択してください',
        please_update_target_details_error_message: 'ターゲットの詳細を更新してください',
        please_update_target_wrong_distribution_error_message: 'ターゲットは分散ターゲットと同じである必要があります',
        target_details_label: '対象の詳細',
        sales_target_achived_label: '営業担当役員 目標/目標達成',
        total_target_label: '合計目標:',
        distributed_target_label: '分散ターゲット:',
        please_enter_assetid_error_message: 'アセットIDを入力してください',
        end_time_should_be_greater_than_start_time_error_message: "終了時間は開始時間より大きくする必要があります",
        please_select_vod_type_validation_error_message: 'VOD タイプを選択してください',
        sum_of_percentages_should_be_100_error_message: 'パーセンテージの合計は 100 になる必要があります',
        campaign_actionbutton_option: 'キャンペーン',
        upcoming_label: '今後の予定',
        select_ott_assets_header_dialog: 'OTT アセットの選択',
        ott_asset_label: 'オット・アセット',
        fast_segmentation_actionbutton_menutext: '高速セグメンテーション',
        is_negative_asrun_diff_label: '負のアスラン差分',
        ott_enabled_label: 'オット有効',
        create_provider_dialog_header: 'プロバイダーの作成',
        insert_dummy_label_planning: 'ダミーを挿入',
        please_enter_duration: '期間を入力してください',
        sum_of_entered_duration_should_be_less_then_or_equal_to_media_duration: '入力した時間の合計はメディアの時間以下である必要があります',
        please_select_area_on_planner_to_insert_dummy_planning_performance_error_message: 'プランナー上でダミーを挿入する領域を選択してください。',
        insert_dummy_dialog_title: 'ダミーを挿入',
        edit_dummy_actionbutton_menutext: 'ダミーの編集',
        upload_fail_error_message: 'アップロードに失敗しました',
        replace_actionbutton_menutext: '交換する',
        media_not_valid_for_selected_channel_error_message: "選択したチャンネルではメディアが無効です",
        replacement_media_lost_error_message: '交換用メディアが紛失しました。',
        are_you_sure_you_want_to_logout: 'ログアウトしてもよろしいですか?',
        translate_dialog_header: '翻訳する',
        text_area_label: 'テキストエリア',
        translate_button_name: '翻訳する',
        missing_google_api_code_error_message: 'Google APIコードがありません',
        please_enter_text_area_first_error_message: '最初にテキスト領域を入力してください',
        please_translate_first_error_message: 'まずは翻訳してください',
        confirm_saved_label: '保存済みの確認',
        changes_you_made_may_not_be_saved_label: '加えた変更は保存されない場合があります。',
        sign_in_label: 'サインイン',
        username_login_label: 'ユーザー名',
        password_login_label: 'パスワード',
        please_enter_user_name_login_label: 'ユーザー名を入力してください',
        enter_your_password_login_label: 'パスワードを入力してください',
        login_lable: 'ログイン',
        material_id_and_media_id_mismatch_please_re_generate_segments_first_error_message: 'マテリアル ID とメディア ID が一致しません。最初にセグメントを再生成してください。',
        please_enter_material_id_error_message: 'マテリアルIDを入力してください',
        poster_note_image_size_label: '注：画像サイズは1MB未満です',
        entry_already_exists_in_system_for_same_prefix_and_suffix_error_message: '同じプレフィックスのエントリがシステムにすでに存在します。',
        loop_till_selected_end_date: '注: 選択した終了日までループする場合にチェックします。',
        please_select_material_content_error_message: 'マテリアルコンテンツを選択してください',
        document_page_breadcrumb: '文書',
        document_sub_menu: '文書',
        document_type_label: '文書の種類',
        please_select_document_type_error_message: 'ドキュメントの種類を選択してください',
        please_enter_doc_error_message: 'ドキュメントを入力してください',
        create_Document_dialog_header: 'ドキュメントの作成',
        upload_documents_label: 'ドキュメントのアップロード',
        doc_label: 'ドクター',
        please_upload_documents_error_message: '書類をアップロードしてください',
        delete_selected_label: '選択したものを削除',
        delete_slot_and_push_forward_in_the_strand_label: 'スロットを削除してストランドを前方に押し出す',
        delete_slot_and_pull_backward_in_the_strand_label: 'エピソードを削除してストランドを後方に引く',
        delete_all_the_events_forward_in_the_strand_label: 'ストランド内のすべてのイベント前方を削除',
        delete_episode_in_future_from_selected_slot_forward_label: '選択したスロットから将来のエピソードを削除します',
        to_enable_other_options_select_only_one_item_label: '他のオプションを有効にするには、項目を 1 つだけ選択します。',
        selected_item_should_be_episode_planning_item_error_message: '再帰はエピソード メディア カテゴリのみに適用されます。',
        selected_item_already_part_of_another_strand_error_message: '選択したアイテムは別のストランドの一部です',
        select_documents_header_dialog: 'ドキュメントの選択',
        revenue_share_label: '収益分配率',
        revenue_share_should_be_negative_error_message: '収益分配率はマイナスである必要があります',
        revenue_share_column: '収益分配率',
        screen_saver_page_breadcrumb: 'スクリーンセーバー',
        screen_saver_sub_menu: 'スクリーンセーバー',
        screen_saver_editpageheader: 'スクリーンセーバー',
        old_value_label: '古い値',
        new_value_label: '新しい価値',
        show_changes_label: '変更を表示',
        planning_slot_sub_menu: '企画枠',
        planning_slot_page_breadcrumb: '企画枠',
        timerangefrom_should_be_greater_then_zero: 'TimeRangeFrom はゼロより大きくなければなりません',
        timerangefrom_should_be_less_then_timerangeto: 'TimeRangeFrom は TimeRangeTo より小さくする必要があります',
        timerangeTo_should_be_greater_then_zero: 'TimeRangeTo はゼロより大きくなければなりません',
        show_details_column: '詳細を表示',
        show_all_label: 'すべて表示',
        isImportable_label: 'インポート可能',
        invalid_file_error_message: '選択したファイルが無効です',
        enable_filter_label: 'フィルターを有効にする',
        rails_label: 'レール',
        promotional_page_page_breadcrumb: 'プロモーションページ',
        promotional_page_sub_menu: 'プロモーションページ',
        slug_label: 'ナメクジ',
        thumb_img_label: 'サムネイル画像',
        ban_img_label: 'バナー画像',
        app_img_label: 'アプリケーションイメージ',
        tags_label: 'タグ',
        show_buy_button_label: '購入ボタンを表示',
        show_in_app_label: 'アプリ内で表示',
        please_enter_slug_error_message: "スラグを入力してください",
        promotional_page_editpageheader: "プロモーションページ",
        comma_seprated_value_should_be_enter_label: "カンマ区切り値を入力する必要があります",
        please_enter_next_number_error_message: '次の数値は 0 より大きくなければなりません',
        please_enter_number_length_error_message: '数値の長さは 0 より大きくなければなりません',
        generate_button_tooltip: 'Excel で TC をダウンロード',
        generate_xml_message: 'Excel を生成中です。お待ちください...',
        create_new_button_label: '新規作成',
        rating_label: '評価',
        please_enter_rating_error_message: '1 ～ 10 の評価を入力してください',
        sponsor_type_page_breadcrumb: 'スポンサーの種類',
        sponsor_type_sub_menu: 'スポンサーの種類',
        note_for_sponsor_type_select_null_label: '注: 評価は 1 ～ 10 の間で行う必要があります。',
        please_enter_sponsor_type_error_message: 'スポンサーの種類を入力してください',
        sponsor_type_label: 'スポンサーの種類',
        default_currency_label: 'デフォルトの通貨',
        web_assets_sub_menu: 'ウェブアセット',
        web_assets_page_breadcrumb: 'ウェブアセット',
        web_assets_page_editpageheader: 'ウェブアセット',
        web_assets_label: 'ウェブアセット',
        logs_label: 'ログ',
        enable_audit_log_label: '監査ログを有効にする',
        please_select_web_assets_error_message: 'ウェブアセットを選択してください',
        select_web_assets_dialog_header: 'Web アセットの選択',
        select_media_dialog_header: 'メディアの選択',
        create_new_button_tooltip: '新規作成',
        create_new_button_text: '新規作成',
        select_rule_label: 'フィルターの選択',
        from_date_should_be_less_then_to_date_error_message: '開始日は終了日よりも小さい必要があります',
        show_repeat_pattern_detail_tooltip: 'リピートパターンの詳細を表示',
        please_select_repeat_pattern_error_message: '最初にリピートパターンを選択してください',
        account_name_label: 'アカウント名',
        bank_name_label: '銀行名',
        account_number_label: '口座番号',
        swift_code_label: 'スイフトコード',
        iban_number_label: 'イバン番号',
        branch_label: '支店',
        bank_details_label: '銀行詳細',
        hero_banner_mobile_label: 'ヒーローバナーモバイル',
        hero_banner_tv_label: 'ヒーローバナーTV',
        square_label: '正方形',
        circle_label: 'サークル',
        landscape_label: '風景',
        partner_ingestion_media_deal_right_confirmation_message: '取引権限なしでメディアをインポートしてもよろしいですか??',
        no_internet_connection_please_check_your_connection_and_try_again_label: 'インターネット接続がありません。接続を確認して、もう一度試してください。',
        there_is_no_product_assigned_to_your_company_kindly_contact_team_BMS_label: 'あなたの会社に割り当てられた製品はありません。チーム BMS にお問い合わせください。',
        you_dont_have_any_module_access_please_contact_your_admin_label: `モジュールへのアクセス権がありません。管理者に問い合わせてください。`,
        show_break_only_label: '休憩のみを表示',
        locked_by_label: 'ロック者',
        auto_plot_interstitial_label: '自動プロットインタースティシャル',
        show_logs_label: 'ログを表示',
        default_label: 'デフォルト',
        from_default_label: 'デフォルトから',
        update_successfully_label: '正常に更新されました',
        show_provider_label: 'ショープロバイダー',
        show_censor_rating_label: 'センサー評価を表示',
        show_episode_no_label: 'エピソード番号を表示',
        pi_page_setting_sub_menu: 'Piページ設定',
        pi_page_setting_page_breadcrumb: 'Piページ設定',
        pi_label: 'PI設定',
        seo_label: 'SEO設定',
        meta_tag_label: 'メタタグ',
        meta_robot_label: 'メタロボット',
        meta_googlebot_label: 'メタ Googlebot',
        pi_page_setting_page_editpageheader: 'Piページ設定',
        show_description_label: '説明を表示',
        show_synopsis_label: '概要を表示',
        show_production_year_label: '番組制作年',
        show_pg_rating_label: 'PG レーティングを表示',
        show_cast_and_crew_label: 'ショーのキャストとスタッフ',
        show_language_label: '言語を表示',
        show_release_date_label: '発売日を表示',
        show_genre_label: '番組ジャンル',
        show_season_no_label: 'ショーシーズンNo.',
        meta_title_label: 'メタタイトル',
        meta_description_label: 'メタディスクリプション',
        select_Field_tooltip: 'フィールドの選択',
        screenshot_label: 'スクリーンショット',
        theme_sub_menu: 'テーマ',
        theme_page_breadcrumb: 'テーマ',
        cta_details_label: 'CTA',
        general_details_label: '一般',
        tray_glow_details_label: 'トレイグロー',
        player_details_label: 'プレーヤー',
        theme_setting_dialog_header: 'テーマの設定',
        deal_rights_give_automatically_for_all_channels_label: '取引の権利はすべてのチャネルに自動的に付与されます',
        add_channel_rights_button_tooltip: 'チャンネル権限の追加',
        you_are_not_authorized_to_edit_this_channel_error_message: 'このチャンネルを変更する権限がありません',
        permalink_structure_label: 'パーマリンク構造',
        plain_label: 'プレーン',
        numeric_label: '数値',
        post_name_label: '役職名',
        excrate_label: '為替レート',
        note_enter_exchange_rate_equal_to_usd_label: '注: 為替レートは USD と等しいと入力してください',
        excrate_should_not_be_negative_error_message: '為替レートはマイナスであってはなりません',
        you_delete_this_deal_right_right_from_parent_series_only_media_episode_publishing_error_message: 'この取引を親シリーズからのみ削除します...',
        you_delete_this_deal_right_right_from_series_only_media_episode_publishing_error_message: 'この取引をシリーズからのみ削除します...',
        agency_type_sub_menu: '代理店タイプ',
        agency_type_label: '代理店タイプ',
        you_are_not_authorized_to_edit_please_go_to_parent_series_error_message: '編集/削除する権限がありません。親シリーズに移動してください',
        you_are_not_authorized_to_edit_please_go_to_series_error_message: '編集/削除する権限がありません。シリーズへどうぞ',
        create_group_header_dialog: 'グループの作成',
        episode_group_page_breadcrumb: 'エピソードグループ',
        delete_media_episode_button_tooltip: 'メディアエピソードの削除',
        rail_title_details_label: 'レールタイトル',
        menu_details_label: 'メニュー',
        segment_by_rc_label: 'RC ごとにセグメント化',
        reference_code_column: 'リファレンスコード',
        two_epiosde_per_day_label: '1 日あたり 2 つのエピソード',
        open_theme_new_tab_label: '新しいタブでテーマを開く',
        refresh_theme_label: 'テーマを更新',
        update_slot_duration_label: 'スロット期間の更新',
        duration_updated_success_message: '期間が正常に更新されました',
        please_select_duration_error_message: '期間を選択してください',
        restricted_genre_label: '制限ジャンル',
        application_configuration_menu: 'アプリケーション構成',
        application_configuration_breadcrumb: 'アプリケーション構成',
        please_select_genre_error_message: 'ジャンルを選択してください',
        font_size_should_be_greater_than_zero_error_message: 'フォント サイズはゼロより大きくなければなりません',
        data_already_exist_error_message: 'データはすでに存在します',
        you_can_not_delete_in_edit_mode_error_message: '編集モードでは削除できません',
        please_add_atleast_one_genre_value_error_message: '少なくとも 1 つのジャンル値を追加してください',
        invalid_short_forms: '無効な短い形式',
        invalid_tooltip: '無効です',
        save_draft_button_tooltip: 'ドラフトの保存',
        save_draft_button_title: 'ドラフトの保存',
        publish_button_text: '発行する',
        program_group_is_mandatory_when_applying_recursive_on_movie_error_message: "映画/プログラムに再帰的に適用するプログラム グループを選択してください",
        trigger_start_time_label: 'トリガー開始時間',
        trigger_end_time_label: 'トリガー終了時刻',
        please_select_all_data_while_importing_playlist: 'プレイリストをインポートするときにすべてのデータを選択してください',
        all_days_can_not_be_excluded_error_message: 'すべての日を除外することはできません',
        dont_show_this_message_again: 'このメッセージを今後表示しないでください',
        media_episode_group_grid_note: '注: 再帰的適用中のシーケンスは、上記のグリッドのシーケンスと同じになります。',
        please_wait_export_report_message: 'レポートをエクスポートしていますのでお待ちください...',
        segment_can_not_be_variation_error_message: "セグメントをバリエーションとして設定できません",
        can_edit_duration_of_segment_error_message: "セグメントの長さのみを編集できます",
        jobs_schedule_sub_menu: 'ジョブスケジュール',
        jobs_schedule_page_breadcrumb: 'ジョブスケジュール',
        enable_error_log_lebel: 'エラーログを有効にする',
        hourly_button_tooltip: '毎時',
        hourly_button_title: '毎時',
        daily_button_tooltip: '毎日',
        daily_button_title: '毎日',
        weekly_button_tooltip: '毎週',
        weekly_button_title: '毎週',
        monthly_button_tooltip: '毎月',
        monthly_button_title: '毎月',
        yearly_button_tooltip: '毎年',
        yearly_button_title: '毎年',
        quick_schedule_lebel: 'クイックスケジュール',
        create_jobs_schedule_dialog_header: 'ジョブスケジュールの作成',
        invalid_input_only_number_and_star_are_allow_error_message: '無効な入力です。数字と * のみが使用できます',
        please_enter_command_error_message: 'コマンドを入力してください',
        can_not_greater_than_error_message: 'を超えることはできません',
        variance_sub_menu: '分散',
        variance_label: '分散',
        tc_in_without_timecode_label: 'TCイン',
        tc_out_without_timecode_label: 'Tcアウト',
        duration_without_timecode_label: '期間',
        minute_label: '分(0-59)',
        hour_label: '時 (0 ～ 23)',
        day_Of_month_label: '日 (1-31)',
        week_label: '週 (1-7)',
        month_label: '月 (1 ～ 12)',
        can_not_less_than_error_message: '以下にすることはできません',
        archived_column: 'アーカイブ済み',
        archived_label: 'アーカイブ済み',
        please_upload_doc_error_message: 'ドキュメントをアップロードしてください',
        variation_type_column: 'バリエーションタイプ',
        create_variance_dialog_header: '差異の作成',
        global_search_bar_placeholder: 'アプリやコンテンツなどを検索します。 ( Ctrl + / )',
        note_variance_link_from_interstitial_edit_form_label: '注: インタースティシャル編集フォームからインタースティシャルをこの差異にリンクできます。',
        duplicate_item_selected_error_message: '重複した項目が選択されました',
        please_select_same_media_category_media_only_global_replacement_error: "同じメディア カテゴリのメディアのみを選択してください",
        restore_schedule_draft_validation_error_message: "現在の日付および現在の日付より数日前のスケジュールの下書きを復元できません",
        schedule_draft_3_month_auto_delete_note: '*注意: 3 か月を超えた下書きは自動的に破棄されます。長期間保存したい場合は、下書きをファイルに保存します。',
        delete_planning_log_message: '選択した計画項目を削除します',
        edited_using_form_log_message: 'フォームを使用して編集しました',
        add_new_planning_item_log_message: '新しい企画項目を追加',
        edited_using_drag_drop_messgae: 'ドラッグアンドドロップで編集',
        planning_logs_dialog_header: '計画ログ',
        slot_column: 'スロット',
        missing_slot_time_for_error_message: '不足しているスロット -',
        slot_label: 'スロット',
        edit_slot_dialog_header: 'スロットの編集',
        attached_media_label: 'メディア',
        time_bound_label: '期限付き',
        live_events_label: 'ライブイベント',
        tournament_label: 'トーナメント',
        create_event_button_tooltip: 'イベントの作成',
        create_event_button_text: 'イベントの作成',
        match_label: '一致',
        venue_label: '会場',
        poster_url_label: 'ポスターURL',
        please_select_tournament_error_message: 'トーナメントを選択してください',
        publish_match_header_dialog: 'マッチの公開',
        un_publish_match_label: 'マッチの非公開',
        publish_match_label: 'マッチの公開',
        selected_days_label: '選択した日',
        copy_transfer_schedule_header_dialog: 'コピー/移動スケジュール',
        created_date_label: '作成日',
        countries_sub_menu: '国',
        countries_page_breadcrumb: '国',
        pincode_sub_menu: 'ピンコード',
        pincode_page_breadcrumb: 'ピンコード',
        states_sub_menu: '州',
        states_page_breadcrumb: '州',
        pincodes_label: 'PINコード',
        states_label: '州',
        countries_label: '国',
        show_media_button_tooltip: 'メディアを表示する',
        show_media_button_text: 'メディアを表示する',
        create_genre_button_text: 'ジャンルの作成',
        time_zone_page_breadcrumb: 'タイムゾーン',
        time_zone_sub_menu: 'タイムゾーン',
        is_negative_offset_default_label: '負のオフセットです',
        offset_label: 'オフセット (hh:mm:ss)',
        please_enter_valid_start_time_message: '有効な開始時刻を入力してください',
        time_zone_label: 'タイムゾーン',
        date_time_column: '日付時刻',
        time_zone_column: 'タイムゾーン',
        insert_live_event_actionbutton_menutext: 'ライブイベントの挿入',
        insert_live_event_actionbutton_menutext_tooltip: 'ライブイベントの挿入',
        virtual_segmentation_actionbutton_menutext: '仮想セグメンテーション',
        virtual_segmentation_actionbutton_menutext_tooltip: '仮想セグメンテーション',
        edit_actionbutton_menutext_tooltip: '編集',
        select_all_Header_actionbutton_menutext_tooltip: 'すべてのヘッダーを選択',
        delete_header_actionbutton_menutext_tooltip: 'ヘッダーの削除',
        insert_break_actionbutton_menutext_tooltip: 'ブレークの挿入',
        program_replacement_actionbutton_menutext_tooltip: 'プログラムの置き換え',
        expand_all_breaks_actionbutton_menutext_tooltip: 'すべてのブレークを展開',
        mnimize_all_breaks_actionbutton_menutext_tooltip: 'すべての休憩を最小限に抑える',
        attach_format_reload_actionbutton_menutext_tooltip: '添付フォーマット',
        fast_segmentation_actionbutton_menutext_tooltip: '高速セグメンテーション',
        remove_filter_actionbutton_menutext_tooltip: 'フィルターを削除',
        filter_actionbutton_menutext_tooltip: 'フィルター',
        revert_virtual_segmentation_actionbutton_menutext: '仮想セグメントを元に戻す',
        revert_virtual_segmentation_actionbutton_menutext_tooltip: '仮想セグメントを元に戻す',
        copy_actionbutton_menutext_tooltip: 'コピー',
        cut_actionbutton_menutext_tooltip: 'カット',
        paste_actionbutton_menutext_tooltip: 'ペースト',
        delete_actionbutton_menutext_tooltip: '削除',
        se_overview_actionbutton_menutext_tooltip: 'SEの概要',
        global_replacement_actionbutton_menutext_tooltip: 'グローバルな置き換え',
        delete_secondary_events_actionbutton_menutext: '二次イベントの削除',
        delete_secondary_events_actionbutton_menutext_tooltip: '二次イベントの削除',
        internal_drag_live_event_error_message: 'ライブイベントを変更できません。削除して再度公開してください!!',
        search_name_label: '検索名',
        imdb_details_label: 'IMDbの詳細',
        year_column: '年',
        imdb_id_column: 'IMDb ID',
        poster_column: 'ポスター',
        imdb_label: 'IMDb',
        actor_label: '俳優',
        rated_label: '評価済み',
        country_label: '国',
        director_label: 'ディレクター',
        writer_label: 'ライター',
        awards_label: '受賞歴',
        dvd_label: 'DVD',
        imdb_votes_label: 'IMDb の投票',
        imdb_id_label: 'IMDb ID',
        production_label: '生産',
        website_label: 'ウェブサイト',
        box_office_label: '興行収入',
        meta_score_label: 'メタスコア',
        release_label: 'リリース',
        please_enter_search_name_error_message: '検索名を入力してください',
        rails_type_details_dialog_header: 'レールタイプの詳細',
        no_image_found_error_message: '画像が見つかりませんでした',
        please_select_item_first_error_message: '最初に項目を選択してください。',
        update_imdb_label: 'IMDb を更新する',
        subscription_label: '定期購入',
        revenue_label: '収益',
        total_subscriber_label: '総購読者数',
        new_subscriber_label: '新規購読者',
        total_deactive_subscriber_label: '非アクティブな購読者',
        total_activation_label: '合計アクティベーション数',
        expiring_users_label: '有効期限が切れる購読者',
        revenue_by_month_label: '月ごとの収益',
        revenue_by_platform_label: 'プラットフォーム別の収益',
        revenue_by_payment_gateway_label: 'ペイメントゲートウェイ別の収益',
        revenue_by_currency_label: '通貨別の収益',
        customers_registration_count_graph: '月ごとの購読者登録数',
        customers_registration_platform_wise: "購読者登録プラットフォーム Wise",
        purchases_by_payment_gateway: "ペイメントゲートウェイによる購入",
        subscriber_by_platform: 'プラットフォーム別の加入者',
        maximum_devices_label: '最大デバイス数',
        please_select_platform_type_error_msg: 'プラットフォームを選択してください',
        maximun_device_should_not_be_less_than_one: "最大デバイス数は 1 未満であってはなりません",
        region_details_monetization_dashboard_label: '地域の製品、クーポン、定期購読者',
        subscribers_by_plan_label: 'プラン別加入者数',
        show_provider_icon_label: 'プロバイダアイコンを表示',
        subscriber_subscription_history: '購読履歴',
        provider_label: 'プロバイダー',
        auto_renew_subscription_label: '自動更新パック',
        subscriber_login_history: 'ログイン履歴',
        create_payment_provider_dialog_header: '支払いプロバイダーの作成',
        currency_code_label: '通貨コード',
        branding_name_label: 'ブランド名',
        branding_logo_label: 'ブランドロゴ',
        branding_color_label: 'ブランディングカラー',
        message_label: 'メッセージ',
        sand_box_key_id_label: 'サンドボックスキーID',
        sand_box_secret_key_label: 'サンドボックス秘密鍵',
        live_key_id_label: 'ライブキーID',
        live_secret_key_label: 'ライブ秘密キー',
        success_url_label: '成功URL',
        failure_url_label: '失敗した URL',
        please_enter_live_key_id_error_message: 'ライブキーIDを入力してください',
        please_enter_live_secret_key_error_message: 'ライブ秘密キーを入力してください',
        please_enter_key_id_error_message: '秘密キーIDを入力してください',
        please_enter_secret_key_error_message: '秘密キーを入力してください',
        please_enter_currency_code_error_message: '通貨コードを入力してください',
        please_enter_branding_name_error_message: 'ブランド名を入力してください',
        please_enter_branding_logo_error_message: 'ブランドロゴを入力してください',
        please_enter_success_url_error_message: '成功した URL を入力してください',
        please_enter_failure_url_error_message: '失敗した URL を入力してください',
        locale_label: 'ロケール',
        payment_gateway_url_label: 'ペイメントゲートウェイURL',
        please_enter_payment_gateway_url_error_message: '支払いゲートウェイの URL を入力してください',
        some_attached_rails_are_full_page_type_and_can_be_attached_independently_only_error_message: '付属のレールの一部はフルページタイプであり、単独でのみ取り付け可能です',
        session_terminated_label: 'セッションが終了しました',
        your_session_has_been_terminated_label: 'セッションは終了しました',
        next_publish_date_label: '次回の発行日',
        create_tournament_type_dialog_header: 'トーナメントタイプの作成',
        create_live_event_type_dialog_header: 'ライブ イベント タイプの作成',
        please_select_house_number_error_message: '家番号を選択してください',
        successfully_exported_success_message: '正常にエクスポートされました',
        please_enter_cast_and_crew_error_message: 'アーティストをメタデータに入力 キャストとクルー',
        music_category_sub_menu: '音楽部門',
        music_category_page_breadcrumb: '音楽部門',
        create_music_category_dialog_header: '音楽カテゴリの作成',
        is_music_label: '音楽です',
        select_music_category_dialog_header: '音楽カテゴリを選択してください',
        music_category_label: '音楽部門',
        available_music_dialog_header: '利用可能な音楽',
        please_select_music_category_error_message: '音楽カテゴリを選択してください',
        music_menu: '音楽',
        more_button_tooltip: 'もっと見る',
        more_button_text: 'もっと見る',
        text_color_label: '文字の色',
        program_time_consumption_report_sub_menu: 'プログラム消費時間レポート',
        program_time_consumption_report_page_breadcrumb: 'プログラム消費時間レポート',
        music_report_sub_menu: 'ミュージックレポート',
        music_report_page_breadcrumb: 'ミュージックレポート',
        total_runs_column: '合計実行数',
        total_run_time_column: '合計実行時間',
        translate_synopsis_level: '概要を翻訳する',
        tx_mode_sub_menu: '送信モード',
        tx_mode_page_breadcrumb: '送信モード',
        series_library_label: 'シリーズライブラリ',
        digital_sign_menu: 'デジタルサイン',
        model_sub_menu: 'モデル',
        model_page_breadcrumb: 'モデル',
        dimensions_label: '寸法',
        model_number_label: 'モデル番号',
        resolution_label: '解像度',
        display_shape_label: '表示形状',
        brightness_label: '明るさ',
        display_size_label: '表示サイズ',
        mounting_type_label: '取付タイプ',
        create_model_dialog_header: 'モデルの作成',
        display_shape_sub_menu: '表示形状',
        display_shape_page_breadcrumb: '表示形状',
        resolution_sub_menu: '解像度',
        resolution_page_breadcrumb: '解像度',
        please_select_brand_error_message: 'ブランドを選択してください',
        please_enter_screen_dimensions_error_message: '画面の寸法を入力してください',
        please_enter_model_number_error_message: 'モデル番号を入力してください',
        please_enter_mounting_type_error_message: '取り付けタイプを入力してください',
        please_select_module_resolution_error_message: 'モジュールの解像度を選択してください',
        please_select_display_shape_error_message: '表示形状を選択してください',
        please_enter_brightness_error_message: '明るさを入力してください',
        please_enter_display_size_error_message: '表示サイズを入力してください',
        digital_sign_brand_sub_menu: 'ブランド',
        digital_sign_brand_page_breadcrumb: 'デジタルサインブランド',
        create_node_dialog_header: 'ノードの作成',
        parent_node_label: '親ノード',
        digital_sign_node_page_breadcrumb: 'デジタル署名ノード',
        node_sub_menu: 'ノード',
        add_sign_board_button_tooltip: '看板を追加',
        digital_sign_board_page_breadcrumb: 'デジタルサインボード',
        digital_sign_board_sub_menu: '理事会',
        model_label: 'モデル',
        node_label: 'ノード',
        warranty_start_date_label: '保証開始日',
        warranty_End_date_label: '保証終了日',
        sign_board_id_label: 'サインボードID',
        model_column: 'モデル',
        sign_board_id_column: 'サインボードID',
        warranty_date_column: '保証日',
        delete_sign_board_button_tooltip: '看板の削除',
        date_wise_sheet_label: '日付に関するシート',
        tx_status_sub_menu: '送信ステータス',
        tx_status_page_breadcrumb: '送信ステータス',
        update_txstatus_actionbutton_menutext: '送信ステータスの更新',
        add_comment_actionbutton_menutext: 'コメントの追加',
        update_comment_actionbutton_menutext: 'コメントを更新',
        tx_status_label: "送信ステータス",
        digital_sign_model_page_breadcrumb: 'デジタル署名モデル',
        please_select_resolution_error_message: '解像度を選択してください',
        please_enter_dimensions_error_message: '寸法を入力してください',
        digital_sign_board_label: 'デジタルサインボード',
        warranty_end_date_label: '保証終了日',
        create_board_dialog_header: 'ボードの作成',
        please_select_model_error_message: 'モデルを選択してください',
        please_enter_sign_board_id_error_message: 'サインボードIDを入力してください',
        create_resolution_dialog_header: '解像度の作成',
        length_label: '長さ',
        please_enter_length_error_message: '長さは0より大きくなければなりません',
        please_width_length_error_message: '幅は0より大きくなければなりません',
        confirm_delete_all_label: 'すべて削除の確認',
        are_you_sure_do_you_want_to_delete_all_label: 'すべて削除してもよろしいですか?',
        serial_number_label: 'シリアル番号',
        please_enter_serial_number_error_message: 'シリアル番号を入力してください',
        aspect_ratio_label: 'アスペクト比',
        width_should_be_greater_than_zero_error_message: '幅はゼロより大きくなければなりません',
        height_should_be_greater_than_zero_error_message: '高さはゼロより大きくなければなりません',
        playlist_sub_menu: 'プレイリスト',
        playlist_page_breadcrumb: 'プレイリスト',
        nodes_lable: 'ノード',
        digital_sign_overlay_label: 'オーバーレイ',
        can_not_add_same_parent_node_error_message: `同じ親ノードを追加できません`,
        publish_selected_match_label: '選択した一致を公開',
        choose_another_parent_node_error_message: '別の親ノードを選択する',
        digital_sign_overlay_page_breadcrumb: 'デジタルサインオーバーレイ',
        overlay_page_breadcrumb: 'オーバーレイ',
        digital_sign_overlay_sub_menu: 'オーバーレイ',
        digital_sign_board_overlay_editpage_header: 'ボードオーバーレイ',
        shape_label: '形状',
        position_label: 'ポジション',
        text_label: 'テキスト',
        font_weights_label: 'フォントの太さ',
        font_color_label: 'フォントの色',
        please_enter_shape_error_message: '形状を入力してください',
        font_family_label: 'フォントファミリー',
        overlay_type_label: 'オーバーレイの種類',
        font_size_label: 'フォントサイズ',
        border_radius_label: '境界半径',
        opacity_label: '不透明度',
        text_marquee_label: 'テキストマーキー',
        opacity_note: '注: 不透明度は 0 ～ 1 の間である必要があります。',
        margin_lrtb_text_label: "テキストマージン",
        width_percentage_should_be_greater_than_zero_and_less_than_hundred_error_message: '幅 % は 0 より大きく 100 未満である必要があります',
        height_percentage_should_be_greater_than_zero_and_less_than_hundred_error_message: '高さ % は 0 より大きく 100 未満である必要があります',
        asset_bundle_sub_menu: 'アセットバンドル',
        asset_bundle_page_breadcrumb: 'アセットバンドル',
        edit_asset_bundle_editpage_header: 'アセットバンドルの編集',
        create_asset_bundle_editpage_header: 'アセットバンドルの作成',
        add_ott_asset_button_tooltip: 'アセットの追加',
        channel_number_label: 'チャンネル番号',
        create_tx_mode_dialog_header: '送信モードの作成',
        is_type_live_label: 'タイプライブ',
        sub_genre_label: 'サブジャンル',
        current_active_version_label: '現在のアクティブなバージョン',
        disable_live_event_section_label: 'ライブイベントセクションを無効にする',
        export_segmentation_tooltip_button: 'Export Segmentation',
        text_position_label: 'テキストの位置',
        text_opacity_label: 'テキストの不透明度',
        digital_sign_board_overlay_page_breadcrumb: 'デジタル サイン ボード オーバーレイ',
        please_enter_valid_numbers_in_duration: '期間に有効な数値を入力してください',
        text_shape_label: 'テキストの形状',
        layer_label: 'レイヤー',
        spotify_label: 'スポティファイ',
        add_blank_label: '空白を追加',
        sync_reference_code_message: 'シリーズ コードをプレフィックスとして使用し、その後にエピソード番号を使用して、リンクされたエピソードの参照コードを更新します。',
        geners_label: 'ジェネレーター',
        sub_geners_label: 'サブジェネレーター',
        downloading_please_wait_message: 'ダウンロード中です。お待ちください...',
        format_schedule_sub_menu: 'スケジュールのフォーマット',
        format_schedule_page_breadcrumb: 'スケジュールのフォーマット',
        create_schedule_format_dialog_header: 'スケジュールフォーマットの作成',
        select_format_dialog_header: 'フォーマットの選択',
        please_select_format_error_message: '形式を選択してください',
        please_enter_valid_from_error_message: '有効期限を入力してください',
        please_enter_valid_to_error_message: '有効期限を入力してください',
        please_select_items_to_update_message: '更新する項目を選択してください',
        update_successfully_message: '正常に更新されました',
        please_select_pg_rating_error_message: 'PG レーティングを選択してください',
        please_select_censor_rating_error_message: 'センサー評価を選択してください',
        please_select_languages_error_message: '言語を選択してください',
        please_select_categories_error_message: 'カテゴリを選択してください',
        please_select_genres_error_message: 'ジャンルを選択してください',
        please_select_sub_genres_error_message: 'サブジャンルを選択してください',
        please_enter_production_year_error_message: '製造年を入力してください',
        please_select_technical_prototype_error_message: '技術プロトタイプを選択してください',
        please_enter_keywords_error_message: 'キーワードを入力してください',
        variation_label: 'バリエーション',
        execute_button_tooltip: '実行する',
        execute_button_text: '実行する',
        download_summary_tooltip: 'ダウンロードの概要',
        from_date_should_be_current_date_error_message: '開始日は現在の日付/将来の日付である必要があります',
        next_number_can_not_be_negative_or_zero_error_meessage: '次の数値は負またはゼロにはできません',
        number_length_should_be_between_1_to_10_error_message: '数値の長さは 1 ～ 10 にする必要があります',
        create_fast_playlist_dialog_header: '高速プレイリストの作成',
        digital_sign_screen_group_page_breadcrumb: '画面グループ',
        digital_sign_screen_group_sub_menu: '画面グループ',
        activate_screen_button_tooltip: 'アクティブ化画面',
        activate_button_text: 'アクティブ化する',
        activate_button_tooltip: 'アクティブ化する',
        activate_screen_dialog_header: 'アクティブ化画面',
        please_enter_screen_name_error_message: 'スクリーン名を入力してください',
        please_enter_otp_error_message: 'OTPを入力してください',
        show_segmentation_actionbutton_menutext: 'セグメンテーションを表示',
        show_segmentation_actionbutton_menutext_tooltip: 'セグメンテーションを表示',
        screen_page_breadcrumb: 'スクリーン',
        create_screen_group_dialog_header: '画面グループの作成',
        screen_sub_menu: 'スクリーン',
        attach_screen_group_dialog_header: '画面グループのアタッチ',
        digital_sign_content_page_breadcrumb: '内容',
        digital_sign_content_sub_menu: '内容',
        create_content_dialog_header: 'コンテンツの作成',
        please_select_content_type_error_message: 'コンテンツタイプを選択してください',
        please_select_url_error_message: 'URLを選択してください',
        content_type_label: 'コンテンツタイプ',
        duration_type_label: '期間',
        playlist_label: 'プレイリスト',
        screen_group_label: '画面グループ',
        player_label: 'プレーヤー',
        orientation_label: '向き',
        playing_now_label: '今すぐプレイ',
        restart_label: '再起動',
        restart_app_label: 'アプリを再起動する',
        cpu_usage_label: 'CPU使用率',
        do_you_really_want_to_delete_question: "本当に削除しますか?",
        percentage_label: 'パーセンテージ',
        digital_sign_content_label: "内容",
        digital_sign_dashboard_sub_menu: 'ダッシュボード',
        digital_sign_dashboard_page_breadcrumb: 'ダッシュボード',
        new_screen_group_button_title: '新しい画面グループ',
        new_playlist_button_title: '新しいプレイリスト',
        new_content_button_title: '新しいコンテンツ',
        new_screen_button_title: '新しい画面',
        add_screen_group_dialog_header: '画面グループの追加',
        playlist_dialog_header: 'プレイリスト',
        same_screen_group_error_message: '同じ画面グループを追加できません',
        add_more_label: 'さらに追加',
        thumbnail_column: "サムネイル",
        overlays_column: "オーバーレイ",
        email_address_label: 'メールアドレス',
        sign_up_label: 'サインアップ',
        company_name_label: '会社名',
        country_code_label: '国コード',
        industries_label: '産業',
        network_screen_size_label: 'ネットワーク画面サイズ',
        how_did_you_found_us_label: 'どうやって私たちを見つけたのですか',
        please_enter_password_error_message: 'パスワードを入力してください',
        please_enter_company_name_error_message: '会社名を入力してください',
        please_select_country_code_error_message: '国コードを選択してください',
        please_enter_phone_error_message: '電話番号を入力してください',
        please_select_industry_error_message: '業種を選択してください',
        please_select_network_screen_size_error_message: 'ネットワーク画面サイズを選択してください',
        please_select_how_did_you_found_us_error_message: '選択してください 当社をどのようにして見つけましたか',
        sign_up_dialog_header: 'サインアップ',
        login_label: 'ログイン',
        do_not_have_an_account_label: 'アカウントをお持ちでない場合は、',
        forgot_password_label: 'パスワードをお忘れですか？',
        screen_players_label: '画面/プレーヤー',
        username_label: 'ユーザー名',
        manage_underoverrun_schedule_menu_text: 'スロットオートフィル',
        add_program_menutext: "プログラムの追加",
        instance_label: 'インスタンス',
        instances_sub_menu: 'インスタンス',
        instances_page_breadcrumb: 'インスタンス',
        forgot_your_password_label: 'パスワードをお忘れですか?',
        enter_email_note: 'メールアドレスとリンクを入力すると、新しく生成されたパスワードがメールで送信されます',
        remember_password_label: 'パスワードを覚えていますか?',
        reset_password_button_text: 'パスワードのリセット',
        progress_column: '進捗状況',
        select_interstitial_group_dialoag_header: 'インタースティシャルグループの選択',
        interstitial_group_button_tooltip: 'インタースティシャルグループ',
        auto_planning_tooltip: "自動プランニング",
        auto_planning_with_boss_ai_tooltip: "Boss AI による自動プランニング",
        day_part_sub_menu: '昼の部',
        day_part_page_breadcrumb: '昼の部',
        create_day_part_dialog_header: '昼の部の作成',
        priority_label: '優先順位',
        please_enter_from_time_error_message: '開始時刻を入力してください',
        please_enter_to_time_error_message: '時間を入力してください',
        please_enter_priority_error_message: '有効な優先度を入力してください',
        please_select_valid_days_error_message: '有効な日数を選択してください',
        please_enter_youtube_link_error_message: 'YouTube リンクを入力してください',
        link_label: 'リンク',
        add_new_button_tooltip: '新規追加',
        attach_screens_column: 'スクリーンを接続する',
        isAllChannel_label: 'すべてのチャンネル',
        day_part_label: '昼の部',
        please_select_day_part_error_message: '時間帯を選択してください',
        please_enter_reference_code_error_message: "参照コードを入力してください",
        company_label: '会社名',
        please_enter_correct_phone_number_error_message: '正しい電話番号を入力してください',
        header_address_font_size_label: 'ヘッダーアドレスのフォントサイズ',
        spots_details_font_size_label: 'スポット詳細の文字サイズ',
        digital_sign_company_plans_page_breadcrumb: '会社計画',
        myrepeatpattern_labe: '自分で作成したもの',
        style_sheet_dialog_header: 'スタイルシート',
        digital_sign_company_plans_sub_menu: '会社計画',
        download_the_app_label: 'アプリをダウンロードする',
        in_house_label: '社内',
        digital_sign_admin_dashboard_menu: '管理者ダッシュボード',
        digital_sign_admin_dashboard_page_breadcrumb: '管理者ダッシュボード',
        last_five_user_login_label: '最近の 5 ユーザーのログイン',
        create_content_button_tooltip: 'コンテンツの作成',
        create_genre_button_tooltip: 'ジャンルの作成',
        create_sub_genre_button_tooltip: 'サブジャンルの作成',
        create_cast_type_button_tooltip: 'キャストタイプの作成',
        digital_sign_plans_sub_menu: '計画',
        digital_sign_plans_page_breadcrumb: '計画',
        edit_image_url_dialog_header: '画像の URL を編集',
        attach_screen_dialog_header: 'アタッチ画面',
        attachments_label: '添付ファイル',
        file_attachment_button_tooltip: '添付ファイル',
        file_column: 'ファイル',
        file_attachment_dialog_header: '添付ファイル',
        version_column: 'バージョン',
        targets_label: 'ターゲット',
        weightage_label: '体重',
        weightage_column: '体重',
        play_count_label: '再生回数',
        play_count_column: '再生回数',
        isplaybycount_label: 'カウントで再生',
        isplaybycount_column: 'カウントで再生',
        weightage_should_be_less_than_fifty_error_message: '体重は50未満である必要があります',
        please_enter_correct_weightage_error_message: '正しい体重を入力してください',
        please_enter_correct_play_count_error_message: '正しい再生回数を入力してください',
        play_count_should_be_less_than_fifty_error_message: '再生回数は 50 未満である必要があります',
        isfetchfromlibrary_label: 'ライブラリからフェッチ',
        create_instance_dialog_header: 'インスタンスの作成',
        base_url_label: 'ベース URL',
        db_name_label: 'DB名',
        digisign_socket_base_url_label: 'Digisign ソケット ベース URL',
        socket_base_url_label: 'ソケットベースURL',
        storage_destination_label: '保存先',
        cloud_name_label: 'クラウド名',
        api_key_label: 'APIキー',
        api_secret_label: 'API シークレット',
        access_key_id_label: 'アクセスキー',
        secret_access_key_label: 'シークレットアクセスキー',
        bucket_name_label: 'バケット名',
        please_enter_base_url_error_message: 'ベース URL を入力してください',
        please_enter_bdname_error_message: 'BD 名を入力してください',
        please_enter_digisign_socket_base_url_error_message: 'Digisign ソケット ベース URL を入力してください',
        please_enter_socket_base_url_error_message: 'ソケットベース URL を入力してください',
        quality_label: '品質',
        quality_should_be_less_than_100_error_message: '品質は 100 未満である必要があります',
        file_label: 'ファイル',
        keep_org_label: 'オリジナルを維持',
        cdn_url_label: 'CDN URL',
        please_enter_cdn_url_error_message: 'CDN URLを入力してください',
        please_cloud_name_error_message: 'クラウド名を入力してください',
        please_api_key_error_message: 'APIキーを入力してください',
        please_api_secret_error_message: 'API シークレットを入力してください',
        please_access_keyid_error_message: 'アクセスキーIDを入力してください',
        please_secret_access_key_error_message: 'シークレットアクセスキーを入力してください',
        please_region_error_message: '地域を入力してください',
        please_bucket_name_error_message: 'バケット名を入力してください',
        column_label: 'コラム',
        please_select_column_error_message: "列を選択してください",
        please_select_operator_error_message: "オペレータを選択してください",
        fill_gaps_label: "ギャップを埋める",
        digital_sign_content_group_sub_menu: 'コンテンツグループ',
        digital_sign_content_group_page_breadcrumb: 'コンテンツグループ',
        content_group_editpage_header: 'コンテンツグループの作成',
        add_content_button_tooltip: 'コンテンツの追加',
        digital_sign_add_content_dialog_header: 'コンテンツの追加',
        please_attach_atleast_one_content_error_message: '少なくとも 1 つのコンテンツを添付してください',
        digital_sign_content_group_label: 'コンテンツグループ',
        minimum_gap_label: "最小ギャップ (時間単位)",
        segment_for_channel_rights_label: '一部のセグメントは、そのチャンネルの権利を持っていない場合、無効になります。',
        already_have_an_account_label: 'すでにアカウントをお持ちですか?',
        min_gap_error_message: "最小ギャップを負にすることはできません",
        min_gap_invalid_error_message: "有効な最小ギャップを入力してください",
        set_as_default_label: 'デフォルトとして設定',
        minimum_gap_in_primary_event_label: '最小ギャップ (日単位)',
        is_tx_status_label: '送信ステータス',
        tx_status_column: '送信ステータス',
        restricted_pg_rating_label: '制限付きページのレーティング',
        marker_label: 'マーカー',
        in_label: 'で',
        out_label: 'アウト',
        marker_duration_label: '期間',
        time_code_markers: 'タイムコードマーカー',
        duration_label_tooltip: '(hh:mm:ss:ff)',
        create_marker_button_tooltip: 'マーカーの作成',
        please_enter_valid_value_in_error_message: '有効な日付を入力してください',
        please_enter_valid_value_out_error_message: '有効な値を入力してください。In は Out より大きくてはなりません',
        in_column: 'で',
        out_column: 'アウト',
        Tcm: 'Tcm',
        please_select_time_code_marker_error_message: 'タイムコードマーカーを選択してください',
        ott_platform_sub_menu: 'プラットフォーム',
        ott_platform_page_breadcrumb: 'プラットフォーム',
        module_restrictions_label: 'モジュールの制限事項',
        action_label: 'アクション',
        please_select_segment_header: 'セグメントを選択してください',
        restriction_actions_label: "制限アクション",
        no_permission_to_delete_header_info: 'ヘッダーを削除する権限がありません。',
        please_contact_admin_message: "管理者に連絡してください",
        privacy_policy_label: 'プライバシーポリシー',
        ott_assets_used_in_archive_confirmation_message: "このアセットは以下で使用されます",
        ott_assets_archive_confirmation_message: "まだアーカイブしますか?",
        ingestion_report_sub_menu: '摂取レポート',
        ingestion_report_page_breadcrumb: '摂取レポート',
        cast_and_crew_column: 'キャストとスタッフ',
        censor_rating_column: '検閲評価',
        production_year_column: '製造年',
        activity_dropdown_label: 'アクティビティ',
        asset_type_column: '資産タイプ',
        provider_column: 'プロバイダー',
        access_level_column: 'アクセスレベル',
        vod_type_column: 'VOD タイプ',
        potrait_image_url_column: 'ポートレート画像の URL',
        landscape_image_url_column: '横長画像のURL',
        playlist_import_buffer_label: 'プレイリストインポートバッファ',
        is_negative_playlist_import_buffer_label: "-ve プレイリストインポートバフです。",
        playlist_export_buffer_label: 'プレイリストエクスポートバッファ',
        is_negative_playlist_export_buffer_label: "-ve プレイリスト エクスポート バフです。",
        add_user_dialog_header: 'ユーザーの追加',
        add_new_company_dialog_header: '新しい会社を追加',
        tenure_label: '在職期間',
        screens_label: 'スクリーン',
        storage_label: 'ストレージ',
        plan_label: '計画',
        users_label: 'ユーザー',
        please_enter_plan_name_error_message: 'プラン名を入力してください',
        plan_tenure_should_be_greater_than_zero_error_message: '在職期間は 0 より大きくなければなりません',
        plan_screens_should_be_greater_than_zero_error_message: '画面は 0 より大きくなければなりません',
        plan_storage_should_be_greater_than_zero_error_message: 'ストレージは 0 より大きくなければなりません',
        please_add_atleast_one_user_error_message: '少なくとも 1 人のユーザーを追加してください',
        enter_your_pin_label: 'PIN を入力してください',
        please_select_company_error_message: '会社を選択してください',
        event_country_level: '開催国',
        please_enter_event_country_error_message: 'イベントの国を入力してください',
        team_a_poster_url_label: 'チームAポスターURL',
        team_b_poster_url_label: 'チームBポスターURL',
        company_type_label: '会社の種類',
        tournament_group_dialog_header: 'トーナメントグループ',
        tournament_group_page_breadcrumb: 'トーナメントグループ',
        tournament_group_sub_menu: 'トーナメントグループ',
        tournament_group_label: 'トーナメントグループ',
        please_select_tournament_group: 'トーナメントグループを選択してください',
        add_playlist_button_tooltip: 'プレイリストを追加',
        plans_label: '計画',
        change_password_button_tooltip: 'パスワードの変更',
        change_password_dialog_header: 'パスワードの変更',
        successfully_change_password_message: 'パスワードが正常に変更されました',
        asrun_report_dialog_header: 'アスランレポート',
        playlist_name_column: 'プレイリスト名',
        screen_name_column: 'スクリーン名',
        serial_number_column: 'シリアル番号',
        every_label: '毎',
        is_auto_restart_enabled_label: '自動再起動',
        daily_reboot_label: '毎日の再起動',
        restart_time_label: '再開時刻',
        screen_group_column: '画面グループ',
        playlist_column: 'プレイリスト',
        epg_convertor_sub_menu: 'EPGコンバーター',
        source_epg_file_label: 'ソース EPG ファイル',
        opta_file_label: 'OPTAファイル',
        image_url_file_label: '画像URLファイル',
        source_epg_tab_label: 'ソース EPG',
        opta_tab_label: 'オプタ',
        image_url_tab_label: '画像のURL',
        converted_epg_tab_label: '変換された EPG',
        convert_button_label: "変換する",
        global_label: 'グローバル',
        media_template_sub_menu: 'メディアテンプレート',
        media_template_page_breadcrumb: 'メディアテンプレート',
        media_template_dialog_header: 'メディアテンプレート',
        select_media_template_collection_header: 'メディアテンプレートの選択',
        save_and_create_media_template_button_tooltip: 'メディア テンプレートの保存と作成',
        select_media_template_button_tooltip: 'メディアテンプレートの選択',
        save_as_media_template_button_text: 'テンプレートとして保存',
        startup_button_tooltip: 'スタートアップ',
        startup_button_title: 'スタートアップ',
        task_label: "タスク",
        curl_label: "カール/API",
        please_select_task_error_message: "タスクを選択してください",
        command_label: "コマンド",
        execute_shell_label: "シェルの実行",
        disable_lebel: "無効にする",
        mudule_label: "モジュール",
        command_column: "コマンド",
        execute_shell_column: "シェルの実行",
        schedule_column: "スケジュール",
        enable_error_log_column: "エラーログを有効にする",
        disable_column: "無効にする",
        success_count_column: "成功数",
        last_activity_count_column: "最後のアクティビティ",
        next_schedule_time_column: "次の予定時間",
        please_add_atleast_one_publishing_rights_error_message: '少なくとも 1 つの出版権を追加してください',
        genres_label: 'ジャンル',
        sub_genres_label: 'サブジャンル',
        avod_Configuration_sub_menu: "構成を避ける",
        avod_Configuration_label: "構成を避ける",
        ad_tags_column: "広告タグ",
        avod_Configuration_dialog_header: "Avod 構成の作成",
        features_label: "特長",
        please_select_title_error_message: "タイトルを選択してください",
        ad_tag_column: "広告タグ",
        avod_configuration_page_breadcrumb: "構成を避ける",
        avod_feature_label: "回避機能",
        ad_tag_label: "広告タグの作成",
        please_select_ad_tag_error_message: "広告タグを選択してください",
        linked_channels_label: "リンクされたチャンネル",
        gender_label: "性別",
        please_select_gender_error_message: "性別を選択してください",
        parent_contract_label: "親契約",
        select_contract_collection_header: "契約の徴収",
        non_linear_publishing_label: 'ノンリニア出版',
        video_not_found_error_message: "ビデオが見つかりません",
        time_line_view_tooltip: 'タイムラインビュー',
        response_area_label: "応答",
        job_schedule_base_url_label: 'ジョブ スケジュールのベース URL',
        please_enter_job_schedule_base_url_error_message: 'ジョブ スケジュールのベース URL を入力してください',
        downloading_excel_please_wait_message: 'Excel をダウンロードしています。お待ちください...',
        enable_notification_label: '通知を有効にする',
        show_shedule_dialog_header: 'ショースケジュール',
        please_select_atleast_one_item_error_message: '少なくとも 1 つの項目を選択してください',
        please_select_item_to_replace_error_message: '交換するアイテムを選択してください',
        schedule_time_column: 'スケジュール時間',
        select_item_to_replace_label: '置換する項目を選択してください',
        save_and_run_button_text: '保存して実行',
        epg_template_label: "EPG テンプレート",
        message_sub_menu: "メッセージ",
        message_provider_sub_menu: "メッセージプロバイダー",
        message_template_sub_menu: "メッセージテンプレート",
        message_configuration_sub_menu: "メッセージ構成",
        message_provider_page_breadcrumb: "メッセージプロバイダー",
        message_template_page_breadcrumb: "メッセージテンプレート",
        message_configuration_page_breadcrumb: "メッセージ構成",
        message_provider_dialog_header: "メッセージプロバイダーの作成",
        auth_key_lable: "認証キー",
        message_template_dialog_header: "メッセージテンプレートの作成",
        is_unicode_label: "ユニコード",
        is_flash_label: "フラッシュ",
        sender_id_lable: "送信者ID",
        message_configuration_dialog_header: "メッセージ構成",
        message_type_label: "メッセージの種類",
        message_template_label: "メッセージテンプレート",
        message_provider_label: "メッセージプロバイダー",
        please_enter_auth_key_error_message: "認証キーを入力してください",
        please_enter_content_error_message: "内容を入力してください",
        please_enter_sender_id_error_message: "送信者IDを入力してください",
        please_select_message_type_error_message: "メッセージの種類を選択してください",
        message_variant_label: "メッセージのバリエーション",
        devices_label: "デバイス",
        device_name_column: "デバイス名",
        last_login_time_column: "最終ログイン時間",
        important_update_successfully_message: "重要なアップデートが正常に完了しました",
        param_label: "パラム",
        please_add_atleast_one_Ad_tags_error_message: "少なくとも 1 つの広告タグを追加してください",
        ingestion_logs_dialog_header: "取り込みログ",
        ingestion_logs_sub_menu: "取り込みログ",
        status_label: "ステータス",
        ingestion_logs_page_breadcrumb: "取り込みログ",
        partner_ingestion_template: "インジェストテンプレート",
        partner_ingestion_base_url: "インジェストベース URL",
        please_select_ingestion_template: "取り込みテンプレートを選択してください",
        please_enter_ingestion_base_url: "インジェストベース URL を入力してください",
        data_column: "データ",
        please_enter_curl_error_message: 'カールを入力してください',
        params_label: 'パラメータ',
        row_label: "行",
        table_view_label: "テーブルビュー",
        please_select_message_variant_error_message: "メッセージ バリアントを選択してください",
        deactive_lebel: "非アクティブ",
        parent_genre_label: "親ジャンル",
        parent_language_label: "親言語",
        parent_pg_rating_label: "親の PG 評価",
        parent_censor_rating_label: "親の検閲評価",
        censor_rating_sub_menu: "検閲評価",
        pg_rating_dialog_header: "ページ評価の作成",
        censor_rating_dialog_header: "センサー評価の作成",
        match_type_label: 'マッチタイプ',
        match_type_page_breadcrumb: "マッチタイプ",
        match_type_sub_menu: "マッチタイプ",
        match_type_dialog_header: "マッチタイプの作成",
        Column_column: 'コラム',
        request_label: 'リクエスト',
        sales_dialog_header: '売上の作成',
        concurrency_label: '同時実行性',
        force_upgrade_label: '強制アップグレード',
        please_enter_version_error_message: 'バージョンを入力してください',
        check_every_label: '毎回チェックする',
        analytics_providers_sub_menu: '分析プロバイダー',
        analytics_providers_page_breadcrumb: '分析プロバイダー',
        analytics_events_sub_menu: '分析イベント',
        analytics_events_page_breadcrumb: '分析イベント',
        create_analytics_provider_dialog_header: '分析プロバイダーの作成',
        please_enter_api_key_error_message: 'APIキーを入力してください',
        analytics_event_page_editpageheader: '分析イベント',
        please_enter_provider_name_error_message: 'プロバイダー名を入力してください',
        provider_name_label: 'プロバイダー名',
        parental_control_label: 'ペアレンタルコントロールを有効にする',
        symbol_label: 'シンボル',
        please_enter_symbol_error_message: '記号を入力してください',
        independent_episode_page_breadcrumb: '独立したエピソード',
        subscriber_profile_dialog_header: '購読者プロフィール',
        enable_pg_restriction_label: 'PG制限を有効にする',
        pin_label: 'ピン',
        enable_parent_control_label: 'ペアレントコントロールを有効にする',
        restricted_pgratings_label: '制限された PgRating',
        debug_mode_label: 'デバッグモード',
        auto_restart_percent_label: '自動再起動',
        set_resolution_dialog_header: '解像度の設定',
        asrun_report_label: 'アスランレポート',
        asrun_report_tooltip: 'アスランレポート',
        auto_fill_playlist_dialog_header: 'オートフィルプレイリスト',
        apply_fixed_sequence_label: '固定シーケンスを適用',
        apply_fixed_start_items_label: '固定開始項目を適用する',
        auto_manage_footers_label: 'フッターの自動管理',
        allowed_footers_offset_label: '許可されるフッターのオフセット',
        fix_playlist_label: 'プレイリストを 24 時間修正',
        categories_required_in_sequence: '順番に必要なカテゴリ',
        select_format_label: 'フォーマットの選択',
        select_format_collection_header: 'フォーマットの選択',
        select_media_category_type_collection_header: 'メディア カテゴリ タイプの選択',
        error_log_column: 'エラーログ',
        please_wait_loading_error_message: '読み込み中しばらくお待ちください...',
        media_management_report_sub_menu: 'メディア管理レポート',
        media_management_report_dialog_header: 'メディア管理レポート',
        media_content_report_sub_menu: 'メディアコンテンツレポート',
        media_content_report_page_breadcrumb: 'メディアコンテンツレポート',
        long_form_label: '長い形式',
        short_form_label: '短い形式',
        spot_label: 'スポット',
        play_mode_label: 'プレイモード',
        memory_label: '記憶',
        used_label: '中古品',
        free_label: '無料',
        delete_storage_button_tooltip: 'ストレージの削除',
        asrun_error_report_dialog_header: '実行エラー',
        restart_history_dialog_header: '再起動履歴',
        enable_asrunlog_label: 'AsrunLog を有効にする',
        take_periodic_screenshots_label: '定期的なスクリーンショット',
        image_format_label: '画像フォーマット',
        video_format_label: 'ビデオフォーマット',
        restart_type_column: '再起動の種類',
        preset_label: 'プリセット',
        commercial_schedule_list: "CMスポット予定",
        disable_profile_selection_label: "プロファイル選択を無効にする",
        auto_fill_music: "オートフィルミュージック",
        content_group_label: 'コンテンツグループ',
        digital_sign_add_content_group_dialog_header: 'コンテンツグループの追加',
        digital_sign_add_overlays_dialog_header: 'オーバーレイの追加',
        restart_screen_label: '再起動画面',
        sports_event_label: 'スポーツイベント',
        mam_asset_report: 'マムアセットレポート',
        successfully_delete_storage_label: 'ストレージが正常に削除されました',
        live_event_details: 'ライブイベントの詳細',
        please_create_screen_first_label: 'まずは画面を作成してください...',
        screen_create_description_label: '画面を追加したらコンテンツを作成し、その後プレイリストを作成します。',
        add_screen_button_label: '画面の追加',
        please_create_content_label: 'コンテンツを作成してください...',
        content_create_description_label: 'コンテンツを追加した後、プレイリストを作成できます。',
        add_content_button_label: 'コンテンツの追加',
        please_create_playlist_label: 'プレイリストを作成してください...',
        playlist_create_description_label: 'プレイリストを作成できます。プレイリストの追加をクリックします',
        add_playlist_button_label: 'プレイリストを追加',
        create_content_label: 'コンテンツの作成',
        content_message_label: 'コンテンツを追加しますか?',
        create_playlist_label: 'プレイリストの作成',
        playlist_message_label: 'プレイリストを作成しますか?',
        sync_mam_asset_label: '同期ママアセット',
        localization_dialog_header: 'ローカリゼーション',
        cast_Type_dialog_header: 'キャストタイプ',
        login_again_label: '再度ログインしてください',
        please_image_bucket_name_error_message: 'S3 イメージバケット名を入力してください',
        please_video_bucket_name_error_message: 'S3 ビデオバケット名を入力してください',
        please_enter_image_cdn_url_error_message: 'S3 イメージ CDN URL を入力してください',
        please_enter_video_cdn_url_error_message: 'S3 ビデオ CDN URL を入力してください',
        base_api_key_label: '基本APIキー',
        s3_access_key_id_label: 'S3 アクセスキー ID',
        s3_secret_access_key_label: 'S3 シークレットアクセスキー',
        s3_region_label: 'S3 地域',
        s3_image_bucket_name_label: 'S3 イメージバケット名',
        s3_video_bucket_name_label: 'S3 ビデオバケット名',
        s3_image_cdn_url_label: 'S3 イメージ CDN URL',
        s3_video_cdn_url_label: 'S3 ビデオ CDN URL',
        how_to_create_google_slide: 'Google スライドの作成方法:',
        go_to_google_slide: '提供されたリンクをクリックして、Google スライドのホームページにアクセスします。',
        click_on_homepage_template_option_available: 'ホームページにアクセスしたら、利用可能なオプションから空のスライド テンプレートまたは事前にデザインされたテンプレートを選択します。',
        creating_presentation: '必要に応じてテキスト、画像、デザインをスライドに追加して、プレゼンテーションの作成を開始します。',
        copy_url_of_google_slide: '[公開] ボタンをクリックし、プレゼンテーション URL をコピーし、loop=false パラメーターを追加して、URL 入力フィールドに貼り付けます。',
        custom_title_1_label: 'カスタムタイトル1',
        custom_title_2_label: 'カスタムタイトル2',
        scheduled_playlist_page_breadcrumb: 'スケジュールされたプレイリスト',
        scheduled_playlist_sub_menu: 'スケジュールされたプレイリスト',
        schedule_type_label: 'スケジュールの種類',
        scheduled_playlist_header: 'スケジュールされたプレイリスト',
        no_end_date_label: '終了日なし',
        digital_sign_report_page_breadcrumb: 'レポート',
        digital_sign_report_menu: 'レポート',
        digital_sign_report_header: 'レポート',
        isRightToLeft: '右から左へ',
        show_deal_label: '取引を表示',
        acquition_report_sub_menu: '取得報告書',
        acquisition_report_page_breadcrumb: '取得報告書',
        budget_column: '予算',
        licensor_column: 'ライセンサー',
        payee_column: '受取人',
        contract_media_library_label: '契約メディアライブラリ',
        total_acq_label: '総獲得量',
        amortization_rule_sub_menu: '償却ルール',
        amortization_rule_page_breadcrumb: '償却ルール',
        amortization_rule_dialog_header: '償却ルール',
        rule_text_label: 'ルールテキスト',
        please_select_amortization_rule_message: '償却ルールを選択してください',
        please_enter_rule_text_message: 'ルールテキストを入力してください',
        amortization_rule_label: '償却ルール',
        amortization_rule_report_button_tooltip: '償却報告書',
        amortization_rule_report_dialog_header: '償却報告書',
        rule_text_instruction: '合計が 100% になるように、カンマ区切りのパーセンテージ値を入力します (例: 10、60、30)。',
        invalid_rule_text_total_error_message: 'ルールテキスト値の合計は 100% である必要があります。',
        amortization_rule_column: '償却ルール',
        amortization_value_column: '償却額',
        detach_mam_asset_confirmation_msg: "このアセットをこのメディアから切り離してもよろしいですか?",
        logo_height_label: 'ロゴの高さ',
        select_custom_date_range: 'カスタム日付範囲の選択',
        exhibition_used_label: '展示品使用',
        total_runs_label: '合計実行数',
        exhibition_number_label: '展示番号',
        amortized_value_label: '償却価額',
        exhibition_schedule_label: '展示予定',
        trailer_label: 'トレーラー',
        switch_to_planning_view_tooltip: '計画ビューに切り替える',
        switch_to_series_timeline_view_tooltip: 'シリーズ タイムライン ビューに切り替える',
        upcoming_events_page_breadcrumb: '今後のイベント',
        upcoming_events_sub_menu: '今後のイベント',
        upcoming_events_header: '今後のイベント',
        start_date_lable: '開始日',
        launch_date_label: '発売日',
        upcoming_event_dialog_header: '今後のイベント',
        social_media_menu: 'ソーシャルメディア',
        budget_sub_menu: '予算',
        budget_page_breadcrumb: '予算',
        budget_dialog_header: '予算',
        client_po_no_label: 'クライアントのPO番号',
        agency_commission_label: '代理店委員会',
        can_only_be_in_Percentage: 'パーセンテージ (%) のみを指定できます',
        ad_status_column: '広告ステータス',
        objective_column: '目的',
        daily_budget_column: '1 日の予算',
        spend_cap_column: '支出の上限',
        buying_type_column: '購入タイプ',
        please_enter_client_po_no_error_message: 'クライアントのPO番号を入力してください。',
        please_select_status_error_message: 'ステータスを選択してください',
        please_enter_order_date_error_message: '注文日を選択してください',
        please_enter_agency_error_message: '代理店を入力してください',
        please_enter_client_error_message: 'クライアントを入力してください',
        please_enter_currency_error_message: '通貨を選択してください',
        please_enter_targetAmount_error_message: '目標金額を入力してください',
        please_enter_target_amount_error_message: '目標金額はキャンペーン総支出上限を下回ることはできません',
        please_enter_agency_comission_error_message: '代理店コミッションをマイナスにすることはできません',
        budget_label: '予算',
        campaign_dialog_header: 'キャンペーン',
        objective_label: '目的',
        buying_type_label: '購入タイプ',
        bid_strategy_label: '入札戦略',
        spend_cap_label: '支出の上限',
        daily_budget_label: '1 日の予算',
        special_ad_categories_label: '特別な広告カテゴリ',
        only_two_special_ad_categories: '選択できる特別な広告カテゴリは 2 つだけです。',
        audience_column: '観客',
        please_select_budget_error_message: '予算を選択してください',
        please_enter_start_time_error_message: '開始時間を入力してください',
        please_enter_end_time_error_message: '終了時間を入力してください',
        please_select_objective_error_message: '目的を選択してください',
        please_select_buying_type_error_message: '購入タイプを選択してください',
        please_select_bid_strategy_error_message: '入札戦略を選択してください',
        please_select_spend_cap_error_message: '支出上限を選択してください',
        please_enter_spend_cap_cannot_exceed_available_budget_error_message: '支出上限は利用可能な予算を超えることはできません',
        please_enter_daily_budget_error_message: '1 日の予算を入力してください',
        please_enter_daily_budget_cannot_exceed_spend_cap_error_message: '1 日の予算は支出上限を超えることはできません',
        please_enter_valid_targetAmount_error_message: '有効な目標金額を入力してください',
        sm_ads_page_breadcrumb: '広告',
        title_label: 'タイトル',
        ad_dialog_header: '広告',
        image_column: '画像',
        file_name_column: 'ファイル名',
        format_column: 'フォーマット',
        please_enter_asset_id_error_message: 'アセットIDを入力してください',
        please_attach_at_least_one_asset_error_message: '少なくとも 1 つのアセットを添付してください',
        ads_sub_menu: '広告',
        sm_audience_page_breadcrumb: '観客',
        audience_sub_menu: '観客',
        please_select_geo_location_error_message: '地理的位置を選択してください',
        please_select_interest_error_message: '興味を選択してください',
        please_enter_minimum_age_error_message: '最低年齢を入力してください',
        please_enter_maximum_age_error_message: '最大年齢を入力してください',
        sm_channels_sub_menu: 'チャンネル',
        sm_channels_page_breadcrumb: 'チャンネル',
        publish_button_tooltip: '発行する',
        un_publish_button_tooltip: '非公開',
        spotsperTRP_label: "TRPごとのスポット数",
        target_trp_label: "目標TRP",
        upate_target_spots_button_tooltip: "対象スポットを更新",
        advertising_channel_type_lable: "広告チャネルの種類",
        spand_cap_label: "支出の上限",
        please_select_advertising_channel_type_error_message: "広告チャネルのタイプを選択してください",
        please_enter_cpc_bid_micros_error_message: "支出上限を入力してください",
        to_date_cannot_be_earlier_than_from_date_message: '終了日を開始日よりも前にすることはできません。',
        end_time_cannot_be_earlier_than_start_time_message: '終了時刻を開始時刻より早くすることはできません。',
        stop_date_label: '停止日',
        impressions_label: '感想',
        clicks_label: 'クリック数',
        spends_label: '支出する',
        cpc_label: 'クリック単価',
        cpm_label: 'CPM',
        ctr_label: 'クリック率',
        show_insight_button_tooltip: '洞察を表示する',
        create_audience_button_tooltip: '視聴者の作成',
        audience_created_successfully: 'オーディエンスが正常に作成されました',
        audience_updated_successfully: 'オーディエンスが正常に更新されました',
        error_fetching_insights: 'このキャンペーンのインサイト取得エラー',
        sm_dashboard_sub_menu: 'ダッシュボード',
        social_media_dashboard_page_breadcrumb: 'ダッシュボード',
        campaign_active_label: 'アクティブなキャンペーン',
        campaign_inactive_label: 'キャンペーンが無効です',
        publish_ads_label: '広告を公開する',
        unpublish_ads_label: '広告の非公開',
        campaign_insights_label: 'キャンペーンの洞察',
        spent_column: '費やした',
        bid_strategy_column: '入札戦略',
        skednetwork_attribution_column: 'スカッドネットワーク帰属',
        split_test_variable_column: 'splitTest 変数',
        cpc_column: 'クリック単価',
        cpm_column: 'CPM',
        ctr_column: 'クリック率',
        sm_campaigns_sub_menu: 'キャンペーン',
        sm_campaigns_page_breadcrumb: 'キャンペーン',
        insight_dialog_header: '洞察力',
        facebook_access_token_invalid_message: 'Facebook アクセス トークンが無効か期限切れです。再認証してください',
        failed_to_fetch_facebook_pages_message: 'Facebook ページの取得に失敗しました',
        objective_type_label: '目的の種類',
        please_select_linkedin_objective_type_error_message: '目的のタイプを選択してください',
        please_select_linkedin_type_error_message: 'タイプを選択してください',
        upcoming_campaigns_label: '今後のキャンペーン',
        share_post_label: '投稿で共有する',
        create_post_button: '投稿を作成する',
        quote_label: '引用',
        hashtag_label: 'ハッシュタグ',
        share_on_facebook_button: 'Facebook でシェアする',
        share_on_linkedin_button: 'LinkedIn で共有する',
        share_url_label: 'URLを共有する',
        share_this_link_via_label: 'このリンクを次の方法で共有します',
        cost_type_label: 'コストタイプ',
        add_program_sub_menu: "プログラムの追加",
        search_program_sub_menu: "検索プログラム",
        search_program_by_category_sub_menu: "カテゴリから番組を探す",
        create_add_program_dialog_header: "プログラムの作成",
        inputs_sub_menu: "入力",
        dai_configurations_sub_menu: "構成",
        dai_configurations_page_breadcrumb: '構成',
        output_configuration_setting_label: '出力構成',
        segment_length_label: 'セグメントの長さ',
        admarkers_label: '広告マーカー',
        caption_language_mappings_label: 'キャプション言語マッピング',
        caption_language_setting_label: 'キャプション言語設定',
        client_cache: 'クライアントキャッシュ',
        codec_specification_label: 'コーデック仕様',
        directory_structure_label: 'ディレクトリ構造',
        discontinuity_tags_label: '不連続タグ',
        hlsId3_segment_tagging_label: 'HlsId3 セグメントのタグ付け',
        iframe_only_playlists_label: 'IFrameOnly プレイリスト',
        incomplete_segment_behavior_label: '不完全なセグメントの動作',
        indexn_segments_label: 'インデックスNセグメント',
        input_loss_action_label: '入力損失アクション',
        ivin_manifest_label: 'IvInマニフェスト',
        iv_source_label: 'Iv ソース',
        keep_segments_label: 'セグメントを保持',
        manifest_compression_label: "マニフェスト圧縮",
        manifest_duration_format_label: 'マニフェスト期間形式',
        matchMediaode_label: 'モード',
        output_selection_label: '出力の選択',
        program_datetime_label: '番組日時',
        program_datetimeclock_label: "プログラム日付時刻時計",
        program_datetime_period_label: 'プログラムの日付と期間',
        redundantManifest_label: '冗長マニフェスト',
        segmentation_mode_label: 'セグメンテーションモード',
        segmentsPer_subdirectory_label: 'サブディレクトリごとのセグメント数',
        satisfiestreaminf_resolution_label: 'ストリームの解像度',
        timed_metadataid3frame_label: '時間指定メタデータ Id3 フレーム',
        timed_metadataid3period_label: '時限メタデータ Id3 期間',
        tsFile_mode_label: 'Tsファイルモード',
        avail_configuration_label: 'アベイル構成',
        no_regional_blackout_flag_label: '地域停電フラグなし',
        web_delivery_allowed_flag_label: 'Web配信許可フラグ',
        scte35_segmentation_scope_label: 'Scte35 セグメンテーションの範囲',
        media_configuration_label: 'メディアトレーラーの構成',
        enableAd_markerpassthrough_label: 'AdMarker パススルーを有効にする',
        ad_insertionmode_label: '広告挿入モード',
        avail_suppression_mode_label: 'アベイル抑制モード',
        avail_suppression_valie_label: 'アベイル抑制値',
        input_configuration_label: '入力構成',
        audio_selectors_label: 'オーディオセレクター',
        caption_selectors_label: 'キャプションセレクター',
        deblock_filter_label: 'デブロックフィルター',
        denoise_filter_label: 'ノイズ除去フィルター',
        filter_strength_label: 'フィルター強度',
        input_filter_label: '入力フィルタ',
        buffer_segments_label: 'バッファセグメント',
        retries_label: '再試行',
        retry_interval_label: '再試行間隔',
        scte35_source_label: 'Ste35 ソース',
        server_validation_label: 'サーバーの検証',
        smpte2038_data_preference_label: 'Smpte2038 データ設定',
        source_end_behavior_label: 'ソースエンドの動作',
        deblock_kilter_label: 'デブロックフィルター',
        dai_input_page_breadCrumb: '入力',
        dai_input_dialog_header: '入力',
        input_class_label: '入力クラス',
        password_param_label: 'パスワード',
        outputs_sub_menu: '出力',
        dai_output_page_breadCrumb: '出力',
        dai_output_dialog_header: '出力',
        dai_add_output_dialog_header: '出力の追加',
        please_select_output_name_error_message: '出力名を選択してください',
        name_modifier_label: "名前修飾子",
        audio_rendition_sets_label: "オーディオレンディションセット",
        audio_frames_per_pes_label: "PESごとのオーディオフレーム数",
        audio_pids_label: "オーディオ PID",
        klv_behavior_label: "KLVの動作",
        nielsen_id3_behavior_label: "ニールセン ID3 の動作",
        pcr_control_label: "PCRコントロール",
        pmt_pid_label: "PMT PID",
        program_num_label: "プログラム番号",
        scte35_behavior_label: "SCTE35の動作",
        scte35_pid_label: "SCTE35 PID",
        timed_metadata_behavior_label: "時間指定されたメタデータの動作",
        timed_metadata_pid_label: "時限メタデータ PID",
        video_pid_label: "ビデオ PID",
        video_descriptions_title: "ビデオの説明",
        h264_settings_title: "H264 設定",
        afd_signaling_label: "AFDシグナリング",
        bitrate_label: "ビットレート",
        framerate_control_label: "フレームレート制御",
        gop_size_label: "GOP サイズ",
        gop_size_units_label: "GOP サイズの単位",
        rate_control_mode_label: "レート制御モード",
        scan_type_label: "スキャンタイプ",
        scene_change_detect_label: "シーンチェンジ検出",
        timecode_insertion_label: "タイムコードの挿入",
        audio_descriptions_title: '音声による説明',
        audio_name_label: '名前',
        audio_type_control_label: 'オーディオタイプコントロール',
        aac_settings_title: 'AAC設定',
        coding_mode_label: 'コーディングモード',
        input_type_label: '入力タイプ',
        profile_label: 'プロフィール',
        raw_format_label: '生の形式',
        sample_rate_label: 'サンプルレート',
        specification_label: '仕様',
        output_name_label: '出力名',
        timezone_label: 'タイムゾーン',
        addition_timezone_label: '追加のタイムゾーン',
        enable_additional_timezone_label: '追加のタイムゾーンを有効にする',
        main_timezone_label: 'メインタイムゾーン',
        enable_main_timezone_label: "メインタイムゾーンを有効にする",
        dai_channels_sub_menu: "チャンネル",
        dai_channels_page_breadcrumb: "チャンネル",
        dai_channel_dialog_header: "チャンネルの作成",
        input_label: '入力',
        output_label: '出力',
        configuration_label: '構成',
        please_select_input_error_message: '入力を選択してください',
        please_select_output_error_message: '出力構成を選択してください',
        please_select_transcoding_configuration_error_message: 'トランスコーディング構成を選択してください',
        please_enter_destination_s3_url_error_message: '宛先の S3 URL を入力してください',
        destinatio_s3_url_label: '宛先S3 URL',
        avail_suppression_fill_policy_label: 'Avail 抑制フィルポリシー',
        dai_inputs_page_breadCrumb: '入力',
        dai_outputs_page_breadCrumb: '出力',
        add_avail_offset_label: "アベイルズオフセット",
        avail_suppression_value_label: 'アベイル抑制値',
        preview_label: 'プレビュー',
        ad_decision_server_url_label: '広告決定サーバー',
        video_content_source_url_label: 'ビデオソースURL',
        hls_url_label: 'HLS URL',
        dash_url_label: 'ダッシュURL',
        file_name_label: 'ファイル名',
        please_enter_file_name_error_message: 'ファイル名を入力してください',
        no_preview_available_label: '利用可能なプレビューがありません',
        dai_sctes_sub_menu: 'SCTES',
        dai_sctes_page_breadcrumb: 'SCTES',
        dai_sctes_dialog_header: 'SCTEの追加',
        action_name_label: 'アクション名',
        time_label: '時間',
        please_enter_date_time_error_message: '日付と時刻を入力してください',
        choose_file_button: 'ファイルを選択',
        no_file_selected: 'ファイルが選択されていません',
        import_file_dialog_header: 'インポートファイル',
        sctes_label: 'SCTES',
        upload_file_button_text: 'ファイルをアップロードする',
        import_label: 'インポート',
        event_id_column: 'イベントID',
        publish_all_button_text: 'すべて公開',
        publish_all_button_tooltip: 'すべて公開',
        update_SCTE_marker_actionbutton_menutext: "SCTE マーカーの更新",
        scte_marker_label: "SCTE マーカー",
        dai_configuration_sub_menu: '構成',
        create_input_button_tooltip: '入力の作成',
        create_output_button_tooltip: '出力構成の作成',
        create_configuration_button_tooltip: '構成の作成',
        outputs_label: '出力',
        edit_input_button_tooltip: '入力の編集',
        edit_output_button_tooltip: '出力構成の編集',
        edit_configuration_button_tooltip: '構成の編集',
        scte_on_actionbutton_menutext: "SCTE ONを適用する",
        scte_off_actionbutton_menutext: "SCTE オフを適用する",
        remove_scte_actionbutton_menutext: "SCTEの削除",
        cannot_apply_SCTE_marker_error_message: "セグメントに SCTE マーカーを適用できません。",
        show_invalid_format_label: "無効な形式",
        music_library_dialog_header: '音楽ライブラリ',
        scte_start_and_end_error_message: "SCTE の開始数と終了数が同じではありません。",
        wrong_scte_marker_sequence_error_message: "間違った SCTE マーカー配列。",
        start_date_time_label: '開始日時',
        end_date_time_label: '終了日時',
        downlaod_sctes_button_tooltip: 'SCTESをダウンロード',
        dai_channel_delete_error_messgae: 'このチャンネルを削除する権利はありませんので、管理者に連絡してください',
        un_publish_button_text: '非公開',
        scte_duplicate_error_message: 'SCTEはすでに存在します',
        re_publish_button_text: '再発行',
        re_publish_button_tooltip: '再発行',
        music_playlist_sub_menu: '音楽プレイリスト',
        music_playlist_page_breadCrumb: '音楽プレイリスト',
        music_playlist_dialog_header: '音楽プレイリスト',
        ott_asset_library_dialog_header: 'オットアセットライブラリ',
        please_select_playlist: 'プレイリストを選択してください',
        music_list_label: '音楽リスト',
        please_add_mp3_video_for_music: '音楽プレーヤーに MP3 のビデオタイプを追加してください',
        create_media_subcategory_type_button_tooltip: "メディア サブカテゴリ タイプの作成",
        channel_type_label: 'チャンネルタイプ',
        transcoding_label: 'トランスコーディング',
        ad_insertion_label: '広告の挿入',
        please_select_channel_type_error_message: 'チャンネルタイプを選択してください',
        destination_label: '目的地',
        please_enter_destination_error_message: '目的地を入力してください',
        please_enter_video_source_url_error_message: 'ビデオソースのURLを入力してください',
        please_enter_ad_decision_server_error_message: '広告決定サーバーを入力してください',
        please_enter_valid_video_source_url_error_message: '有効なビデオ ソースの URL を入力してください',
        dai_transcodings_sub_menu: 'トランスコーディング',
        dai_transcodings_page_breadcrumb: 'トランスコーディング',
        dai_transcoding_dialog_header: 'トランスコーディングの作成',
        dai_ad_insertions_sub_menu: '広告の挿入',
        dai_ad_insertions_page_breadcrumb: '広告の挿入',
        dai_ad_insertion_dialog_header: '広告挿入の作成',
        skip_media_category_type_for_SCTE_label: "スキップメディアSCTE",
        import_commercials: "輸入コマーシャル",
        please_select_route_type_error_message: "ルートの種類を選択してください",
        please_select_ad_insertion_configuration_error_message: "広告挿入設定を選択してください",
        file_date_and_schedule_date_mismatch: "ファイルの日付とスケジュールの日付が一致しません",
        fetch_ahead_label: '先へフェッチ',
        station_code_label: '駅コード',
        please_enter_fetch_ahead_error_message: '先にフェッチを入力してください',
        please_select_station_code_error_message: '駅コードを選択してください',
        please_enter_valid_fetch_ahead_error_message: '範囲0～6のみ',
        total_count_label: '総数',
        last_air_time_label: '最終放送時間',
        output_configuration_label: '出力構成',
        create_adInsertion_button_tooltip: '広告挿入設定の作成',
        edit_adInsertion_button_tooltip: '広告挿入設定の編集',
        verify_button_text: "検証する",
        import_commercial_file_label: "輸入商業",
        to_date_should_not_be_less_than_from_date_error_message: "[終了日] は [開始日] より小さくてはなりません",
        from_date_to_date_should_not_be_more_than_7_days: "開始日と終了日の差は 7 日を超えてはいけません",
        ch_number_label: 'Ch.いいえ。',
        channel_suffix_label: 'チャンネルサフィックス',
        filter_template_tooltip: "フィルターテンプレート",
        please_select_language_media_episode_cast_and_crew_error_message: "キャストとスタッフの言語を選択してください",
        filter_criteria_label: "フィルタ基準",
        keyword_label: 'キーワード',
        attach_mam_asset_tooltip: "MAM アセットをアタッチする",
        EMRC_label: 'EMRC',
        MRC_days_label: 'MRCデイズ',
        mrc_days_valid_error_message: '範囲は 0 ～ 10 のみにしてください',
        EMRC_tooltip_msg: '有効にすると、システムは EMRC 設定に基づいて、MRC 日の前後にメディアの繰り返しをチェックします。',
        export_missing_segment_mam_report_button_tooltip: 'Export Missing Segment/MAM Report',
        please_select_filters_msg: 'フィルターを選択/検索してください',
        missing_segment_planning_report_dialog_header: '欠落セグメント/MAMレポート',
        planned_slot_time_label: '予定されたスロット時間',
        mam_id_column: 'ママID',
        hard_disk_label: "ハードディスク",
        add_time_repeat_block_button: "タイムリピートの追加",
        exceeding_slot_duration_error_message: "スロット期間を超えています",
        overlapping_timecodes_error_message: "重複するタイムコード",
        from_date_to_date_should_not_be_more_than_days_error_message: "開始日と終了日の差は以下でなければなりません",
        invalid_duration_segment_error_message: '有効な期間/タイムコードを入力してください',
        please_select_media_category_error_message: 'メディア カテゴリを選択してください',
        please_enter_classification_error_message: '分類を入力してください',
        please_enter_officer_error_message: '役員を入力してください',
        please_select_result_error_message: '結果を選択してください',
        ott_aggregator_sub_menu: "アグリゲータ",
        ott_aggregator_page_breadCrumb: "アグリゲータ",
        ott_aggregator_dialog_header: "アグリゲーターの作成",
        content_distribution_sub_menu: "コンテンツ配信",
        content_distribution_page_breadCrumb: "コンテンツ配信",
        content_distribution_dialog_header: "コンテンツ配布の作成",
        aggregator_label: "アグリゲータ",
        access_key_label: "アクセスキー",
        assets_label: "資産",
        copied_to_clipboard_message: "クリップボードにコピーされました",
        please_select_aggregator_error_message: "アグリゲータを選択してください",
        distribution_label: "配布",
        content_distribution_response_type_label: "コンテンツ配信応答タイプ",
        content_distribution_api_label: "コンテンツ配信API",
        please_select_distribution_api: "ディストリビューション API とベース URL を選択してください",
        delivery_label: "配送",
        please_select_delivery_error_message: "配送タイプを選択してください",
        please_enter_ftp_host_error_message: "FTP ホストを入力してください。",
        please_enter_ftp_username_error_message: "FTP ユーザー名を入力してください。",
        please_enter_ftp_password_error_message: "FTPパスワードを入力してください。",
        please_enter_ftp_remote_path_error_message: "FTP リモート パスを入力してください。",
        ftp_host_label: "ホスト",
        ftp_remote_path_label: "リモートパス",
        please_generate_access_key_error_message: "アクセスキーを生成してください",
        create_loop_actionbutton_menutext: 'ループの作成',
        create_loop_dialog_header: 'ループの作成',
        start_time_cannot_be_greater_than_end_time_error_message: '開始時刻を終了時刻より大きくすることはできません',
        publishable_key_label: "公開可能なキー",
        add_provider_button_tooltip: "プロバイダーの追加",
        select_provider_label: "プロバイダーの選択",
        select_create_from_button_tooltip: "作成元",
        save_and_close_text: "保存して閉じる",
        os_label: "OS",
        period_label: "期間",
        media_filter_label: "メディアフィルター",
        media_filter_dialog_header: "メディアフィルター",
        remove_filter_button_tooltip: "フィルターを削除",
        media_filter_info: "メディア フィルターを使用すると、アセット タイプ、プロバイダー、アクセス レベル、VOD タイプ、セグメントなどのさまざまな基準に基づいてメディアをフィルターできます。カスタム フィルターを作成して、メディア管理プロセスを合理化し、関連するコンテンツをすばやく見つけることができます。",
        branding_logo_column: "ブランドロゴ",
        os_column: 'OS',
        please_select_period_error_message: '期間を選択してください',
        please_select_os_error_message: 'OSを選択してください',
        product_id_label: "プロダクトID",
        sandbox_mode_label: "サンドボックスモード",
        please_select_name_error_message: "名前を選択してください",
        please_enter_country_code_error_message: "国コードを入力してください",
        please_enter_product_id_required_for_applesubscription_in_payments_error_message: "AppleSubscription の支払いには ProductId が必要ですので入力してください。",
        product_id_info_message: "製品 ID は、モバイル アプリケーションでアプリ内購入やサブスクリプションを管理するために使用される一意の識別子です。これは、ユーザーが購入しようとしている製品 (この場合は毎週の定期購入など) をアプリが正確に認識するのに役立ちます。この ID はアプリ ストアに登録されており、アプリのコードで使用されているものと一致する必要があります。",
        dummy_planning_dialog_header: "ダミー企画",
        break_template_label: "ブレークテンプレート",
        repeat_pattern_column: "リピートパターン",
        slot_date_label: "スロット日付",
        duration_without_format_label: "期間",
        add_mam_asset_label: "MAM アセットの追加",
        mam_assets_label: "ママアセット",
        please_select_media_sub_category_error_message: "メディア サブ カテゴリ タイプを選択してください",
        default_region_label: "デフォルトの地域",
        device_access_control_label: "デバイスアクセス制御",
        authentication_type_label: "認証タイプ",
        splash_screen_mobile_label: "スプラッシュ スクリーン モバイル",
        splash_screen_tv_label: "スプラッシュ スクリーン テレビ",
        aspect_ratio_mobile_message: "モバイルのアスペクト比 (iOS および Android): 9:16",
        aspect_ratio_tv_message: "TV のアスペクト比 (Android TV): ノーマルおよび 4K UHD - 16:9",
        notification_menu: "お知らせ",
        notification_manager_sub_menu: "通知マネージャー",
        notification_manager_page_breadCrumb: "通知マネージャー",
        notification_manager_dialog_header: "通知マネージャー",
        user_select_dialog_header: "ユーザー選択",
        asset_select_dialog_header: "アセットの選択",
        notification_send_label: "送信",
        please_select_group_error_message: "グループを選択してください",
        please_select_user_error_message: "ユーザーを選択してください",
        please_select_image_url_error_message: "画像の URL を選択してください",
        select_asset_label: "アセットの選択",
        user_label: "ユーザー",
        amortisation_value_report: "償却価額レポート",
        remove_as_important: "重要として削除",
        set_as_important: "重要として設定",
        router_command_label: "ルーターコマンド",
        add_router_command: "ルーターコマンドの追加",
        add_router_command_actionbutton_menutext: "ルーターコマンドの追加",
        update_router_command_actionbutton_menutext: "ルーター更新コマンド",
        router_command_can_only_be_added_for_live_and_sdd: "Router コマンドは Live および SDD にのみ追加できます",
        measurement_id_label: "測定ID",
        please_enter_measurement_id_error_message: "測定IDを入力してください",
        please_enter_api_secret_error_message: "API 秘密キーを入力してください",
        analytics_provider_label: "分析プロバイダー",
        token_label: "トークン",
        please_enter_token_error_message: "トークンを入力してください",
        commercial_consumption_report_sub_menu: "商業消費レポート",
        commercial_consumption_report_header: "商業消費レポート",
        download_commercial_consumption_report_tooltip_button: '商業消費レポートのダウンロード',
        schedule_export_history_sub_menu: 'スケジュールのエクスポート履歴',
        schedule_export_history_header: 'スケジュールのエクスポート履歴',
        manual_label: "マニュアル",
        add_cast_and_crew_tooltip: "複数のキャストとクルーを追加する",
        please_enter_cast_name_error_message: "キャスト名を入力してください",
        please_select_cast_type_error_message: "キャストタイプを選択してください",
        macro_name_label: "マクロ名",
        ott_subtitle_label: "サブタイトル",
        create_subtitle_header: "字幕の作成",
        language_code_column: "ラングコード",
        video_thumbnail_vtt_url_message: "サムネイル プレビュー用の直接画像 URL または Web vtt ファイルをサポートします。",
        show_menu_label: "表示する",
        logs_menu_label: 'ログ',
        exhibitions_menu_label: '展示会',
        deal_menu_label: 'お得情報',
        media_menu_label: 'メディア',
        run_button_text_planning: '走る',
        update_properties_button_text_planning: 'プロパティを更新する',
        update_multiple_title_button: "複数の更新",
        update_cast_and_crew_title_button: "キャストとスタッフを更新",
        ott_assets_label: "OTT アセット",
        sync_with_media_episodes_label: "メディアエピソードと同期する",
        foreground_color_label: "前景色",
        foreground_color_sm_label: "フォアカラー",
        background_color_label: "背景色",
        background_color_sm_label: "バックカラー",
        large_video_compress_message: '大きなビデオの場合は、アップロードする前に圧縮してください。',
        video_format_mpeg_message: 'ビデオ形式が MPEG-4 であることを確認してください。変換するには、使用します',
        click_here_to_currency_code_message: '通貨コードはここをクリックしてください',
        export_commercials_label: "Export Commercials",
        please_save_season_first_error_message: "まずシリーズを保存してください",
        setting_header: "設定",
        settings_updated_successfully_message: "設定が正常に更新されました",
        music_airing_report_sub_menu: "音楽オンエアレポート",
        music_airing_report_page_breadcrumb: "音楽オンエアレポート",
        performance_year_column: "業績年",
        performance_month_column: "パフォーマンス月間",
        performance_day_column: "パフォーマンスデー",
        performer_artist_column: "パフォーマー アーティスト",
        record_label_column: "レコードレーベル",
        publisher_column: "出版社",
        composer_column: "作曲家",
        risa_member_column: "りさメンバー",
        duration_min_column: "持続時間の最小値",
        duration_sec_column: "期間秒",
        break_pattern_report_sub_menu: "ブレークパターンレポート",
        break_pattern_report_page_breadcrumb: "ブレークパターンレポート",
        record_label_label: "レコードレーベル",
        publisher_label: "出版社",
        is_expired_label: "有効期限が切れています",
        only_label: "のみ",
        bucket_configurations_breadcrumb: 'バケット構成',
        bucket_breadcrumb: 'バケツ',
        bucket_configurations_menu: "バケット構成",
        bucket_menu: "バケツ",
        bucket_configurations_sub_menu: "バケット構成",
        bucket_sub_menu: "バケツ",
        bucket_config_label: 'バケット構成',
        please_enter_access_key_error_message: 'アクセスキーを入力してください',
        folder_path_label: 'フォルダーのパス',
        please_select_bucket_configuration_error_message: "バケット構成を選択してください",
        please_enter_folder_path_error_message: "フォルダーのパスを入力してください",
        check_label: "チェックする",
        move_to_media_management_label: "メディア管理に移動",
        move_to_Archive: "アーカイブに移動",
        size_label: "サイズ",
        detach_file_confirmation_msg: "このファイルを切り離してもよろしいですか?",
        offer_sub_menu: "オファー",
        price_code_sub_menu: "価格コード",
        offer_page_breadcrumb: "オファー",
        price_code_breadcrumb: "価格コード",
        programs_generic_label: "汎用プログラム",
        price_label: '価格',
        price_code_label: '価格コード',
        please_enter_display_title_error_message: '表示タイトルを入力してください',
        offer_label: "オファー",
        runs_label: "走る",
        offer_type_label: 'オファーの種類',
        content_tree_view_menu: "コンテンツツリー",
        node_tree_view_menu: "ノードツリー",
        content_tree_view_page_breadcrumb: "コンテンツツリー",
        node_tree_view_page_breadcrumb: "ノードツリー",
        select_a_category_from_the_tree_to_view_media_message: "ツリーからカテゴリを選択してメディアを表示します",
        no_media_found_for_this_category_message: "このカテゴリのメディアが見つかりませんでした",
        try_selecting_another_category_message: "別のカテゴリを選択してみてください",
        copybreak_schedule_menu_text: 'ブレークアイテムのコピー',
        pastebreak_schedule_menu_text: 'ブレークアイテムの貼り付け',
        no_categories_found_message: "カテゴリが見つかりませんでした",
        no_nodes_found_message: "ノードが見つかりません",
        content_categories_label: "コンテンツカテゴリ",
        nodes_label: "ノード",
        add_content_category_label: "コンテンツカテゴリの追加",
        edit_content_category_label: "コンテンツカテゴリの編集",
        delete_content_category_label: "コンテンツカテゴリの削除",
        please_enter_runs_error_message: "実行を入力してください",
        please_select_offer_error_message: "オファーを選択してください",
        select_offers_label: "オファーを選択してください",
        you_delete_this_offer_from_parent_series_only_error_message: "権限がありません: このオファーは親シリーズからのみ削除できます",
        you_delete_this_offer_from_series_only_error_message: "未承認 : このオファーはシリーズからのみ削除できます",
        you_delete_this_offer_from_contract_only_error_message: "未承認 : このオファーは契約からのみ削除できます",
        create_offer_button_tooltip: "オファーの作成",
        vod_report_sub_menu: "VODレポート",
        vod_report_page_breadcrumb: "VODレポート",
        attech_media_category_button_tooltip: "アテックメディア部門",
        please_select_media_category_selection_error_message: "特定のメディア カテゴリを選択してください。 「すべて」は表示専用モードです",
        update_all_media_by_category_button_tooltip: "カテゴリごとにすべてのメディアを更新します",
        export_appendix12_tooltip: 'Export Appendix 12 XML',
        export_appendix11_tooltip: 'Export Appendix 11 XML',
        export_appendix8_tooltip: 'Export Appendix 8 XML',
        appendix8: '付録 8',
        appendix11: '付録 11',
        appendix12: '付録 12',
        mark_as_catch_up_actionbutton_menutext: 'キャッチアップとしてマーク',
        un_marked_as_catch_up_actionbutton_menutext: 'キャッチアップとしてマークされていない',
        translated_display_title_label: '翻訳された表示タイトル',
        translated_Description_label: '翻訳された説明',
        please_enter_translated_display_title_error_message: '翻訳された表示タイトルを入力してください',
        please_enter_translated_description_error_message: '翻訳された説明',
        pay_per_time_label: '時間ごとに支払う',
        ris_label: 'リス',
        image_groups_sub_menu: '画像グループ',
        catalogues_sub_menu: 'カタログ',
        image_groups_page_breadcrumb: '画像グループ',
        catalogues_page_breadcrumb: 'カタログ',
        transmission_type_label: "伝送方式",
        transmission_type_column: "伝送方式",
        parental_rating_label: '保護者による評価',
        image_group_label: '画像グループ',
        external_reference_label: '外部リファレンス',
        nodes_sub_menu: 'ノード',
        nodes_page_breadcrumb: 'ノード',
        please_select_image_group_error_message: '画像グループを選択してください',
        please_enter_valid_parental_rating_error_message: '有効な保護者による評価を入力してください',
        please_select_parent_error_message: '親を選択してください',
        please_select_vod_channel_error_message: 'VOD チャンネルを選択してください',
        please_enter_external_reference_error_message: '外部参照を入力してください',
        create_transmission_button_tooltip: '送信の作成',
        channels_label: 'チャンネル',
        vod_channels_label: 'VOD チャンネル',
        attach_nodes_button_tooltip: 'ノードの接続',
        select_nodes_dialog_header: 'ノードの選択',
        catalogue_label: 'カタログ',
        please_select_catalogue_error_message: 'カタログを選択してください',
        transmission_types_page_breadcrumb: '伝送タイプ',
        transmission_types_sub_menu: '伝送タイプ',
        transmission_type_header: '伝送方式',
        VODtype_label: 'VODの種類',
        please_select_vod_channels_error_message: 'VOD チャンネルを選択してください',
        please_select_nodes_error_message: 'ノードを選択してください',
        vod_channels_column: 'VOD チャンネル',
        nodes_column: 'ノード',
        publish_transmission_button_tooltip: 'パブリッシュ送信',
        please_save_media_first_error_message: 'まずメディアを保存してください',
        mam_asset_menu: 'MAM資産',
        transcode_definition_sub_menu: 'トランスコード定義',
        transcode_definition_header: 'トランスコード定義',
        technical_details_label: '技術的な詳細',
        bit_rate_label: 'ビットレート',
        file_size_label: 'ファイルサイズ',
        file_location_label: 'ファイルの場所',
        checksum_label: 'チェックサム',
        please_select_parent_rating_error_message: '親の評価を選択してください',
        sid_label: 'シド',
        node_browser_menu: 'ノードブラウザ',
        node_browser_page_breadcrumb: 'ノードブラウザ',
        ingest_prototype_page_breadcrumb: 'プロトタイプの取り込み',
        ingest_prototype_sub_menu: 'プロトタイプの取り込み',
        direct_ingest_label: '直接取り込み',
        censorship_flag_label: '検閲フラグ',
        asset_group_label: '資産グループ',
        dual_sound_label: 'デュアルサウンド',
        subtitles_flag_label: '字幕フラグ',
        subtitling_code_label: '字幕コード',
        subtitling_lang_label: '字幕ラング',
        subtitling_mode_label: '字幕モード',
        thumbnail_label: 'サムネイル',
        language1_label: '言語1',
        hd_label: 'HD',
        please_select_asset_group_error_message: 'アセットグループを選択してください',
        ingest_prototype_header: 'プロトタイプの取り込み',
        ingest_prototype_label: 'プロトタイプの取り込み',
        ingest_prototype_column: 'プロトタイプの取り込み',
        ingest_prototype_tooltip: 'プロトタイプの取り込み',
        please_select_ingest_prototype_error_message: 'プロトタイプの取り込みを選択してください',
        transcode_definition_page_breadcrumb: 'トランスコード定義',
        transcode_Prototypes_page_breadcrumb: 'トランスコード プロトタイプ',
        transcode_Prototypes_sub_menu: 'トランスコード プロトタイプ',
        transcode_Prototypes_header: 'トランスコード プロトタイプ',
        title_flag_label: 'タイトルフラグ',
        logo_flag_label: 'ロゴフラッグ',
        logo_opposite_label: 'ロゴの反対側',
        ending_flag_label: '終了フラグ',
        definition_label: '定義',
        reverse_audio_channel_flag_label: 'リバースオーディオチャンネルフラグ',
        tag_flag_label: 'タグフラグ',
        please_enter_audio_mode_error_message: 'オーディオモードに入ってください',
        transcode_prototype_label: 'トランスコード プロトタイプ',
        please_select_direct_ingest_error_message: '直接取り込みを選択してください',
        please_select_transcode_prototype_error_message: 'トランスコード プロトタイプを選択してください',
        transcode_prototype_column: 'トランスコード プロトタイプ',
        transmission_status_column: "送信ステータス",
        mam_asset_status_column: "MAMステータス",
        hide_node_label: 'ノードを非表示にする',
        show_node_label: 'ノードの表示',
        node_hidden_success_message: 'ノードが正常に非表示になりました',
        node_show_success_message: 'ノードが正常に表示されました',
        node_hidden_error_message: 'ノードの非表示に失敗しました',
        node_show_error_message: 'ノードの表示に失敗しました',
        ingest_work_order_exported_successfully_message: '作業指示書の取り込みが正常にエクスポートされました',
        genreId_label: 'ジャンルID',
        subGenreId_label: 'サブジャンルID',
        channel_groups_page_breadcrumb: 'チャネルグループ',
        channel_groups_sub_menu: 'チャネルグループ',
        channel_groups_header: 'チャネルグループ',
        select_channel_groups_collection_header: 'チャネル グループ コレクションの選択',
        select_channel_groups_tooltip: 'チャネルグループの選択',
        offer_already_published_error_message: 'オファーはすでに公開されています',
        some_offers_already_published_error_message: '一部のオファーはすでに公開されています',
        attach_offers_button_tooltip: 'オファーを添付する',
        create_mamasset_and_wo_button_tooltip: 'MAM アセットと WorkOrder を作成する',
        you_cannot_delete_published_offer_error_message: 'すでに公開されているオファーは削除できません。削除したい場合は、まずオファーを非公開にしてください',
        please_enter_valid_copy_from_date_error_message: '有効なコピー開始日を入力してください',
        please_enter_valid_copy_to_date_error_message: '有効なコピーの日付を入力してください',
        please_enter_valid_copy_to_from_date_error_message: '有効なコピー開始日を入力してください',
        please_enter_valid_copy__to_todate_error_message: '有効な CopyTo To Date を入力してください',
        export_dublist_label: 'Export Dublist',
        export_vod_catalogue_label: 'Export VOD Catalogue',
        export_incremental_catalogue_label: 'Export Incremental Catalogue',
        export_inc_catalogue_label: "Export Inc Catalogue",
        export_delete_list_label: 'Export Delete List',
        asset_offer_link_browser_menu: 'オファーブラウザ',
        asset_offer_link_browser_page_breadcrumb: 'オファーブラウザ',
        asset_offer_multiple_update_tooltip: 'すべて公開',
        asset_offer_multiple_unpublish_tooltip: 'すべて非公開',
        multiple_update_label: '複数の更新',
        publish_confirmation_title: 'オファーの公開の確認',
        multiple_publish_update_confirmation_message: '選択したすべてのアセットオファーを公開しますか?',
        multiple_publish_update_note: '注: すでに公開されているアセット オファーはスキップされます',
        unpublish_confirmation_title: 'オファー非公開の確認',
        multiple_unpublish_update_confirmation_message: '選択したアセットオファーをすべて非公開にしますか?',
        multiple_upublish_update_note: '注: すでに未公開のアセット オファーはスキップされます',
        external_refrence_label: '外部基準',
        please_select_media_error_message: "メディアを選択してください",
        un_mark_as_black_out_actionbutton_menutext: 'ブラックアウトとしてマークを解除する',
        mark_as_black_out_actionbutton_menutext: 'ブラックアウトとしてマーク',
        you_cannot_edit_published_offer_error_message: 'すでに公開されているオファーは編集できません。編集したい場合は、まずオファーを非公開にしてください',
        simul_cast_channel_configuration_page_breadcrumb: 'サイマルキャスト チャネルの構成',
        simul_cast_channel_configuration_sub_menu: 'サイマルキャスト チャネルの構成',
        primary_channel_label: 'プライマリチャネル',
        simul_cast_channel_configuration_header: 'サイマルキャスト チャネルの構成',
        mapped_channels_label: 'マッピングされたチャネル',
        cannot_mark_default_for_segments_with_transmission_type_selected_error_message: '送信タイプが選択されているセグメントのデフォルトをマークできません',
        non_linear_transmission_label: '非線形伝送',
        linear_transmission_label: 'リニアトランスミッション',
        media_sub_type_label: 'メディアのサブタイプ',
        select_provider_collection_header: 'プロバイダーの選択',
        select_pgrating_collection_header: 'グレーティングの選択',
        confirm_alert_delete_all_message: 'アラートを確認 すべて削除',
        delete_all_label: 'すべて削除',
        error_exporting_xml_error_message: 'XMLのエクスポート中にエラーが発生しました',
        trailer_booking_sub_menu: 'トレーラーの予約',
        publish_menu: '発行する',
        publish_page_breadcrumb: '発行する',
        publish_type_label: 'パブリッシュタイプ',
        report_is_not_exported_error_message: 'レポートはエクスポートされません。もう一度お試しください。',
        simulcast_label: '同時放送',
        please_enter_price_error_message: '価格を入力してください',
        please_enter_start_date_time_error_message: '開始日時を入力してください',
        please_enter_end_date_time_error_message: '終了日時を入力してください',
        please_wait_export_message: 'エクスポートをお待ちください...',
        exported_successfully_message: 'Exported successfully',
        report_type_label: 'レポートの種類',
        please_select_report_type_error_message: 'レポートの種類を選択してください',
        you_are_not_authorized_to_publish_please_go_to_parent_series_error_message: "ここから公開/非公開にする権限がありません。親シリーズに移動してください",
        you_are_not_authorized_to_publish_please_go_to_series_error_message: "ここから公開/非公開にする権限がありません。シリーズへどうぞ",
        you_edit_this_offer_from_contract_only_error_message: "このオファーは契約からのみ編集できます",
        you_publish_this_offer_from_contract_only_error_message: "このオファーは契約からのみ公開/非公開にすることができます",
        sid_column: 'シド',
        offer_csid_column: 'CSIDを提供する',
        offer_id_column: 'オファーID',
        nodes_id_column: 'ノードID',
        search_label: '検索',
        node_csid_label: 'ノードID',
        offer_csid_label: 'オファーID',
        price_code_csid_label: '価格コードID',
        catalogue_dashboard: 'カタログダッシュボード',
        epg_file_status_label: 'EPG ファイルのステータス',
        vod_file_status_label: 'VOD ファイルのステータス',
        publish_file_status_label: 'パブリッシュファイルステータス',
        target_types_page_breadcrumb: 'ターゲットの種類',
        target_types_sub_menu: 'ターゲットの種類',
        target_type_header: 'ターゲットの種類',
        transcoding_Work_order_label: 'トランスコーディング WO の作成',
        ingest_Work_order_label: '作成 インジェスト WO',
        set_mam_status_as_pending_label: 'ママのステータスを保留中として設定します',
        reset_button_text: 'リセット',
        some_spots_are_txready_selected_spots_error_message: '一部のスポットは TXReady ですが、トランスコーディング作業指示を作成できません',
        transcoding_work_order_confirmation_message: 'トランスコーディングWO確認！',
        transcoding_work_order_confirmation_text: 'トランスコーディング作業指示書はすでに作成されていますが、再度作成しますか?',
        publish_provider_label: 'プロバイダーの公開',
        vod_catalogue_menu: 'VODカタログ',
        vod_catalogue_page_breadcrumb: 'VODカタログ',
        epgs_menu: 'EPG',
        epgs_page_breadcrumb: 'EPG',
        schedule_export_menu: 'スケジュール',
        schedule_export_page_breadcrumb: 'スケジュール',
        promo_campaign_page_breadcrumb: 'プロモーションキャンペーン',
        promo_campaign_sub_menu: 'プロモーションキャンペーン',
        broadcast_windows_label: 'ブロードキャストウィンドウ',
        broadcast_windows_tooltip: 'ブロードキャストウィンドウ',
        from_date_cannot_be_greater_than_to_date: '開始日は終了日より大きくすることはできません',
        target_type_label: 'ターゲットの種類',
        target_type_column: 'ターゲットの種類',
        weightage_header: '体重',
        weightage_type: '重量タイプ',
        frequency_type: '周波数の種類',
        weightage_value: '重み付け値',
        frequency_value: '周波数値',
        please_select_weightage_type_error_message: '重量タイプを選択してください',
        please_select_frequency_type_error_message: '周波数タイプを選択してください',
        percentage_should_not_exceed_100_error_message: 'パーセンテージは 100% を超えてはなりません',
        trailers_cardlist_header: 'トレーラー',
        sidefix_trailers_tooltip: 'トレーラー',
        target_value: '目標値',
        optional_label: 'オプション',
        no_valid__offer_to_unpublish_error_message: "オファーはすでに非公開になっています。親ソースからのみ非公開にできます。",
        select_mam_ingestion_header: "MAMの摂取",
        please_select_transmission_type_error_message: "伝送タイプを選択してください",
        version_type_label: "バージョンの種類",
        please_select_verison_type_error_message: "バージョンタイプを選択してください",
        log_browser_page_breadcrumb: 'ログブラウザ',
        file_log: 'ファイルログ',
        epg_export_label: "EPG エクスポート",
        vod_import_label: "VOD インポート",
        vod_export_label: "VOD エクスポート",
        work_order_import_label: "作業指示書のインポート",
        work_order_export_label: "作業指示書のエクスポート",
        version_category_label: "バージョンカテゴリ",
        version_category_column: "バージョンカテゴリ",
        file_publish_label: "ファイルのパブリッシュ",
        mam_report_sub_menu: "ママ",
        mam_report_page_breadcrumb: "ママ",
        dublist_report_sub_menu: "ダブリスト",
        dublist_report_page_breadcrumb: "ダブリスト",
        purge_list_report_sub_menu: "パージリスト",
        purge_list_report_page_breadcrumb: "パージリスト",
        select_transcode_prototype: "トランスコード プロトタイプの選択",
        process_monitoring_label: "プロセス監視",
        transmission_list_report_sub_menu: "送信リスト",
        transmission_list_report_page_breadcrumb: "送信リスト",
        vod_sub_menu: "VOD",
        ingest_tooltip: "MAM への取り込み",
        node_report_sub_menu: 'ノードレポート',
        node_page_breadcrumb: 'ノード',
        please_select_node_error_message: 'ノードを選択してください',
        schedule_sub_menu: 'スケジュール',
        versions_label: "バージョン",
        mamassets_label: "MAM資産",
        offers_label: "オファー",
        transmission_browser_menu: '送信ブラウザ',
        schedule_export_label: 'エクスポートのスケジュール設定',
        purge_button_text: 'パージ',
        ingest_to_mam_tooltip: '選択したアイテムを MAM に取り込む',
        ingest_to_mam_all_tooltip: 'すべてのアイテムを MAM に取り込む',
        ingest_to_mam_all_text: 'すべてを摂取する',
        please_select_ott_platform_error_message: 'OTT プラットフォームを選択してください',
        offer_status_label: 'オファーステータス',
        add_offers_dialog_header: 'オファーを追加',
        has_versions_label: "バージョンあり",
        has_mam_assets_label: "ママの資産がある",
        has_offers_label: "オファーあり",
        has_transmissions_label: "トランスミッションあり",
        contract_title_column: '契約タイトル',
        offer_status_column: 'オファーステータス',
        offer_title_column: 'オファータイトル',
        price_code_column: '価格コード',
        please_selest_transmission_type_error_message: '伝送タイプを選択してください',
        offers_dialog_header: 'オファー',
        offer_delete_confirmation_message: "このオファーはすでに送信中です。このオファーを削除しますか?",
        select_channel_groups_label: 'チャネルグループの選択',
        season_episode_identifier_setting_menu: 'シーズンエピソード識別子の設定',
        duplicate_transmission_error_message: "同じ VOD チャンネルでの送信がすでに存在します。",
        epg_export_status: "EPG エクスポート ステータス",
        filename_label: "ファイル名",
        filename_not_found_error_message: "ファイル名が見つかりません",
        unable_to_download_all_files_error_message: "すべてのファイルをダウンロードできません",
        channel_groups_label: "チャネルグループ",
        download_label: "ダウンロード",
        fixed_value: "固定値",
        is_fixed_value_column: "固定値です",
        fixed_value_column: "固定値",
        select_season_label: "季節を選択してください",
        season_attached_success_message: "シーズンが正常に接続されました",
        unable_to_attach_season_error_message: "シーズンを添付できません",
        please_select_vod_type_error_message: "VOD タイプを選択してください",
        scte_break_duration_label: "SCTE ブレイク期間(分単位)",
        auto_segment_rule_sub_menu: '自動セグメントルール',
        auto_segment_rule_page_breadcrumb: '自動セグメントルール',
        auto_segment_rule_dialog_header: '自動セグメントルール',
        segment_details_label: 'セグメントの詳細',
        segment_details_total_should_not_be_greater_than_100_percentage: "セグメント詳細の合計は 100% を超えてはいけません",
        segment_details_should_be_equal_to_segment_count: 'セグメントの詳細はセグメント数と同じである必要があります',
        import_mam_asset_success_message: "MAM アセットが正常にインポートされました",
        download_mam_asset_template_label: "MAM アセット テンプレートをダウンロード",
        import_mam_asset_from_excel_label: "MAM アセットを Excel からインポート",
        please_select_company_type_error_message: "会社タイプを選択してください",
        please_select_at_least_one_instance_error_message: "少なくとも 1 つのインスタンスを選択してください",
        please_select_time_zone_error_message: "タイムゾーンを選択してください",
        instances_label: "インスタンス",
        select_instance_label: "インスタンスの選択",
        please_select_instance_error_message: "インスタンスを選択してください",
        total_booked_amount_label: "予約総額",
        missing_spots_amount_label: "欠損点の量",
        billed_amount_label: "請求金額",
        payment_recieved_label: "支払いを受け取りました",
        agency_wise_revenue_label: "代理店の賢い収益",
        client_wise_revenue_label: "クライアントの収益",
        recent_invoices_label: "最近の請求書",
        pending_invoices_label: "保留中の請求書",
        export_and_mail_saved_booking_label: 'Export & Mail Saved Booking',
        send_booking_to_email_label: '予約をメールに送信',
        agency_email_label: '代理店のメールアドレス',
        client_email_label: 'クライアントの電子メール',
        booking_mailed_success_message: "予約は正常に郵送されました",
        target_groups_page_breadcrumb: '対象グループ',
        target_groups_sub_menu: '対象グループ',
        minimum_age_label: '最低年齢',
        maximum_age_label: '最大年齢',
        minimum_age_should_be_greater_than_zero_error_message: '最小年齢はゼロより大きくなければなりません',
        maximum_age_should_be_greater_than_zero_error_message: '最大年齢はゼロより大きくなければなりません',
        target_group_label: '対象グループ',
        email_sub_menu: '電子メール',
        email_page_breadcrumb: '電子メール',
        email_configuration_menu: '電子メール設定',
        authentication_label: "認証",
        service_label: "サービス",
        app_pass_label: "アプリパス",
        tenant_id_label: "テナントID",
        client_id_label: "クライアントID",
        client_secret_value_label: "クライアントシークレット値",
        refresh_token_label: "リフレッシュトークン",
        access_token_label: "アクセストークン",
        enter_email_error_message: "メールアドレスを入力してください",
        please_select_authentication_error_message: "認証を選択してください",
        please_enter_app_pass_error_message: "アプリパスを入力してください",
        please_enter_tenant_id_error_message: "テナントIDを入力してください",
        please_enter_client_id_error_message: "クライアントIDを入力してください",
        please_enter_refresh_token_error_message: "リフレッシュトークンを入力してください",
        please_enter_client_secret_error_message: "クライアントシークレットを入力してください",
        brand_product_report_sub_menu: 'ブランド製品レポート',
        brand_product_report_header: 'ブランド製品レポート',
        telecast_date_column: 'テレビ放送日',
        telecast_day_column: 'テレビ放送の日',
        sales_unit_column: '販売単位',
        aired_time_column: '放送時間',
        episode_code_column: 'エピソードコード',
        campaign_id_column: 'キャンペーンID',
        agency_gst_column: '代理店消費税',
        client_gst_column: 'クライアントの消費税',
        agency_pos_column: '代理店POS',
        client_pos_column: 'クライアントPOS',
        commercial_id_column: '商用ID',
        campaign_report_sub_menu: 'キャンペーンレポート',
        campaign_report_header: 'キャンペーンレポート',
        booked_fct_column: '予約済みの FCT',
        booked_spots_column: '予約済みスポット',
        total_spots_column: '総スポット数',
        booked_budget_column: '予約済みの予算',
        total_budget_column: '総予算',
        email_template_menu_breadcrumb: 'メールテンプレート',
        email_template_sub_menu: 'メールテンプレート',
        sender_label: "送信者",
        cc_label: "CC",
        bcc_label: "BCC",
        subject_label: "件名",
        deleted_success_message: "正常に削除されました",
        error_deleting_file_message: "ファイル削除エラー",
        error_downloading_file_message: 'ファイルのダウンロード中にエラーが発生しました',
        please_enter_subject_error_message: "件名を入力してください",
        please_enter_body_error_message: "本文を入力してください",
        please_select_sender_error_message: "送信者を選択してください",
        template_saved_successfully_message: "テンプレートが正常に保存されました",
        error_saving_template_message: "テンプレートの保存中にエラーが発生しました",
        file_already_attached_error_message: "ファイルはすでに添付されています",
        unable_to_delete_file_error_message: "ファイルを削除できません",
        unable_to_upload_file_error_message: "ファイルをアップロードできません",
        email_sent_success_message: "メールが正常に送信されました",
        please_select_email_template_error_message: "メールテンプレートを選択してください",
        please_enter_to_error_message: "に入力してください",
        file_not_found_label: "ファイルが見つかりません",
        downloading_template_error_message: "テンプレートをダウンロードできません",
        choose_file_label: "ファイルを選択",
        please_select_a_file_label: "ファイルを選択してください",
        export_label: "Export",
        update_label: "アップデート",
        epg_report_success_message: "EPG レポートが正常に生成されました",
        epg_import_Configuration_label: 'EPG インポート設定',
        file_type_label: 'ファイルの種類',
        header_index_label: 'ヘッダーインデックス',
        data_index_label: 'データインデックス',
        auto_epg_import_enabled_label: '自動 EPG インポートが有効になっています',
        input_dir_label: '入力ディレクトリ',
        identifier_label: '識別子',
        output_dir_label: '出力ディレクトリ',
        create_Channel_Dir_label: 'チャンネルディレクトリの作成',
        sent_to_wf_label: 'WF に送信',
        please_select_atleast_one_prototype_error_message: "少なくとも 1 つのプロトタイプを選択してください",
        channel_epg_mapping_config_sub_menu: 'チャンネル EPG マッピング構成',
        channel_epg_mapping_config_menu_breadcrumb: 'チャンネル EPG マッピング構成',
        channel_epg_mapping_config_dialog_header: 'チャンネル EPG マッピング構成',
        form_field_label: 'フォームフィールド',
        import_field_label: 'インポートフィールド',
        fixed_value_label: '固定値',
        find_label: '探す',
        replace_value_label: '値を置換',
        replace_dialog_header: '交換する',
        find_column: '探す',
        replace_value_column: '値を置換',
        epg_import_type_label: 'EPG インポート タイプ',
        please_enter_find_error_message: '入力してください 検索',
        epg_import_field_type_label: 'EPGインポートフィールドタイプ',
        template_module_label: 'テンプレートモジュール',
        field_validation_menu: 'フィールドの検証',
        field_validation_menu_breadcrumb: 'フィールドの検証',
        field_validation_dialog_header: 'フィールドの検証',
        validation_level_label: '検証レベル',
        validation_type_label: '検証タイプ',
        please_select_validation_level_error_message: '検証レベルを選択してください',
        please_select_form_field_error_message: 'フォームフィールドを選択してください',
        add_validation_dialog_header: '検証の追加',
        data_type_label: 'データ型',
        error_message_column: 'エラーメッセージ',
        regex_pattern_label: '正規表現パターン',
        fields_label: 'フィールド',
        error_message_label: 'エラーメッセージ',
        number_label: '番号',
        boolean_label: 'ブール値',
        any_label: 'どれでも',
        pattern_label: 'パターン',
        date_type_label: '日付の種類',
        allowed_values_label: '許可される値',
        please_select_validation_type_error_message: '検証タイプを選択してください',
        please_select_data_type_error_message: 'データタイプを選択してください',
        please_select_entityname_error_message: 'エンティティ名を選択してください',
        please_enter_error_message: 'エラーメッセージを入力してください',
        add_validation_type_label: '検証タイプの追加',
        done_label: '完了',
        please_add_atleast_one_validation_type_error_message: '少なくとも 1 つの検証タイプを追加してください',
        please_enter_pattern_error_message: 'パターンを入力してください',
        please_enter_allowed_values_error_message: '許可される値を入力してください',
        please_enter_fields_error_message: 'フィールドを入力してください',
        show_segment_details_full_screen_button_tooltip: 'セグメントの詳細を全画面で表示する',
        no_validation_type_message: '検証タイプなし',
        add_type_message: 'タイプメッセージの追加',
        image_dir_label: '画像ディレクトリ',
        download_image_label: '画像をダウンロード',
        chinese_title_label: '中国語タイトル',
        spanish_title_label: 'スペイン語のタイトル',
        schedule_music_qsheet__menu: '音楽スケジュール Qシート',
        schedule_music_qsheet_export_page_breadcrumb: '音楽スケジュール Qシート',
        sheet_index_label: 'シートインデックス',
        box_channel_number_label: "ボックスチャンネルNo.",
        please_select_entity_name_error_message: "エンティティ名を選択してください",
        epg_import_label: "EPG インポート",
        epg_publish_label: 'EPG の発行',
        report_type_config_column: 'レポートタイプ構成',
        publishing_days_column: '出版日',
        report_type_config_label: 'レポートタイプ構成',
        publishing_days_label: '出版日',
        extension_label: '延長',
        working_title_label: '仮タイトル',
        content_platform_label: 'コンテンツプラットフォーム',
        cable_vod_label: 'ケーブルVOD',
        iptv_vod_label: 'IPTV VOD',
        internet_vod_label: 'インターネットVOD',
        ott_vod_label: 'OTT VOD',
        ssai_vod_label: 'SSAI VOD',
        download_video_label: 'ビデオをダウンロードする',
        image_url1_label: '画像URL1',
        image_url2_label: '画像URL2',
        origin_countries_label: '原産国',
        validity_start_label: '有効期間の開始',
        validity_end_label: '有効期限終了',
        premier_start_date_label: 'プレミア開始日',
        premier_start_time_label: 'プレミア開始時間',
        premier_end_date_label: 'プレミア終了日',
        premier_end_time_label: 'プレミア終了時間',
        thumbnail_required_label: 'サムネイルは必須です',
        game_id_label: 'ゲームID',
        home_team_label: 'ホームチーム',
        away_team_label: 'アウェイチーム',
        new_title_label: '新しいタイトル',
        audio_language1_label: '音声言語 1',
        audio_language2_label: '音声言語 2',
        subtitle_embedded_label: '字幕の埋め込み',
        closed_caption_file_format_label: 'クローズドキャプションファイル形式',
        subtitle_file_name_label: '字幕ファイル名',
        subtitle_languages_label: '字幕言語',
        audio_mode_label: 'オーディオモード',
        censorship_label: '検閲',
        folder_name_label: 'フォルダ名',
        episode_number_for_press_label: 'プレス向けエピソード番号',
        total_episodes_label: '総エピソード数',
        deal_reference_label: 'ディールリファレンス',
        relative_start_date_label: '相対開始日',
        relative_start_date_column: '相対開始日',
        program_language_id_label: 'プログラム言語ID',
        etv_display_label: 'ETVディスプレイ',
        is_start_over_label: 'やり直しです',
        short_display_title_label: '短い表示タイトル',
        short_display_title_chinese_label: '短い表示タイトル (中国語)',
        chinese_synopsis_label: '中国語のあらすじ',
        edit_all_button_tooltip: 'すべて編集',
        add_field_button_tooltip: 'フィールドの追加',
        prototype_already_exists_error_message: '同じIDのプロトタイプがすでに存在します。',
        do_still_want_to_create_message: 'まだ作成しますか?',
        create_and_attach_offers_button_tooltip: 'オファーの作成と添付',
        translated_description_label: '翻訳された説明',
        info_bar_rating_label: '情報バーの評価',
        mapping_label: 'マッピング',
        mapping_on_bxf_file_label: 'Bxf ファイルのマッピング',
        genre_subgenre_mapping_menu_breadcrumb: 'ジャンルのサブジャンルのマッピング',
        genre_subgenre_mapping_sub_menu: 'ジャンルのサブジャンルのマッピング',
        genre_subgenre_mapping_dialog_header: 'ジャンルのサブジャンルのマッピング',
        dvb_content_label: 'DVB コンテンツ',
        please_enter_dvb_content_error_message: 'DVB コンテンツを入力してください',
        edit_action_button_tooltip: 'アクションの編集',
        sync_mam_asset_with_S3_label: "MAM アセットを S3 と同期する",
        valid_file_extensions_label: "有効なファイル拡張子",
        itxml_parser_sub_menu: 'ITXML パーサー',
        itxml_parser_dialog_header: 'ITXML パーサー',
        default_value_label: 'デフォルト値',
        cue_tone_in_label: "キュートーンイン",
        cue_tone_out_label: "キュートーンアウト",
        delete_selected_menutext: '削除',
        delete_selected_in_whole_menutext: 'すべて削除',
        please_select_production_year_error_message: '製造年を選択してください',
        not_linked_label: "リンクされていません",
        version_browser_page_breadcrumb: 'バージョンブラウザ',
        transmissions_label: 'トランスミッション',
        price_code_details_label: '価格コードの詳細',
        create_price_code_button_tooltip: '価格コードの作成',
        create_node_button_tooltip: 'ノードの作成',
        edit_node_button_tooltip: 'ノードの編集',
        transmission_browser_header: '送信ブラウザ',
        update_node__button_tooltip: 'ノードの更新',
        auto_create_nodes_label: 'ノードの自動作成',
        frame_duration_label: 'フレーム持続時間',
        languages_label: '言語',
        dubbed_languages_label: '吹き替え言語',
        channel_version_id_label: 'チャンネルバージョンID',
        l2v_channel_mapping_page_breadcrumb: 'L2V チャネル マッピング',
        l2v_channel_mapping_dialog_header: 'L2V チャネル マッピング',
        please_enter_channel_number_error_message: 'チャンネル番号を入力してください',
        no_scheduling_found_to_resync_segments_error_message: "セグメントを再同期するためのスケジュールが見つかりません",
        show_attached_media_dialog_header: '添付されたメディアを表示',
        chinese_cast_label: '中国人キャスト',
        client_type_label: 'クライアントの種類',
        address_code_label: '住所コード',
        advertiser_label: '広告主',
        channel_header: 'チャンネル',
        transmission_id_prefix_label: '送信IDプレフィックス',
        channel_number_column: 'チャンネル番号',
        transmission_id_prefix_column: '送信IDプレフィックス',
        insert_cuetone_label: 'キュートーンの挿入',
        insert_scte_label: 'SCTE マーカーの挿入',
        delete_cuetone_label: 'キュートーンの削除',
        delete_scte_label: 'SCTE マーカーの削除',
        please_select_only_2_items_to_insert_cuetone_error_message: "キュートーンを挿入するには、もう 1 つの項目を選択してください",
        cuetone_inserted_successfully_message: "キュートンが正常に追加されました",
        scte_inserted_successfully_message: "SCTE マーカーが正常に追加されました",
        some_selected_items_already_have_cuetone_error_message: "選択した項目の中には、すでにキュートーンが設定されているものもあります。キュートーンのない項目を選択してください。",
        cuetone_deleted_successfully_message: "Cuetone は正常に削除されました",
        scte_deleted_successfully_message: "SCTE マーカーは正常に削除されました",
        ref_export_segment_label: "セグメントをエクスポートします。",
        planning_browser_sub_menu: 'プランニングブラウザ',
        planning_browser_header: 'プランニングブラウザ',
        event_type_label: 'イベントの種類',
        episode_title_column: 'エピソードのタイトル',
        catchup_up_column: 'キャッチアップアップ',
        black_out_column: 'ブラックアウト',
        status_text_label: 'ステータステキスト',
        segment_extension_header: 'セグメントの拡張',
        add_extension_tooltip: '拡張機能の追加',
        time_shift_configuration_label: 'タイムシフト設定',
        Start_trigger_type_label: '開始トリガーの種類',
        copy_slot_prototype_sub_menu: 'スロットのプロトタイプをコピー',
        copy_slot_prototype_page_breadcrumb: 'スロットのプロトタイプをコピー',
        day_buffer_label: 'デイバッファ',
        slot_start_time: 'スロット開始時間 (hh:mm:ss:ff)',
        day_buffer_column: 'デイバッファ',
        slot_start_time_column: 'スロット開始時間',
        copy_slot_page_breadcrumb: 'コピースロット',
        copy_slot_dialog_header: 'コピースロット',
        copy_slot_prototype_label: 'スロットのプロトタイプをコピー',
        copy_slot_button_tooltip: 'コピースロット',
        content_custom_label: "カスタム",
        is_catch_up_label: "キャッチアップです",
        item_already_planned_error_message: "貼り付けできません: アイテムはこのスロットですでに計画されています。",
        add_slot_button_tooltip: 'スロットの追加',
        copy_slot_success_message: "スロットが正常にコピーされました",
        create_copy_slot_prototype_label: 'コピースロットプロトタイプの作成',
        duplicate_daybuffer_slot_error_message: 'DayBuffer とスロットの重複は許可されません',
        please_fill_daybuffer_and_slot_error_message: 'DayBuffer と Slot を埋めてください',
        edit_copy_slot_prototype_label: 'コピースロットプロトタイプの編集',
        day_buffer_can_not_be_lass_than_one_error_message: '日バッファは 1 より小さくすることはできません',
        platforms_column: 'プラットフォーム',
        video_format_column: 'ビデオフォーマット',
        working_title_column: '仮タイトル',
        deal_reference_column: 'ディールリファレンス',
        advance_catchup_schedule_days_label: 'アドバンスキャッチアップスケジュール日数',
        trans_end_offset_type_label: 'トランスエンドオフセットタイプ',
        trans_end_offset_value_label: 'トランスエンドオフセット値',
        time_range_difference_error_message: '時間範囲の差を 6 時間以下にする必要があることを選択してください',
        please_select_copy_slot_prototype_error_message: 'スロット プロトタイプのコピーを選択してください',
        no_slots_found_to_copy_error_message: 'コピーするスロットが見つかりませんでした',
        l2v_time_shift_configuration_label: 'L2V タイムシフト構成',
        selected_period_label: '選択した期間',
        contract_type_label: '契約の種類',
        purchase_type_label: '購入タイプ',
        is_signed_label: '署名されています',
        contract_type_page_breadcrumb: '契約の種類',
        contract_type_sub_menu: '契約の種類',
        campaign_category_page_breadcrumb: 'キャンペーンカテゴリー',
        campaign_category_sub_menu: 'キャンペーンカテゴリー',
        campaign_category_header: 'キャンペーンカテゴリー',
        campaign_category_label: 'キャンペーンカテゴリー',
        please_select_campaign_category_error_message: 'キャンペーンカテゴリを選択してください',
        planning_export_label: '輸出の計画',
        export_break_pattern_button_text: 'Export Break Pattern',
        export_pdf_button_text: 'Export PDF',
        mismatch_in_selected_time_range_and_slots_time_range_error_message: "選択した時間範囲と開始時間のスロットが一致しません",
        chinese_episode_title_column: '中国語のエピソードのタイトル',
        please_select_country_error_message: '国を選択してください',
        slot_start_time_is_less_than_day_buffer_error_message: `選択したコピー プロトタイプの同日の「To Time」は、選択したコピー スロットの「To Time」より大きくなければなりません`,
        please_add_atleast_one_slot_error_message: '少なくとも 1 つのスロットを追加してください',
        please_complete_save_changes_error_message: "編集変更を保存してください",
        custom_episode_title_1_label: 'カスタム エピソード タイトル 1',
        custom_episode_title_2_label: 'カスタムエピソードタイトル2',
        chinese_episode_title_label: '中国語のエピソードのタイトル',
        spanish_episode_title_label: 'スペイン語のエピソードのタイトル',
        custom_description_label: 'カスタムの説明',
        short_title_label: '短いタイトル',
        custom_short_title_label: 'カスタムの短いタイトル',
        studio_label: 'スタジオ',
        rental_duration_label: 'レンタル期間 (日)',
        time_unit_label: '時間単位',
        publish_to_vod_actionbutton_menutext: 'VOD に公開する',
        create_offers_label: 'オファーの作成',
        attach_offers_label: 'オファーを添付する',
        segment_detail_type_column: 'タイプ',
        delete_start_end_credits_label: 'クレジットの削除',
        delete_start_credits_label: 'スタートクレジット',
        delete_end_credits_label: 'エンドクレジット',
        delete_both_credits_label: '両方のクレジット',
        premier_start_date_column: 'プレミア開始日',
        premier_end_date_column: 'プレミア終了日',
        sync_metadata_to_episodes_label: "メタデータをエピソードに同期する",
        sync_metadata_to_episodes_confirmation_message: "This will override metadata for all episodes under this season.続けますか?",
        number_of_exhibition_available_tooltip_message: '展示可能数。',
        number_of_repeat_telecast_available_tooltip_message: '利用可能なリピートテレビキャストの数。',
        playtime_tooltip_message: 'Duration Period type for schedule validity (e.g. Day / Week).',
        playtime_number_tooltip_message: 'Number of times the content can be scheduled within the selected PlayTime period.',
        language2_label: '言語 2',
        secondary_copy_label: '二次コピー',
        language1_length_error_message: 'Language 1 length cannot be greater than 3 characters',
        language2_length_error_message: 'Language 2 length cannot be greater than 3 characters',
        custom_slot_duration: "カスタムスロット期間",
        please_enter_custom_duration_error_message: "有効なカスタム期間を入力してください",
        please_enter_custom_duration_min_time_error_message: "Custom Duration should be greater than equal to 5 minutes",
        please_select_version_type_error_message: "バージョンの種類を選択してください",
        auto_delete_start_end_credits_label: "開始クレジットと終了クレジットを自動削除",
        delete_start_end_credits_note_message: "Note: This will automatically delete start and end credits while applying recursive",
        program_group_episode_range_disable_note_message: "Note: If Program Group is selected Episode Range should be disabled",
        platform_groups_page_breadcrumb: 'プラットフォームグループ',
        platform_groups_sub_menu: 'プラットフォームグループ',
        platform_groups_header: 'プラットフォームグループ',
        platform_groups_label: 'プラットフォームグループ',
        select_platform_groups_collection_header: 'プラットフォームグループの選択',
        select_program_groups_tooltip: 'プログラムグループの選択',
        platforms_label: 'プラットフォーム',
        please_select_linear_channels_error_message: 'リニアチャンネルを選択してください',
        linear_channels_label: 'リニアチャネル',
        non_linear_platforms_label: '非線形プラットフォーム',
        expected_date_label: '予定日',
        promotion_report_menu: 'プロモーションレポート',
        promotion_report_header: 'プロモーションレポート',
        please_select_linear_start_date_error_message: 'リニア開始日を選択してください',
        please_select_non_linear_start_date_error_message: '非直線的な開始日を選択してください',
        please_select_linear_end_date_error_message: '直線的な終了日を選択してください',
        please_select_non_linear_end_date_error_message: '非直線的な終了日を選択してください',
        linear_start_and_end_date_error_message: '直線的な開始日は終了日よりも前の日付である必要があります',
        non_linear_start_and_end_date_error_message: 'Non Linear start date should be less than end date',
        thumbnail_status_reset_success_message: "サムネイルのステータスが正常にリセットされました",
        reset_thumbnail_status_label: 'サムネイルのステータスをリセット',
        you_are_not_authorized_to_attach_contract_please_go_to_parent_series_error_message: '契約書を添付する権限がありません。親シリーズに移動してください',
        you_are_not_authorized_to_attach_contract_please_go_to_series_error_message: '契約書を添付する権限がありません。シリーズへどうぞ',
        you_are_not_authorized_to_attach_contract_please_go_to_contract_error_message: '契約書を添付する権限がありません。契約まで行ってください',
        successfully_attached_success_message: '正常に接続されました',
        exclusive_start_date_label: '独占開始日',
        exclusive_end_date_label: '独占終了日',
        ref_attach_media_label: 'メディアを添付する',
        attach_label: '添付する',
        delete_label: '削除',
        please_enter_valid_custom_duration_recusive_error_message: '有効な期間をカンマ区切り形式で分単位で入力してください。',
        enter_comma_separated_durations_error_message: '例: 各番号に対して 5、10、15 (分) epsの',
        number_of_episode_not_eqaul_error_message: 'エピソードの数は、入力した期間の数以下である必要があります',
        duration_format_note: "( hh:mm:ss:ff ) 形式で入力します。",
        image_url1_landscape_label: '画像URL 1 (横)',
        image_url2_portrait_label: '画像URL2（縦）',
        time_restriction_label: '時間制限',
        to_should_be_grater_than_from_error_message: 'To は From より大きい必要があります',
        please_enter_to_error_message: '宛先を入力してください',
        please_enter_from_error_message: 'から入力してください',
        cannot_paste_due_to_time_restriction_error_message: "時間制限により、選択したスロットでは一部のアイテムが無効になります。",
        program_last_airing_report_header: '番組最終放送レポート',
        schedule_date_column: '予定日',
        program_last_airing_sub_menu: '番組最終放送レポート',
        enable_auto_epg_export_label: '自動 EPG エクスポートを有効にする',
        channel_start_date_label: 'チャンネル開始日',
        dev_logs_label: '開発ログ',
        media_actual_duration_sub_menu: 'メディアの実際の再生時間レポート',
        media_actual_duration_report_header: 'メディアの実際の再生時間レポート',
        program_title_column: '番組タイトル',
        program_episode_season_column: 'プログラムエピソードシーズン',
        program_episode_number_column: '番組エピソード番号',
        segment_number_column: 'セグメント番号',
        delete_channel_button_tooltip: 'チャンネルの削除',
        is_hard_parted_has_been_changed_please_generated_segments_again_error_message: 'Is Hard Parted が変更されました。保存する前にセグメントを再度生成してください。',
        secondary_event_label: '二次イベント',
        scte_exc_media_category_type_label: 'SCTE除くメディア カテゴリ タイプ',
        sync_label: '同期',
        applying_program_group_status_message: 'プログラム グループを申請中です。お待ちください...',
        blackout_column: '停電',
        show_blackout_tooltip: 'ブラックアウトを表示',
        clash_genre_label: 'クラッシュジャンル',
        producer_label: 'プロデューサー',
        promos_trailers_label: 'プロモーション/トレーラー',
        default_genre_label: 'デフォルトのジャンル',
        please_select__clash_genre_error_message: 'クラッシュジャンルを選択してください',
        import_export_module_wise_count_label: 'インポート/エクスポートモジュールのワイズカウント',
        show_import_export_module_wise_full_screen_button_tooltip: 'インポート/エクスポートモジュールを全画面で表示',
        edit_slot_metadata_label:"スロットメタデータの編集",
        subgenre_label:"サブジャンル",
        slot_metadata_updated_successfully:"スロットのメタデータが正常に更新されました",
        failed_to_load_slot_metadata_error_message:"スロットのメタデータのロードに失敗しました",
        please_select_avail_suppression_fill_policy_error_message:"Avail Suppression Fill ポリシーを選択してください",
        please_select_ad_insertion_mode_error_message :"広告挿入モードを選択してください",
        please_select_avail_suppression_mode_error_message :"アベイル抑制モードを選択してください",
        please_enter_avail_suppression_value_error_message :"アベイル抑制値を入力してください",
        default_audioTrack_label: 'デフォルトのオーディオトラック',
        default_programme_language_id_label: 'デフォルトのプログラム言語 ID',
        fix_follow_label: "修正/フォロー",
        info_message_title: "情報",
        success_message_title: "成功",
        invalid_error_message_title: "無効",
        warning_message_title: "警告",
        loading_label: "読み込み中",
        failed_to_generate_data_error_message: "データの生成に失敗しました。",
        ready_to_generate_data_label: "データを生成する準備ができました",
        boss_ai_gernerate_data_message: "タイトルを入力し、必要に応じて言語を選択して、「表示」ボタンをクリックし、Boss AIを使用してデータを生成します。",
        apply_filter_button: "フィルターを適用",
        transmissions_header: "送信",
        dai_ad_insertions_menu: "動的広告挿入",
        utility_menu: "ユーティリティ",
        linear_deal_rights_label: "リニア取引権",
        non_linear_deal_rights_label: "非リニア取引権",
        timing_and_classification_section_header: "タイミングと分類",
        content_and_identification_section_header: "コンテンツと識別",
        title_and_description_section_header: "タイトルと説明",
        confirm_button: "確認",
        confirm_button_tooltip: "確認",
        genre_categorization_and_metadata_section_header: "ジャンルの分類とメタデータ",
        images_label: "画像",
        sports_label: "スポーツ",
        audio_and_video_label: "オーディオとビデオ",
        deep_archive_menu: "ディープアーカイブ",
        planning_export_dialog_header: "エクスポート",
        start_label: "開始",
        hide_next_day_show_continuation_label: "翌日の番組継続を非表示",
        show_title_only_label: "タイトルのみ表示",
        month_export_label: "月次エクスポート",
        export_break_pattern_button: "休憩パターンをエクスポート",
        export_pdf_button: "PDFをエクスポート",
        media_content_header: "メディアコンテンツ",
        content_category_header: "コンテンツカテゴリ",
        segment_and_mam_label: "セグメント/MAM",
        next_day_label: "翌日",
        audience_label: "視聴者",
        ad_label: "広告",
        create_ad_header: "广告を作成",
        select_ad_label: "広告を選択",
        sunday_short_text: "日",
        monday_short_text: "月",
        tuesday_short_text: "火",
        wednesday_short_text: "水",
        thursday_short_text: "木",
        friday_short_text: "金",
        saturday_short_text: "土",
        create_planning_slot_header: "計画スロットを作成",
        series_library_header: "シリーズライブラリ",
        media_versions_header: "メディアバージョン",
        auto_id_label: "自動ID",
        selected_items_label: "選択された項目",
        total_duration_label: "合計時間",
        total_bookings_label: "総予約数",
        filter_bookings_label: "予約を絞り込む",
        make_good_menu_label: "メイクグッド",
        purge_menu_label: "パージ",
        open_campaign_menu_label: "キャンペーンを開く",
        go_to_schedule_button: "スケジュールへ",
        cpld_label: "CPLD",
        expd_label: "EXPD",
        previous_day_end_time_label: "前日の終了時間",
        schedule_header: "スケジュール",
        file_menu_label: "ファイル",
        new_schedule_menu_label: "新しいスケジュール",
        open_draft_menu_label: "下書きを開く",
        save_as_draft_menu_label: "下書きとして保存",
        unlock_schedule_menu_label: "スケジュールのロックを解除",
        lock_schedule_menu_label: "スケジュールをロック",
        open_planning_menu_label: "計画を開く",
        show_logs_menu_label: "ログを表示",
        export_menu_label: "エクスポート",
        export_playlist_menu_label: "プレイリストをエクスポート",
        export_partial_playlist_menu_label: "一部のプレイリストをエクスポート",
        export_sftp_playlist_menu_label: "SFTPプレイリストをエクスポート",
        download_pdf_menu_label: "PDFをダウンロード",
        export_excel_menu_label: "Excelをエクスポート",
        export_itxml_menu_label: "ITXMLをエクスポート",
        export_announcement_menu_label: "アナウンスをエクスポート",
        export_imagine_playlist_menu_label: "Imagineプレイリストをエクスポート",
        export_epg_menu_label: "EPGをエクスポート",
        export_ross_playlist_menu_label: "ROSSプレイリストをエクスポート",
        export_jazler_commercial_menu_label: "Jazlerコマーシャルをエクスポート",
        push_playlist_menu_label: "プレイリストをプッシュ",
        export_and_deliver_playlist_menu_label: "プレイリストをエクスポートして配信",
        edit_menu_label: "編集",
        cut_menu_label: "切り取り",
        copy_menu_label: "コピー",
        paste_menu_label: "貼り付け",
        delete_menu_label: "削除",
        insert_break_menu_label: "休憩を挿入",
        find_and_replace_menu_label: "検索と置換",
        insert_live_event_menu_label: "ライブイベントを挿入",
        revert_virtual_segment_menu_label: "仮想セグメントを元に戻す",
        delete_all_footer_menu_label: "すべてのフッターを削除",
        match_prev_day_end_time_menu_label: "前日の終了時間と一致させる",
        view_menu_label: "表示",
        go_to_menu_label: "移動",
        refresh_schedule_menu_label: "スケジュールを更新",
        show_breaks_only_menu_label: "休憩のみ表示",
        expand_menu_label: "展開",
        collapse_menu_label: "折りたたむ",
        secondary_events_menu_label: "二次イベント",
        delete_all_menu_label: "すべて削除",
        delete_selected_menu_label: "選択項目を削除",
        se_overview_menu_label: "SE概要",
        apply_style_sheet_menu_label: "スタイルシートを適用",
        run_menu_label: "実行",
        auto_fill_short_forms_menu_label: "ショートフォームを自動入力",
        auto_fill_booked_spots_menu_label: "予約済みスポットを自動入力",
        execute_promo_campaigns_menu_label: "プロモーションキャンペーンを実行",
        fill_playlist_menu_label: "プレイリストを入力",
        auto_fill_music_menu_label: "音楽を自動入力",
        create_fast_playlist_menu_label: "高速プレイリストを作成",
        cue_tones_menu_label: "キュートーン",
        scte_markers_menu_label: "SCTEマーカー",
        reset_auto_fill_menu_label: "自動入力をリセット",
        reset_schedule_menu_label: "スケジュールをリセット",
        sync_all_headers_segment_menu_label: "すべてのヘッダーのセグメントを同期",
        reset_header_to_nominal_menu_label: "ヘッダーを公称値にリセット",
        create_automatic_breaks_menu_label: "自動休憩を作成",
        check_lists_menu_label: "チェックリスト",
        settings_menu_label: "設定",
        schedule_preference_menu_label: "スケジュール設定",
        column_preference_menu_label: "列の設定",
        checklist_preference_menu_label: "チェックリスト設定",
        exit_draft_mode_menu_label: "下書きモードを終了",
        restore_menu_label: "復元",
        select_itxml_file_label: "ITXMLファイルを選択",
        file_ready_label: "ファイル准备完了",
        create_storage_provider_header: "ストレージプロバイダを作成",
        transaction_id_column: "トランザクションID",
        action_type_column: "アクションタイプ",
        request_column: "リクエスト",
        response_column: "レスポンス",
        response_header: "レスポンス",
        campaign_status_label: "キャンペーン状況",
        create_product_header: "商品を作成",
        create_target_group_header: "ターゲットグループを作成",
        social_media_channel_type_header: "ソーシャルメディアチャンネルタイプ",
        meta_label: "Meta",
        google_label: "Google",
        linkedin_label: "LinkedIn",
        youtube_label: "YouTube",
        snapchat_label: "Snapchat",
        create_adset_label: "広告セットを作成",
        adsets_label: "広告セット",
        update_adset_label: "広告セットを更新",
        conversion_location_label: "コンバージョンの場所",
        choose_where_you_want_to_generate_leads_tooltip_message: "リードを獲得したい場所を選択してください。",
        learn_more: "詳細を見る",
        billing_event_label: "課金イベント",
        optimization_goal_label: "最適化の目標",
        application_id_label: "アプリケーションID",
        object_store_url_label: "オブジェクトストアURL",
        custom_event_type_label: "カスタムイベントタイプ",
        pixel_id_label: "ピクセルID",
        button_type_label: "ボタンタイプ",
        button_link_label: "ボタンリンク",
        billing_event_tooltip_message: "課金イベントは、広告配信プロセスのどの段階で課金されるかをMetaに伝えます。これは広告セットレベルで設定され、キャンペーンの目的によって異なります。",
        optimization_goal_tooltip_message: "最適化目標は、最も重要視する結果をMetaに伝えるもので、これによりそのアクションを起こす可能性が最も高いユーザーに広告を表示できます。リード：リード、コンバージョンリード、リンククリック。アプリインストール：アプリインストール、アプリアクション。売上/コンバージョン：コンバージョン、価値、購入。",
        page_not_found_tooltip_message: "ページが見つからない場合は、APIトークンが期限切れでないか確認してください。期限切れの場合は、Metaチャンネルを再認証してください。",
        enter_application_id_placeholder: "アプリケーションIDを入力",
        enter_object_store_url_placeholder: "オブジェクトストアURLを入力",
        enter_pixel_id_placeholder: "ピクセルIDを入力",
        enter_link_placeholder: "リンクを入力",
        enter_button_action_link_placeholder: "ボタンのアクションリンクを入力",
        enter_ad_description_message_placeholder: "広告の説明メッセージを入力",
        app_id_displayed_at_top_help_text: "アプリIDは上部に表示されます。",
        find_pixel_id_help_text: "イベントマネージャーのデータソースの上部でピクセルIDを見つけます。",
        facebook_feed_tab: "Facebookフィード",
        instagram_feed_tab: "Instagramフィード",
        instagram_story_tab: "Instagramストーリーズ",
        update_audience_header: "オーディエンスを更新",
        add_audience_header: "オーディエンスを追加",
        geo_locations_label: "地理的位置",
        interests_label: "興味",
        special_add_category_label: "特殊な広告カテゴリ",
        genders_label: "性別",
        scroll_together_label: "一緒にスクロール",
        manage_asrun_header: "Asrunの管理",
        add_subtitle_dialog_title: "字幕を追加",
        edit_subtitle_dialog_title: "字幕を編集",
        app_bar_label: "アプリバー",
        menu_label: "メニュー",
        rail_type_label: "レールタイプ",
        cta_label: "コールトゥアクション (CTA)",
        message_box_label: "メッセージボックス",
        background_label: "背景",
        icon_color_label: "アイコンの色",
        icon_selector_color_label: "アイコン選択の色",
        font_weight_label: "フォントの太さ",
        icon_size_label: "アイコンサイズ",
        focus_color_label: "フォーカスの色",
        focus_width_label: "フォーカスの幅",
        page_title_label: "ページタイトル",
        block_title_label: "ブロックタイトル",
        link_hover_label: "リンクのホバー",
        page_skeleton_label: "ページのスケルトン",
        box_shadow_label: "ボックスシャドウ",
        primary_label: "プライマリ",
        primary_hover_label: "プライマリのホバー",
        secondary_label: "セカンダリ",
        secondary_hover_label: "セカンダリのホバー",
        border_color_label: "枠線の色",
        border_width_label: "枠線の幅",
        box_label: "ボックス",
        button_label: "ボタン",
        show_logo_label: "ロゴを表示",
        source_1_label: "ソース 1",
        source_2_label: "ソース 2",
        create_price_code_dialog_title: "価格コードを作成",
        edit_offer_dialog_title: "オファーを編集",
        create_offer_dialog_title: "オファーを作成",
        create_bucket_configuration_dialog_title: "バケット構成を作成",
        create_bucket_dialog_title: "バケットを作成",
        enter_extensions_separated_by_comma_label: "拡張子をカンマ区切りで入力します（例: .jpg、.pngなど）。",
        deep_archive_header: "ディープアーカイブ",
        syncing_button_text: "同期中...",
        sync_button_text: "同期",
        media_overview_label: "メディアの概要",
        no_folder_data_available_use_sync_to_pull_data_placeholder: "フォルダデータがありません。同期してデータを取得してください。",
        loading_folders_label: "フォルダを読み込み中...",
        restore_from_deep_archive_label: "ディープアーカイブから復元",
        restoring_button_text: "復元中...",
        restore_button_text: "復元",
        create_email_configuration_dialog_header: "メール設定を作成",
        create_email_template_dialog_header: "メールテンプレートを作成",
        application_configuration_dialog_header: "アプリケーション構成",
        season_episode_identifier_settings_dialog_header: "シーズンエピソード識別子の設定",
        season_form_field_label: "シーズンフォームフィールド",
        season_identifier_label: "シーズン識別子",
        episode_form_field_label: "エピソードフォームフィールド",
        episode_identifier_label: "エピソード識別子",
        add_publish_setting_dialog_header: "公開設定を追加",
        publish_settings_page_breadcrumb: "公開設定",
        make_sure_to_logout_and_login_again_to_see_the_changes_message: "変更を反映するには、必ずログアウトして再度ログインしてください。",
        create_catalogue_dialog_header: "カタログを作成"
    }
};